var _rect, _pattern, _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient0, _linearGradient1, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _linearGradient21, _linearGradient22, _linearGradient23, _linearGradient24, _linearGradient25, _linearGradient26, _linearGradient27, _linearGradient28, _linearGradient29, _linearGradient30, _linearGradient31, _linearGradient32, _linearGradient33, _linearGradient34, _linearGradient35, _linearGradient36, _linearGradient37, _linearGradient38, _linearGradient39, _linearGradient40, _linearGradient41, _linearGradient42, _linearGradient43, _linearGradient44, _linearGradient45, _linearGradient46, _linearGradient47, _linearGradient48, _linearGradient49, _linearGradient50, _linearGradient51, _linearGradient52, _linearGradient53, _linearGradient54, _linearGradient55, _linearGradient56, _linearGradient57, _linearGradient58, _linearGradient59, _linearGradient60, _linearGradient61, _linearGradient62, _linearGradient63, _linearGradient64, _linearGradient65, _linearGradient66, _linearGradient67, _linearGradient68, _linearGradient69, _linearGradient70, _linearGradient71, _linearGradient72, _linearGradient73, _linearGradient74, _linearGradient75, _linearGradient76, _linearGradient77, _linearGradient78, _linearGradient79, _linearGradient80, _linearGradient81, _linearGradient82, _linearGradient83, _linearGradient84, _linearGradient85, _linearGradient86, _linearGradient87, _linearGradient88, _linearGradient89, _linearGradient90, _image, _feComposite, _feColorMatrix, _feFlood, _feBlend, _feBlend2, _feColorMatrix2, _feComposite2, _feColorMatrix3, _feComposite3, _feColorMatrix4, _feFlood2, _feBlend3, _feBlend4, _feColorMatrix5, _feComposite4, _feColorMatrix6, _feColorMatrix7, _feComposite5, _feColorMatrix8, _feFlood3, _feBlend5, _feBlend6, _feColorMatrix9, _feComposite6, _feColorMatrix0, _feComposite7, _feColorMatrix1, _feFlood4, _feBlend7, _feBlend8, _feColorMatrix10, _feComposite8, _feColorMatrix11, _feColorMatrix12, _feComposite9, _feColorMatrix13, _feFlood5, _feBlend9, _feBlend0, _feColorMatrix14, _feComposite0, _feColorMatrix15, _feComposite1, _feColorMatrix16, _feFlood6, _feBlend1, _feBlend10, _feColorMatrix17, _feComposite10, _feColorMatrix18, _feColorMatrix19, _feComposite11, _feColorMatrix20, _feFlood7, _feBlend11, _feBlend12, _feColorMatrix21, _feComposite12, _feColorMatrix22, _feComposite13, _feColorMatrix23, _feFlood8, _feBlend13, _feBlend14, _feColorMatrix24, _feComposite14, _feColorMatrix25, _feColorMatrix26, _feComposite15, _feColorMatrix27, _feFlood9, _feBlend15, _feBlend16, _feColorMatrix28, _feComposite16, _feColorMatrix29, _feComposite17, _feColorMatrix30, _feFlood0, _feBlend17, _feBlend18, _feColorMatrix31, _feComposite18, _feColorMatrix32, _feColorMatrix33, _feComposite19, _feColorMatrix34, _feFlood1, _feBlend19, _feBlend20, _feColorMatrix35, _feComposite20, _feColorMatrix36, _feComposite21, _feColorMatrix37, _feFlood10, _feBlend21, _feBlend22, _feColorMatrix38, _feComposite22, _feColorMatrix39, _feColorMatrix40, _feComposite23, _feColorMatrix41, _feFlood11, _feBlend23, _feBlend24, _feColorMatrix42, _feComposite24, _feColorMatrix43, _feComposite25, _feColorMatrix44, _feFlood12, _feBlend25, _feBlend26, _feColorMatrix45, _feComposite26, _feColorMatrix46, _feColorMatrix47, _feComposite27, _feColorMatrix48, _feFlood13, _feBlend27, _feBlend28, _feColorMatrix49, _feComposite28, _feColorMatrix50, _feComposite29, _feColorMatrix51, _feFlood14, _feBlend29, _feBlend30, _feColorMatrix52, _feComposite30, _feColorMatrix53, _feColorMatrix54, _feComposite31, _feColorMatrix55, _feFlood15, _feBlend31, _feBlend32, _feColorMatrix56, _feComposite32, _feColorMatrix57, _feComposite33, _feColorMatrix58, _feFlood16, _feBlend33, _feBlend34, _feColorMatrix59, _feComposite34, _feColorMatrix60, _feColorMatrix61, _feComposite35, _feColorMatrix62, _feFlood17, _feBlend35, _feBlend36, _feColorMatrix63, _feComposite36, _feColorMatrix64, _feComposite37, _feColorMatrix65, _feFlood18, _feBlend37, _feBlend38, _feColorMatrix66, _feComposite38, _feColorMatrix67, _feColorMatrix68, _feComposite39, _feColorMatrix69, _feFlood19, _feBlend39, _feBlend40, _feColorMatrix70, _feComposite40, _feColorMatrix71, _feComposite41, _feColorMatrix72, _feFlood20, _feBlend41, _feBlend42, _feColorMatrix73, _feComposite42, _feColorMatrix74, _feColorMatrix75, _feComposite43, _feColorMatrix76, _feFlood21, _feBlend43, _feBlend44, _feColorMatrix77, _feComposite44, _feColorMatrix78, _feComposite45, _feColorMatrix79, _feFlood22, _feBlend45, _feBlend46, _feColorMatrix80, _feComposite46, _feColorMatrix81, _feColorMatrix82, _feComposite47, _feColorMatrix83, _feFlood23, _feBlend47, _feBlend48, _feColorMatrix84, _feComposite48, _feColorMatrix85, _feComposite49, _feColorMatrix86, _feFlood24, _feBlend49, _feBlend50, _feColorMatrix87, _feComposite50, _feColorMatrix88, _feColorMatrix89, _feComposite51, _feColorMatrix90, _feFlood25, _feBlend51, _feBlend52, _feColorMatrix91, _feComposite52, _feColorMatrix92, _feComposite53, _feColorMatrix93, _feFlood26, _feBlend53, _feBlend54, _feColorMatrix94, _feComposite54, _feColorMatrix95, _feColorMatrix96, _feComposite55, _feColorMatrix97, _feFlood27, _feBlend55, _feBlend56, _feColorMatrix98, _feComposite56, _feColorMatrix99, _feComposite57, _feColorMatrix100, _feFlood28, _feBlend57, _feBlend58, _feColorMatrix101, _feComposite58, _feColorMatrix102, _feColorMatrix103, _feComposite59, _feColorMatrix104, _feFlood29, _feBlend59, _feBlend60, _feColorMatrix105, _feComposite60, _feColorMatrix106, _feComposite61, _feColorMatrix107, _feFlood30, _feBlend61, _feBlend62, _feColorMatrix108, _feComposite62, _feColorMatrix109, _feColorMatrix110, _feComposite63, _feColorMatrix111, _feFlood31, _feBlend63, _feBlend64, _feColorMatrix112, _feComposite64, _feColorMatrix113, _feComposite65, _feColorMatrix114, _feFlood32, _feBlend65, _feBlend66, _feColorMatrix115, _feComposite66, _feColorMatrix116, _feColorMatrix117, _feComposite67, _feColorMatrix118, _feFlood33, _feBlend67, _feBlend68, _feColorMatrix119, _feComposite68, _feColorMatrix120, _feComposite69, _feColorMatrix121, _feFlood34, _feBlend69, _feBlend70, _feColorMatrix122, _feComposite70, _feColorMatrix123, _feColorMatrix124, _feComposite71, _feColorMatrix125, _feFlood35, _feBlend71, _feBlend72, _feColorMatrix126, _feComposite72, _feColorMatrix127, _feComposite73, _feColorMatrix128, _feFlood36, _feBlend73, _feBlend74, _feColorMatrix129, _feComposite74, _feColorMatrix130, _feColorMatrix131, _feComposite75, _feColorMatrix132, _feFlood37, _feBlend75, _feBlend76, _feColorMatrix133, _feComposite76, _feColorMatrix134, _feComposite77, _feColorMatrix135, _feFlood38, _feBlend77, _feBlend78, _feColorMatrix136, _feComposite78, _feColorMatrix137, _feColorMatrix138, _feComposite79, _feColorMatrix139, _feFlood39, _feBlend79, _feBlend80, _feColorMatrix140, _feComposite80, _feColorMatrix141, _feComposite81, _feColorMatrix142, _feFlood40, _feBlend81, _feBlend82, _feColorMatrix143, _feComposite82, _feColorMatrix144, _feColorMatrix145, _feComposite83, _feColorMatrix146, _feFlood41, _feBlend83, _feBlend84, _feColorMatrix147, _feComposite84, _feColorMatrix148, _feComposite85, _feColorMatrix149, _feFlood42, _feBlend85, _feBlend86, _feColorMatrix150, _feComposite86, _feColorMatrix151, _feColorMatrix152, _feComposite87, _feColorMatrix153, _feFlood43, _feBlend87, _feBlend88, _feColorMatrix154, _feComposite88, _feColorMatrix155, _feComposite89, _feColorMatrix156, _feFlood44, _feBlend89, _feBlend90, _feColorMatrix157, _feComposite90, _feColorMatrix158, _feColorMatrix159, _feComposite91, _feColorMatrix160, _feFlood45, _feBlend91, _feBlend92, _feColorMatrix161, _feComposite92, _feColorMatrix162, _feComposite93, _feColorMatrix163, _feFlood46, _feBlend93, _feBlend94, _feColorMatrix164, _feComposite94, _feColorMatrix165, _feColorMatrix166, _feComposite95, _feColorMatrix167, _feFlood47, _feBlend95, _feBlend96, _feColorMatrix168, _feComposite96, _feColorMatrix169, _feComposite97, _feColorMatrix170, _feFlood48, _feBlend97, _feBlend98, _feColorMatrix171, _feComposite98, _feColorMatrix172, _feColorMatrix173, _feComposite99, _feColorMatrix174, _feFlood49, _feBlend99, _feBlend100, _feColorMatrix175, _feComposite100, _feColorMatrix176, _feComposite101, _feColorMatrix177, _feFlood50, _feBlend101, _feBlend102, _feColorMatrix178, _feComposite102, _feColorMatrix179, _feColorMatrix180, _feComposite103, _feColorMatrix181, _feFlood51, _feBlend103, _feBlend104, _feColorMatrix182, _feComposite104, _feColorMatrix183, _feComposite105, _feColorMatrix184, _feFlood52, _feBlend105, _feBlend106, _feColorMatrix185, _feComposite106, _feColorMatrix186, _feColorMatrix187, _feComposite107, _feColorMatrix188, _feFlood53, _feBlend107, _feBlend108, _feColorMatrix189, _feComposite108, _feColorMatrix190, _feComposite109, _feColorMatrix191, _feFlood54, _feBlend109, _feBlend110, _feColorMatrix192, _feComposite110, _feColorMatrix193, _feColorMatrix194, _feComposite111, _feColorMatrix195, _feFlood55, _feBlend111, _feBlend112, _feColorMatrix196, _feComposite112, _feColorMatrix197, _feComposite113, _feColorMatrix198, _feFlood56, _feBlend113, _feBlend114, _feColorMatrix199, _feComposite114, _feColorMatrix200, _feColorMatrix201, _feComposite115, _feColorMatrix202, _feFlood57, _feBlend115, _feBlend116, _feColorMatrix203, _feComposite116, _feColorMatrix204, _feComposite117, _feColorMatrix205, _feFlood58, _feBlend117, _feBlend118, _feColorMatrix206, _feComposite118, _feColorMatrix207, _feColorMatrix208, _feComposite119, _feColorMatrix209, _feFlood59, _feBlend119, _feBlend120, _feColorMatrix210, _feComposite120, _feColorMatrix211, _feComposite121, _feColorMatrix212, _feFlood60, _feBlend121, _feBlend122, _feColorMatrix213, _feComposite122, _feColorMatrix214, _feColorMatrix215, _feComposite123, _feColorMatrix216, _feFlood61, _feBlend123, _feBlend124, _feColorMatrix217, _feComposite124, _feColorMatrix218, _feComposite125, _feColorMatrix219, _feFlood62, _feBlend125, _feBlend126, _feColorMatrix220, _feComposite126, _feColorMatrix221, _feColorMatrix222, _feComposite127, _feColorMatrix223, _feFlood63, _feBlend127, _feBlend128, _feColorMatrix224, _feComposite128, _feColorMatrix225, _feComposite129, _feColorMatrix226, _feFlood64, _feBlend129, _feBlend130, _feColorMatrix227, _feComposite130, _feColorMatrix228, _feColorMatrix229, _feComposite131, _feColorMatrix230, _feFlood65, _feBlend131, _feBlend132, _feColorMatrix231, _feComposite132, _feColorMatrix232, _feComposite133, _feColorMatrix233, _feFlood66, _feBlend133, _feBlend134, _feColorMatrix234, _feComposite134, _feColorMatrix235, _feColorMatrix236, _feComposite135, _feColorMatrix237, _feFlood67, _feBlend135, _feBlend136, _feColorMatrix238, _feComposite136, _feColorMatrix239, _feComposite137, _feColorMatrix240, _feFlood68, _feBlend137, _feBlend138, _feColorMatrix241, _feComposite138, _feColorMatrix242, _feColorMatrix243, _feComposite139, _feColorMatrix244, _feFlood69, _feBlend139, _feBlend140, _feColorMatrix245, _feComposite140, _feColorMatrix246, _feComposite141, _feColorMatrix247, _feFlood70, _feBlend141, _feBlend142, _feColorMatrix248, _feComposite142, _feColorMatrix249, _feColorMatrix250, _feComposite143, _feColorMatrix251, _feFlood71, _feBlend143, _feBlend144, _feColorMatrix252, _feComposite144, _feColorMatrix253, _feComposite145, _feColorMatrix254, _feFlood72, _feBlend145, _feBlend146, _feColorMatrix255, _feComposite146, _feColorMatrix256, _feColorMatrix257, _feComposite147, _feColorMatrix258, _feFlood73, _feBlend147, _feBlend148, _feColorMatrix259, _feComposite148, _feColorMatrix260, _feComposite149, _feColorMatrix261, _feFlood74, _feBlend149, _feBlend150, _feColorMatrix262, _feComposite150, _feColorMatrix263, _feColorMatrix264, _feComposite151, _feColorMatrix265, _feFlood75, _feBlend151, _feBlend152, _feColorMatrix266, _feComposite152, _feColorMatrix267, _feComposite153, _feColorMatrix268, _feFlood76, _feBlend153, _feBlend154, _feColorMatrix269, _feComposite154, _feColorMatrix270, _feColorMatrix271, _feComposite155, _feColorMatrix272, _feFlood77, _feBlend155, _feBlend156, _feColorMatrix273, _feComposite156, _feColorMatrix274, _feComposite157, _feColorMatrix275, _feFlood78, _feBlend157, _feBlend158, _feColorMatrix276, _feComposite158, _feColorMatrix277, _feColorMatrix278, _feComposite159, _feColorMatrix279, _feFlood79, _feBlend159, _feBlend160, _feColorMatrix280, _feComposite160, _feColorMatrix281, _feComposite161, _feColorMatrix282, _feFlood80, _feBlend161, _feBlend162, _feColorMatrix283, _feComposite162, _feColorMatrix284, _feColorMatrix285, _feComposite163, _feColorMatrix286, _feFlood81, _feBlend163, _feBlend164, _feColorMatrix287, _feComposite164, _feColorMatrix288, _feComposite165, _feColorMatrix289, _feFlood82, _feBlend165, _feBlend166, _feColorMatrix290, _feComposite166, _feColorMatrix291, _feColorMatrix292, _feComposite167, _feColorMatrix293, _feFlood83, _feBlend167, _feBlend168, _feColorMatrix294, _feComposite168, _feColorMatrix295, _feComposite169, _feColorMatrix296, _feFlood84, _feBlend169, _feBlend170, _feColorMatrix297, _feComposite170, _feColorMatrix298, _feColorMatrix299, _feComposite171, _feColorMatrix300, _feFlood85, _feBlend171, _feBlend172, _feColorMatrix301, _feComposite172, _feColorMatrix302, _feComposite173, _feColorMatrix303, _feFlood86, _feBlend173, _feBlend174, _feColorMatrix304, _feComposite174, _feColorMatrix305, _feColorMatrix306, _feComposite175, _feColorMatrix307, _feFlood87, _feBlend175, _feBlend176, _feColorMatrix308, _feComposite176, _feColorMatrix309, _feComposite177, _feColorMatrix310, _feFlood88, _feBlend177, _feBlend178, _feColorMatrix311, _feComposite178, _feColorMatrix312, _feColorMatrix313, _feComposite179, _feColorMatrix314, _feFlood89, _feBlend179, _feBlend180, _feColorMatrix315, _feComposite180, _feColorMatrix316, _feComposite181, _feColorMatrix317, _feFlood90, _feBlend181, _feBlend182, _feColorMatrix318, _feComposite182, _feColorMatrix319, _feColorMatrix320, _feComposite183, _feColorMatrix321, _feFlood91, _feBlend183, _feBlend184, _feColorMatrix322, _feComposite184, _feColorMatrix323, _feComposite185, _feColorMatrix324, _feFlood92, _feBlend185, _feBlend186, _feColorMatrix325, _feComposite186, _feColorMatrix326, _feColorMatrix327, _feComposite187, _feColorMatrix328, _feFlood93, _feBlend187, _feBlend188, _feColorMatrix329, _feComposite188, _feColorMatrix330, _feComposite189, _feColorMatrix331, _feFlood94, _feBlend189, _feBlend190, _feColorMatrix332, _feComposite190, _feColorMatrix333, _feColorMatrix334, _feComposite191, _feColorMatrix335, _feFlood95, _feBlend191, _feBlend192, _feColorMatrix336, _feComposite192, _feColorMatrix337, _feComposite193, _feColorMatrix338, _feFlood96, _feBlend193, _feBlend194, _feColorMatrix339, _feComposite194, _feColorMatrix340, _feColorMatrix341, _feComposite195, _feColorMatrix342, _feFlood97, _feBlend195, _feBlend196, _feColorMatrix343, _feComposite196, _feColorMatrix344, _feComposite197, _feColorMatrix345, _feFlood98, _feBlend197, _feBlend198, _feColorMatrix346, _feComposite198, _feColorMatrix347, _feColorMatrix348, _feComposite199, _feColorMatrix349, _feFlood99, _feBlend199, _feBlend200, _feColorMatrix350, _feComposite200, _feColorMatrix351, _feComposite201, _feColorMatrix352, _feFlood100, _feBlend201, _feBlend202, _feColorMatrix353, _feComposite202, _feColorMatrix354, _feColorMatrix355, _feComposite203, _feColorMatrix356, _feFlood101, _feBlend203, _feBlend204, _feColorMatrix357, _feComposite204, _feColorMatrix358, _feComposite205, _feColorMatrix359, _feFlood102, _feBlend205, _feBlend206, _feColorMatrix360, _feComposite206, _feColorMatrix361, _feColorMatrix362, _feComposite207, _feColorMatrix363, _feFlood103, _feBlend207, _feBlend208, _feColorMatrix364, _feComposite208, _feColorMatrix365, _feComposite209, _feColorMatrix366, _feFlood104, _feBlend209, _feBlend210, _feColorMatrix367, _feComposite210, _feColorMatrix368, _feColorMatrix369, _feComposite211, _feColorMatrix370, _feFlood105, _feBlend211, _feBlend212, _feColorMatrix371, _feComposite212, _feColorMatrix372, _feComposite213, _feColorMatrix373, _feFlood106, _feBlend213, _feBlend214, _feColorMatrix374, _feComposite214, _feColorMatrix375, _feColorMatrix376, _feComposite215, _feColorMatrix377, _feFlood107, _feBlend215, _feBlend216, _feColorMatrix378, _feComposite216, _feColorMatrix379, _feComposite217, _feColorMatrix380, _feFlood108, _feBlend217, _feBlend218, _feColorMatrix381, _feComposite218, _feColorMatrix382, _feColorMatrix383, _feComposite219, _feColorMatrix384, _feFlood109, _feBlend219, _feBlend220, _feColorMatrix385, _feComposite220, _feColorMatrix386, _feComposite221, _feColorMatrix387, _feFlood110, _feBlend221, _feBlend222, _feColorMatrix388, _feComposite222, _feColorMatrix389, _feColorMatrix390, _feComposite223, _feColorMatrix391, _feFlood111, _feBlend223, _feBlend224, _feColorMatrix392, _feComposite224, _feColorMatrix393, _feComposite225, _feColorMatrix394, _feFlood112, _feBlend225, _feBlend226, _feColorMatrix395, _feComposite226, _feColorMatrix396, _feColorMatrix397, _feComposite227, _feColorMatrix398, _feFlood113, _feBlend227, _feBlend228, _feColorMatrix399, _feComposite228, _feColorMatrix400, _feComposite229, _feColorMatrix401, _feFlood114, _feBlend229, _feBlend230, _feColorMatrix402, _feComposite230, _feColorMatrix403, _feColorMatrix404, _feComposite231, _feColorMatrix405, _feFlood115, _feBlend231, _feBlend232, _feColorMatrix406, _feComposite232, _feColorMatrix407, _feComposite233, _feColorMatrix408, _feFlood116, _feBlend233, _feBlend234, _feColorMatrix409, _feComposite234, _feColorMatrix410, _feColorMatrix411, _feComposite235, _feColorMatrix412, _feFlood117, _feBlend235, _feBlend236, _feColorMatrix413, _feComposite236, _feColorMatrix414, _feComposite237, _feColorMatrix415, _feFlood118, _feBlend237, _feBlend238, _feColorMatrix416, _feComposite238, _feColorMatrix417, _feColorMatrix418, _feComposite239, _feColorMatrix419, _feFlood119, _feBlend239, _feBlend240, _feColorMatrix420, _feComposite240, _feColorMatrix421, _feComposite241, _feColorMatrix422, _feFlood120, _feBlend241, _feBlend242, _feColorMatrix423, _feComposite242, _feColorMatrix424, _feColorMatrix425, _feComposite243, _feColorMatrix426, _feFlood121, _feBlend243, _feBlend244, _feColorMatrix427, _feComposite244, _feColorMatrix428, _feComposite245, _feColorMatrix429, _feFlood122, _feBlend245, _feBlend246, _feColorMatrix430, _feComposite246, _feColorMatrix431, _feColorMatrix432, _feComposite247, _feColorMatrix433, _feFlood123, _feBlend247, _feBlend248, _feColorMatrix434, _feComposite248, _feColorMatrix435, _feComposite249, _feColorMatrix436, _feFlood124, _feBlend249, _feBlend250, _feColorMatrix437, _feComposite250, _feColorMatrix438, _feColorMatrix439, _feComposite251, _feColorMatrix440, _feFlood125, _feBlend251, _feBlend252, _feColorMatrix441, _feComposite252, _feColorMatrix442, _feComposite253, _feColorMatrix443, _feFlood126, _feBlend253, _feBlend254, _feColorMatrix444, _feComposite254, _feColorMatrix445, _feColorMatrix446, _feComposite255, _feColorMatrix447, _feFlood127, _feBlend255, _feBlend256, _feColorMatrix448, _feComposite256, _feColorMatrix449, _feComposite257, _feColorMatrix450, _feFlood128, _feBlend257, _feBlend258, _feColorMatrix451, _feComposite258, _feColorMatrix452, _feColorMatrix453, _feComposite259, _feColorMatrix454, _feFlood129, _feBlend259, _feBlend260, _feColorMatrix455, _feComposite260, _feColorMatrix456, _feComposite261, _feColorMatrix457, _feFlood130, _feBlend261, _feBlend262, _feColorMatrix458, _feComposite262, _feColorMatrix459, _feColorMatrix460, _feComposite263, _feColorMatrix461, _feFlood131, _feBlend263, _feBlend264, _feColorMatrix462, _feComposite264, _feColorMatrix463, _feComposite265, _feColorMatrix464, _feFlood132, _feBlend265, _feBlend266, _feColorMatrix465, _feComposite266, _feColorMatrix466, _feColorMatrix467, _feComposite267, _feColorMatrix468, _feFlood133, _feBlend267, _feBlend268, _feColorMatrix469, _feComposite268, _feColorMatrix470, _feComposite269, _feColorMatrix471, _feFlood134, _feBlend269, _feBlend270, _feColorMatrix472, _feComposite270, _feColorMatrix473, _feColorMatrix474, _feComposite271, _feColorMatrix475, _feFlood135, _feBlend271, _feBlend272, _feColorMatrix476, _feComposite272, _feColorMatrix477, _feComposite273, _feColorMatrix478, _feFlood136, _feBlend273, _feBlend274, _feColorMatrix479, _feComposite274, _feColorMatrix480, _feColorMatrix481, _feComposite275, _feColorMatrix482, _feFlood137, _feBlend275, _feBlend276, _feColorMatrix483, _feComposite276, _feColorMatrix484, _feComposite277, _feColorMatrix485, _feFlood138, _feBlend277, _feBlend278, _feColorMatrix486, _feComposite278, _feColorMatrix487, _feColorMatrix488, _feComposite279, _feColorMatrix489, _feFlood139, _feBlend279, _feBlend280, _feColorMatrix490, _feComposite280, _feColorMatrix491, _feComposite281, _feColorMatrix492, _feFlood140, _feBlend281, _feBlend282, _feColorMatrix493, _feComposite282, _feColorMatrix494, _feColorMatrix495, _feComposite283, _feColorMatrix496, _feFlood141, _feBlend283, _feBlend284, _feColorMatrix497, _feComposite284, _feColorMatrix498, _feComposite285, _feColorMatrix499, _feFlood142, _feBlend285, _feBlend286, _feColorMatrix500, _feComposite286, _feColorMatrix501, _feColorMatrix502, _feComposite287, _feColorMatrix503, _feFlood143, _feBlend287, _feBlend288, _feColorMatrix504, _feComposite288, _feColorMatrix505, _feComposite289, _feColorMatrix506, _feFlood144, _feBlend289, _feBlend290, _feColorMatrix507, _feComposite290, _feColorMatrix508, _feColorMatrix509, _feComposite291, _feColorMatrix510, _feFlood145, _feBlend291, _feBlend292, _feColorMatrix511, _feComposite292, _feColorMatrix512, _feComposite293, _feColorMatrix513, _feFlood146, _feBlend293, _feBlend294, _feColorMatrix514, _feComposite294, _feColorMatrix515, _feColorMatrix516, _feComposite295, _feColorMatrix517, _feFlood147, _feBlend295, _feBlend296, _feColorMatrix518, _feComposite296, _feColorMatrix519, _feComposite297, _feColorMatrix520, _feFlood148, _feBlend297, _feBlend298, _feColorMatrix521, _feComposite298, _feColorMatrix522, _feColorMatrix523, _feComposite299, _feColorMatrix524, _feFlood149, _feBlend299, _feBlend300, _feColorMatrix525, _feComposite300, _feColorMatrix526, _feComposite301, _feColorMatrix527, _feFlood150, _feBlend301, _feBlend302, _feColorMatrix528, _feComposite302, _feColorMatrix529, _feColorMatrix530, _feComposite303, _feColorMatrix531, _feFlood151, _feBlend303, _feBlend304, _feColorMatrix532, _feComposite304, _feColorMatrix533, _feComposite305, _feColorMatrix534, _feFlood152, _feBlend305, _feBlend306, _feColorMatrix535, _feComposite306, _feColorMatrix536, _feColorMatrix537, _feComposite307, _feColorMatrix538, _feFlood153, _feBlend307, _feBlend308, _feColorMatrix539, _feComposite308, _feColorMatrix540, _feComposite309, _feColorMatrix541, _feFlood154, _feBlend309, _feBlend310, _feColorMatrix542, _feComposite310, _feColorMatrix543, _feColorMatrix544, _feComposite311, _feColorMatrix545, _feFlood155, _feBlend311, _feBlend312, _feColorMatrix546, _feComposite312, _feColorMatrix547, _feComposite313, _feColorMatrix548, _feFlood156, _feBlend313, _feBlend314, _feColorMatrix549, _feComposite314, _feColorMatrix550, _feColorMatrix551, _feComposite315, _feColorMatrix552, _feFlood157, _feBlend315, _feBlend316, _feColorMatrix553, _feComposite316, _feColorMatrix554, _feComposite317, _feColorMatrix555, _feFlood158, _feBlend317, _feBlend318, _feColorMatrix556, _feComposite318, _feColorMatrix557, _feColorMatrix558, _feComposite319, _feColorMatrix559, _feFlood159, _feBlend319, _feBlend320, _feColorMatrix560, _feComposite320, _feColorMatrix561, _feComposite321, _feColorMatrix562, _feFlood160, _feBlend321, _feBlend322, _feColorMatrix563, _feComposite322, _feColorMatrix564, _feColorMatrix565, _feComposite323, _feColorMatrix566, _feFlood161, _feBlend323, _feBlend324, _feColorMatrix567, _feComposite324, _feColorMatrix568, _feComposite325, _feColorMatrix569, _feFlood162, _feBlend325, _feBlend326, _feColorMatrix570, _feComposite326, _feColorMatrix571, _feColorMatrix572, _feComposite327, _feColorMatrix573, _feFlood163, _feBlend327, _feBlend328, _feColorMatrix574, _feComposite328, _feColorMatrix575, _feComposite329, _feColorMatrix576, _feFlood164, _feBlend329, _feBlend330, _feColorMatrix577, _feComposite330, _feColorMatrix578, _feColorMatrix579, _feComposite331, _feColorMatrix580, _feFlood165, _feBlend331, _feBlend332, _feColorMatrix581, _feComposite332, _feColorMatrix582, _feComposite333, _feColorMatrix583, _feFlood166, _feBlend333, _feBlend334, _feColorMatrix584, _feComposite334, _feColorMatrix585, _feColorMatrix586, _feComposite335, _feColorMatrix587, _feFlood167, _feBlend335, _feBlend336, _feColorMatrix588, _feComposite336, _feColorMatrix589, _feComposite337, _feColorMatrix590, _feFlood168, _feBlend337, _feBlend338, _feColorMatrix591, _feComposite338, _feColorMatrix592, _feColorMatrix593, _feComposite339, _feColorMatrix594, _feFlood169, _feBlend339, _feBlend340, _feColorMatrix595, _feComposite340, _feColorMatrix596, _feComposite341, _feColorMatrix597, _feFlood170, _feBlend341, _feBlend342, _feColorMatrix598, _feComposite342, _feColorMatrix599, _feColorMatrix600, _feComposite343, _feColorMatrix601, _feFlood171, _feBlend343, _feBlend344, _feColorMatrix602, _feComposite344, _feColorMatrix603, _feComposite345, _feColorMatrix604, _feFlood172, _feBlend345, _feBlend346, _feColorMatrix605, _feComposite346, _feColorMatrix606, _feColorMatrix607, _feComposite347, _feColorMatrix608, _feFlood173, _feBlend347, _feBlend348, _feColorMatrix609, _feComposite348, _feColorMatrix610, _feComposite349, _feColorMatrix611, _feFlood174, _feBlend349, _feBlend350, _feColorMatrix612, _feComposite350, _feColorMatrix613, _feColorMatrix614, _feComposite351, _feColorMatrix615, _feFlood175, _feBlend351, _feBlend352, _feColorMatrix616, _feComposite352, _feColorMatrix617, _feComposite353, _feColorMatrix618, _feFlood176, _feBlend353, _feBlend354, _feColorMatrix619, _feComposite354, _feColorMatrix620, _feColorMatrix621, _feComposite355, _feColorMatrix622, _feFlood177, _feBlend355, _feBlend356, _feColorMatrix623, _feComposite356, _feColorMatrix624, _feComposite357, _feColorMatrix625, _feFlood178, _feBlend357, _feBlend358, _feColorMatrix626, _feComposite358, _feColorMatrix627, _feColorMatrix628, _feComposite359, _feColorMatrix629, _feFlood179, _feBlend359, _feBlend360, _feColorMatrix630, _feComposite360, _feColorMatrix631, _feComposite361, _feColorMatrix632, _feFlood180, _feBlend361, _feBlend362, _feColorMatrix633, _feComposite362, _feColorMatrix634, _feColorMatrix635, _feComposite363, _feColorMatrix636, _feFlood181, _feBlend363, _feBlend364, _feColorMatrix637, _feComposite364, _feColorMatrix638, _feComposite365, _feColorMatrix639, _feFlood182, _feBlend365, _feBlend366, _feColorMatrix640, _feComposite366, _feColorMatrix641, _feColorMatrix642, _feComposite367, _feColorMatrix643, _feFlood183, _feBlend367, _feBlend368, _feColorMatrix644, _feComposite368, _feColorMatrix645, _feComposite369, _feColorMatrix646, _feFlood184, _feBlend369, _feBlend370, _feColorMatrix647, _feComposite370, _feColorMatrix648, _feColorMatrix649, _feComposite371, _feColorMatrix650, _feFlood185, _feBlend371, _feBlend372, _feColorMatrix651, _feComposite372, _feColorMatrix652, _feComposite373, _feColorMatrix653, _feFlood186, _feBlend373, _feBlend374, _feColorMatrix654, _feComposite374, _feColorMatrix655, _feColorMatrix656, _feComposite375, _feColorMatrix657, _feFlood187, _feBlend375, _feBlend376, _feColorMatrix658, _feComposite376, _feColorMatrix659, _feComposite377, _feColorMatrix660, _feFlood188, _feBlend377, _feBlend378, _feColorMatrix661, _feComposite378, _feColorMatrix662, _feColorMatrix663, _feComposite379, _feColorMatrix664, _feFlood189, _feBlend379, _feBlend380, _feColorMatrix665, _feComposite380, _feColorMatrix666, _feComposite381, _feColorMatrix667, _feFlood190, _feBlend381, _feBlend382, _feColorMatrix668, _feComposite382, _feColorMatrix669, _feColorMatrix670, _feComposite383, _feColorMatrix671, _feFlood191, _feBlend383, _feBlend384, _feColorMatrix672, _feComposite384, _feColorMatrix673, _feComposite385, _feColorMatrix674, _feFlood192, _feBlend385, _feBlend386, _feColorMatrix675, _feComposite386, _feColorMatrix676, _feColorMatrix677, _feComposite387, _feColorMatrix678, _feFlood193, _feBlend387, _feBlend388, _feColorMatrix679, _feComposite388, _feColorMatrix680, _feComposite389, _feColorMatrix681, _feFlood194, _feBlend389, _feBlend390, _feColorMatrix682, _feComposite390, _feColorMatrix683, _feColorMatrix684, _feComposite391, _feColorMatrix685, _feFlood195, _feBlend391, _feBlend392, _feColorMatrix686, _feComposite392, _feColorMatrix687, _feComposite393, _feColorMatrix688, _feFlood196, _feBlend393, _feBlend394, _feColorMatrix689, _feComposite394, _feColorMatrix690, _feColorMatrix691, _feComposite395, _feColorMatrix692, _feFlood197, _feBlend395, _feBlend396, _feColorMatrix693, _feComposite396, _feColorMatrix694, _feComposite397, _feColorMatrix695, _feFlood198, _feBlend397, _feBlend398, _feColorMatrix696, _feComposite398, _feColorMatrix697, _feColorMatrix698, _feComposite399, _feColorMatrix699, _feFlood199, _feBlend399, _feBlend400, _feColorMatrix700, _feComposite400, _feColorMatrix701, _feComposite401, _feColorMatrix702, _feFlood200, _feBlend401, _feBlend402, _feColorMatrix703, _feComposite402, _feColorMatrix704, _feColorMatrix705, _feComposite403, _feColorMatrix706, _feFlood201, _feBlend403, _feBlend404, _feColorMatrix707, _feComposite404, _feColorMatrix708, _feComposite405, _feColorMatrix709, _feFlood202, _feBlend405, _feBlend406, _feColorMatrix710, _feComposite406, _feColorMatrix711, _feColorMatrix712, _feComposite407, _feColorMatrix713, _feFlood203, _feBlend407, _feBlend408, _feColorMatrix714, _feComposite408, _feColorMatrix715, _feComposite409, _feColorMatrix716, _feFlood204, _feBlend409, _feBlend410, _feColorMatrix717, _feComposite410, _feColorMatrix718, _feColorMatrix719, _feComposite411, _feColorMatrix720, _feFlood205, _feBlend411, _feBlend412, _feColorMatrix721, _feComposite412, _feColorMatrix722, _feComposite413, _feColorMatrix723, _feFlood206, _feBlend413, _feBlend414, _feColorMatrix724, _feComposite414, _feColorMatrix725, _feColorMatrix726, _feComposite415, _feColorMatrix727, _feFlood207, _feBlend415, _feBlend416, _feColorMatrix728, _feComposite416, _feColorMatrix729, _feComposite417, _feColorMatrix730, _feFlood208, _feBlend417, _feBlend418, _feColorMatrix731, _feComposite418, _feColorMatrix732, _feColorMatrix733, _feComposite419, _feColorMatrix734, _feFlood209, _feBlend419, _feBlend420, _feColorMatrix735, _feComposite420, _feColorMatrix736, _feComposite421, _feColorMatrix737, _feFlood210, _feBlend421, _feBlend422, _feColorMatrix738, _feComposite422, _feColorMatrix739, _feColorMatrix740, _feComposite423, _feColorMatrix741, _feFlood211, _feBlend423, _feBlend424, _feColorMatrix742, _feComposite424, _feColorMatrix743, _feComposite425, _feColorMatrix744, _feFlood212, _feBlend425, _feBlend426, _feColorMatrix745, _feComposite426, _feColorMatrix746, _feColorMatrix747, _feComposite427, _feColorMatrix748, _feFlood213, _feBlend427, _feBlend428, _feColorMatrix749, _feComposite428, _feColorMatrix750, _feComposite429, _feColorMatrix751, _feFlood214, _feBlend429, _feBlend430, _feColorMatrix752, _feComposite430, _feColorMatrix753, _feColorMatrix754, _feComposite431, _feColorMatrix755, _feFlood215, _feBlend431, _feBlend432, _feColorMatrix756, _feComposite432, _feColorMatrix757, _feComposite433, _feColorMatrix758, _feFlood216, _feBlend433, _feBlend434, _feColorMatrix759, _feComposite434, _feColorMatrix760, _feColorMatrix761, _feComposite435, _feColorMatrix762, _feFlood217, _feBlend435, _feBlend436, _feColorMatrix763, _feComposite436, _feColorMatrix764, _feComposite437, _feColorMatrix765, _feFlood218, _feBlend437, _feBlend438, _feColorMatrix766, _feComposite438, _feColorMatrix767, _feColorMatrix768, _feComposite439, _feColorMatrix769, _feFlood219, _feBlend439, _feBlend440, _feColorMatrix770, _feComposite440, _feColorMatrix771, _feComposite441, _feColorMatrix772, _feFlood220, _feBlend441, _feBlend442, _feColorMatrix773, _feComposite442, _feColorMatrix774, _feColorMatrix775, _feComposite443, _feColorMatrix776, _feFlood221, _feBlend443, _feBlend444, _feColorMatrix777, _feComposite444, _feColorMatrix778, _feComposite445, _feColorMatrix779, _feFlood222, _feBlend445, _feBlend446, _feColorMatrix780, _feComposite446, _feColorMatrix781, _feColorMatrix782, _feComposite447, _feColorMatrix783, _feFlood223, _feBlend447, _feBlend448, _feColorMatrix784, _feComposite448, _feColorMatrix785, _feComposite449, _feColorMatrix786, _feFlood224, _feBlend449, _feBlend450, _feColorMatrix787, _feComposite450, _feColorMatrix788, _feColorMatrix789, _feComposite451, _feColorMatrix790, _feFlood225, _feBlend451, _feBlend452, _feColorMatrix791, _feComposite452, _feColorMatrix792, _feComposite453, _feColorMatrix793, _feFlood226, _feBlend453, _feBlend454, _feColorMatrix794, _feComposite454, _feColorMatrix795, _feColorMatrix796, _feComposite455, _feColorMatrix797, _feFlood227, _feBlend455, _feBlend456, _feColorMatrix798, _feComposite456, _feColorMatrix799, _feComposite457, _feColorMatrix800, _feFlood228, _feBlend457, _feBlend458, _feColorMatrix801, _feComposite458, _feColorMatrix802, _feColorMatrix803, _feComposite459, _feColorMatrix804, _feFlood229, _feBlend459, _feBlend460, _feColorMatrix805, _feComposite460, _feColorMatrix806, _feComposite461, _feColorMatrix807, _feFlood230, _feBlend461, _feBlend462, _feColorMatrix808, _feComposite462, _feColorMatrix809, _feColorMatrix810, _feComposite463, _feColorMatrix811, _feFlood231, _feBlend463, _feBlend464, _feColorMatrix812, _feComposite464, _feColorMatrix813, _feComposite465, _feColorMatrix814, _feFlood232, _feBlend465, _feBlend466, _feColorMatrix815, _feComposite466, _feColorMatrix816, _feColorMatrix817, _feComposite467, _feColorMatrix818, _feFlood233, _feBlend467, _feBlend468, _feColorMatrix819, _feComposite468, _feColorMatrix820, _feComposite469, _feColorMatrix821, _feFlood234, _feBlend469, _feBlend470, _feColorMatrix822, _feComposite470, _feColorMatrix823, _feColorMatrix824, _feComposite471, _feColorMatrix825, _feFlood235, _feBlend471, _feBlend472, _feColorMatrix826, _feComposite472, _feColorMatrix827, _feComposite473, _feColorMatrix828, _feFlood236, _feBlend473, _feBlend474, _feColorMatrix829, _feComposite474, _feColorMatrix830, _feColorMatrix831, _feComposite475, _feColorMatrix832, _feFlood237, _feBlend475, _feBlend476, _feColorMatrix833, _feComposite476, _feColorMatrix834, _feComposite477, _feColorMatrix835, _feFlood238, _feBlend477, _feBlend478, _feColorMatrix836, _feComposite478, _feColorMatrix837, _feColorMatrix838, _feComposite479, _feColorMatrix839, _feFlood239, _feBlend479, _feBlend480, _feColorMatrix840, _feComposite480, _feColorMatrix841, _feComposite481, _feColorMatrix842, _feFlood240, _feBlend481, _feBlend482, _feColorMatrix843, _feComposite482, _feColorMatrix844, _feColorMatrix845, _feComposite483, _feColorMatrix846, _feFlood241, _feBlend483, _feBlend484, _feColorMatrix847, _feComposite484, _feColorMatrix848, _feComposite485, _feColorMatrix849, _feFlood242, _feBlend485, _feBlend486, _feColorMatrix850, _feComposite486, _feColorMatrix851, _feColorMatrix852, _feComposite487, _feColorMatrix853, _feFlood243, _feBlend487, _feBlend488, _feColorMatrix854, _feComposite488, _feColorMatrix855, _feComposite489, _feColorMatrix856, _feFlood244, _feBlend489, _feBlend490, _feColorMatrix857, _feComposite490, _feColorMatrix858, _feColorMatrix859, _feComposite491, _feColorMatrix860, _feFlood245, _feBlend491, _feBlend492, _feColorMatrix861, _feComposite492, _feColorMatrix862, _feComposite493, _feColorMatrix863, _feFlood246, _feBlend493, _feBlend494, _feColorMatrix864, _feComposite494, _feColorMatrix865, _feColorMatrix866, _feComposite495, _feColorMatrix867, _feFlood247, _feBlend495, _feBlend496, _feColorMatrix868, _feComposite496, _feColorMatrix869, _feComposite497, _feColorMatrix870, _feFlood248, _feBlend497, _feBlend498, _feColorMatrix871, _feComposite498, _feColorMatrix872, _feColorMatrix873, _feComposite499, _feColorMatrix874, _feFlood249, _feBlend499, _feBlend500, _feColorMatrix875, _feComposite500, _feColorMatrix876, _feComposite501, _feColorMatrix877, _feFlood250, _feBlend501, _feBlend502, _feColorMatrix878, _feComposite502, _feColorMatrix879, _feColorMatrix880, _feComposite503, _feColorMatrix881, _feFlood251, _feBlend503, _feBlend504, _feColorMatrix882, _feComposite504, _feColorMatrix883, _feComposite505, _feColorMatrix884, _feFlood252, _feBlend505, _feBlend506, _feColorMatrix885, _feComposite506, _feColorMatrix886, _feColorMatrix887, _feComposite507, _feColorMatrix888, _feFlood253, _feBlend507, _feBlend508, _feColorMatrix889, _feComposite508, _feColorMatrix890, _feComposite509, _feColorMatrix891, _feFlood254, _feBlend509, _feBlend510, _feColorMatrix892, _feComposite510, _feColorMatrix893, _feColorMatrix894, _feComposite511, _feColorMatrix895, _feFlood255, _feBlend511, _feBlend512, _feColorMatrix896, _feComposite512, _feColorMatrix897, _feComposite513, _feColorMatrix898, _feFlood256, _feBlend513, _feBlend514, _feColorMatrix899, _feComposite514, _feColorMatrix900, _feColorMatrix901, _feComposite515, _feColorMatrix902, _feFlood257, _feBlend515, _feBlend516, _feColorMatrix903, _feComposite516, _feColorMatrix904, _feComposite517, _feColorMatrix905, _feFlood258, _feBlend517, _feBlend518, _feColorMatrix906, _feComposite518, _feColorMatrix907, _feColorMatrix908, _feComposite519, _feColorMatrix909, _feFlood259, _feBlend519, _feBlend520, _feColorMatrix910, _feComposite520, _feColorMatrix911, _feComposite521, _feColorMatrix912, _feFlood260, _feBlend521, _feBlend522, _feColorMatrix913, _feComposite522, _feColorMatrix914, _feColorMatrix915, _feComposite523, _feColorMatrix916, _feFlood261, _feBlend523, _feBlend524, _feColorMatrix917, _feComposite524, _feColorMatrix918, _feComposite525, _feColorMatrix919, _feFlood262, _feBlend525, _feBlend526, _feColorMatrix920, _feComposite526, _feColorMatrix921, _feColorMatrix922, _feComposite527, _feColorMatrix923, _feFlood263, _feBlend527, _feBlend528, _feColorMatrix924, _feComposite528, _feColorMatrix925, _feComposite529, _feColorMatrix926, _feFlood264, _feBlend529, _feBlend530, _feColorMatrix927, _feComposite530, _feColorMatrix928, _feColorMatrix929, _feComposite531, _feColorMatrix930, _feFlood265, _feBlend531, _feBlend532, _feColorMatrix931, _feComposite532, _feColorMatrix932, _feComposite533, _feColorMatrix933, _feFlood266, _feBlend533, _feBlend534, _feColorMatrix934, _feComposite534, _feColorMatrix935, _feColorMatrix936, _feComposite535, _feColorMatrix937, _feFlood267, _feBlend535, _feBlend536, _feColorMatrix938, _feComposite536, _feColorMatrix939, _feComposite537, _feColorMatrix940, _feFlood268, _feBlend537, _feBlend538, _feColorMatrix941, _feComposite538, _feColorMatrix942, _feColorMatrix943, _feComposite539, _feColorMatrix944, _feFlood269, _feBlend539, _feBlend540, _feColorMatrix945, _feComposite540, _feColorMatrix946, _feComposite541, _feColorMatrix947, _feFlood270, _feBlend541, _feBlend542, _feColorMatrix948, _feComposite542, _feColorMatrix949, _feColorMatrix950, _feComposite543, _feColorMatrix951, _feFlood271, _feBlend543, _feBlend544, _feColorMatrix952, _feComposite544, _feColorMatrix953, _feComposite545, _feColorMatrix954, _feFlood272, _feBlend545, _feBlend546, _feColorMatrix955, _feComposite546, _feColorMatrix956, _feColorMatrix957, _feComposite547, _feColorMatrix958, _feFlood273, _feBlend547, _feBlend548, _feColorMatrix959, _feComposite548, _feColorMatrix960, _feComposite549, _feColorMatrix961, _feFlood274, _feBlend549, _feBlend550, _feColorMatrix962, _feComposite550, _feColorMatrix963, _feColorMatrix964, _feComposite551, _feColorMatrix965, _feFlood275, _feBlend551, _feBlend552, _feColorMatrix966, _feComposite552, _feColorMatrix967, _feComposite553, _feColorMatrix968, _feFlood276, _feBlend553, _feBlend554, _feColorMatrix969, _feComposite554, _feColorMatrix970, _feColorMatrix971, _feComposite555, _feColorMatrix972, _feFlood277, _feBlend555, _feBlend556, _feColorMatrix973, _feComposite556, _feColorMatrix974, _feComposite557, _feColorMatrix975, _feFlood278, _feBlend557, _feBlend558, _feColorMatrix976, _feComposite558, _feColorMatrix977, _feColorMatrix978, _feComposite559, _feColorMatrix979, _feFlood279, _feBlend559, _feBlend560, _feColorMatrix980, _feComposite560, _feColorMatrix981, _feComposite561, _feColorMatrix982, _feFlood280, _feBlend561, _feBlend562, _feColorMatrix983, _feComposite562, _feColorMatrix984, _feColorMatrix985, _feComposite563, _feColorMatrix986, _feFlood281, _feBlend563, _feBlend564, _feColorMatrix987, _feComposite564, _feColorMatrix988, _feComposite565, _feColorMatrix989, _feFlood282, _feBlend565, _feBlend566, _feColorMatrix990, _feComposite566, _feColorMatrix991, _feColorMatrix992, _feComposite567, _feColorMatrix993, _feFlood283, _feBlend567, _feBlend568, _feColorMatrix994, _feComposite568, _feColorMatrix995, _feComposite569, _feColorMatrix996, _feFlood284, _feBlend569, _feBlend570, _feColorMatrix997, _feComposite570, _feColorMatrix998, _feColorMatrix999, _feComposite571, _feColorMatrix1000, _feFlood285, _feBlend571, _feBlend572, _feColorMatrix1001, _feComposite572, _feColorMatrix1002, _feComposite573, _feColorMatrix1003, _feFlood286, _feBlend573, _feBlend574, _feColorMatrix1004, _feComposite574, _feColorMatrix1005, _feColorMatrix1006, _feComposite575, _feColorMatrix1007, _feFlood287, _feBlend575, _feBlend576, _feColorMatrix1008, _feComposite576, _feColorMatrix1009, _feComposite577, _feColorMatrix1010, _feFlood288, _feBlend577, _feBlend578, _feColorMatrix1011, _feComposite578, _feColorMatrix1012, _feColorMatrix1013, _feComposite579, _feColorMatrix1014, _feFlood289, _feBlend579, _feBlend580, _feColorMatrix1015, _feComposite580, _feColorMatrix1016, _feComposite581, _feColorMatrix1017, _feFlood290, _feBlend581, _feBlend582, _feColorMatrix1018, _feComposite582, _feColorMatrix1019, _feColorMatrix1020, _feComposite583, _feColorMatrix1021, _feFlood291, _feBlend583, _feBlend584, _feColorMatrix1022, _feComposite584, _feColorMatrix1023, _feComposite585, _feColorMatrix1024, _feFlood292, _feBlend585, _feBlend586, _feColorMatrix1025, _feComposite586, _feColorMatrix1026, _feColorMatrix1027, _feComposite587, _feColorMatrix1028, _feFlood293, _feBlend587, _feBlend588, _feColorMatrix1029, _feComposite588, _feColorMatrix1030, _feComposite589, _feColorMatrix1031, _feFlood294, _feBlend589, _feBlend590, _feColorMatrix1032, _feComposite590, _feColorMatrix1033, _feColorMatrix1034, _feComposite591, _feColorMatrix1035, _feFlood295, _feBlend591, _feBlend592, _feColorMatrix1036, _feComposite592, _feColorMatrix1037, _feComposite593, _feColorMatrix1038, _feFlood296, _feBlend593, _feBlend594, _feColorMatrix1039, _feComposite594, _feColorMatrix1040, _feColorMatrix1041, _feComposite595, _feColorMatrix1042, _feFlood297, _feBlend595, _feBlend596, _feColorMatrix1043, _feComposite596, _feColorMatrix1044, _feComposite597, _feColorMatrix1045, _feFlood298, _feBlend597, _feBlend598, _feColorMatrix1046, _feComposite598, _feColorMatrix1047, _feColorMatrix1048, _feComposite599, _feColorMatrix1049, _feFlood299, _feBlend599, _feBlend600, _feColorMatrix1050, _feComposite600, _feColorMatrix1051, _feComposite601, _feColorMatrix1052, _feFlood300, _feBlend601, _feBlend602, _feColorMatrix1053, _feComposite602, _feColorMatrix1054, _feColorMatrix1055, _feComposite603, _feColorMatrix1056, _feFlood301, _feBlend603, _feBlend604, _feColorMatrix1057, _feComposite604, _feColorMatrix1058, _feComposite605, _feColorMatrix1059, _feFlood302, _feBlend605, _feBlend606, _feColorMatrix1060, _feComposite606, _feColorMatrix1061, _feColorMatrix1062, _feComposite607, _feColorMatrix1063, _feFlood303, _feBlend607, _feBlend608, _feColorMatrix1064, _feComposite608, _feColorMatrix1065, _feComposite609, _feColorMatrix1066, _feFlood304, _feBlend609, _feBlend610, _feColorMatrix1067, _feComposite610, _feColorMatrix1068, _feColorMatrix1069, _feComposite611, _feColorMatrix1070, _feFlood305, _feBlend611, _feBlend612, _feColorMatrix1071, _feComposite612, _feColorMatrix1072, _feComposite613, _feColorMatrix1073, _feFlood306, _feBlend613, _feBlend614, _feColorMatrix1074, _feComposite614, _feColorMatrix1075, _feColorMatrix1076, _feComposite615, _feColorMatrix1077, _feFlood307, _feBlend615, _feBlend616, _feColorMatrix1078, _feComposite616, _feColorMatrix1079, _feComposite617, _feColorMatrix1080, _feFlood308, _feBlend617, _feBlend618, _feColorMatrix1081, _feComposite618, _feColorMatrix1082, _feColorMatrix1083, _feComposite619, _feColorMatrix1084, _feFlood309, _feBlend619, _feBlend620, _feColorMatrix1085, _feComposite620, _feColorMatrix1086, _feComposite621, _feColorMatrix1087, _feFlood310, _feBlend621, _feBlend622, _feColorMatrix1088, _feComposite622, _feColorMatrix1089, _feColorMatrix1090, _feComposite623, _feColorMatrix1091, _feFlood311, _feBlend623, _feBlend624, _feColorMatrix1092, _feComposite624, _feColorMatrix1093, _feComposite625, _feColorMatrix1094, _feFlood312, _feBlend625, _feBlend626, _feColorMatrix1095, _feComposite626, _feColorMatrix1096, _feColorMatrix1097, _feComposite627, _feColorMatrix1098, _feFlood313, _feBlend627, _feBlend628, _feColorMatrix1099, _feComposite628, _feColorMatrix1100, _feComposite629, _feColorMatrix1101, _feFlood314, _feBlend629, _feBlend630, _feColorMatrix1102, _feComposite630, _feColorMatrix1103, _feColorMatrix1104, _feComposite631, _feColorMatrix1105, _feFlood315, _feBlend631, _feBlend632, _feColorMatrix1106, _feComposite632, _feColorMatrix1107, _feComposite633, _feColorMatrix1108, _feFlood316, _feBlend633, _feBlend634, _feColorMatrix1109, _feComposite634, _feColorMatrix1110, _feColorMatrix1111, _feComposite635, _feColorMatrix1112, _feFlood317, _feBlend635, _feBlend636, _feColorMatrix1113, _feComposite636, _feColorMatrix1114, _feComposite637, _feColorMatrix1115, _feFlood318, _feBlend637, _feBlend638, _feColorMatrix1116, _feComposite638, _feColorMatrix1117, _feColorMatrix1118, _feComposite639, _feColorMatrix1119, _feFlood319, _feBlend639, _feBlend640, _feColorMatrix1120, _feComposite640, _feColorMatrix1121, _feComposite641, _feColorMatrix1122, _feFlood320, _feBlend641, _feBlend642, _feColorMatrix1123, _feComposite642, _feColorMatrix1124, _feColorMatrix1125, _feComposite643, _feColorMatrix1126, _feFlood321, _feBlend643, _feBlend644, _feColorMatrix1127, _feComposite644, _feColorMatrix1128, _feComposite645, _feColorMatrix1129, _feFlood322, _feBlend645, _feBlend646, _feColorMatrix1130, _feComposite646, _feColorMatrix1131, _feColorMatrix1132, _feComposite647, _feColorMatrix1133, _feFlood323, _feBlend647, _feBlend648, _feColorMatrix1134, _feComposite648, _feColorMatrix1135, _feComposite649, _feColorMatrix1136, _feFlood324, _feBlend649, _feBlend650, _feColorMatrix1137, _feComposite650, _feColorMatrix1138, _feColorMatrix1139, _feComposite651, _feColorMatrix1140, _feFlood325, _feBlend651, _feBlend652, _feColorMatrix1141, _feComposite652, _feColorMatrix1142, _feComposite653, _feColorMatrix1143, _feFlood326, _feBlend653, _feBlend654, _feColorMatrix1144, _feComposite654, _feColorMatrix1145, _feColorMatrix1146, _feComposite655, _feColorMatrix1147, _feFlood327, _feBlend655, _feBlend656, _feColorMatrix1148, _feComposite656, _feColorMatrix1149, _feComposite657, _feColorMatrix1150, _feFlood328, _feBlend657, _feBlend658, _feColorMatrix1151, _feComposite658, _feColorMatrix1152, _feColorMatrix1153, _feComposite659, _feColorMatrix1154, _feFlood329, _feBlend659, _feBlend660, _feColorMatrix1155, _feComposite660, _feColorMatrix1156, _feComposite661, _feColorMatrix1157, _feFlood330, _feBlend661, _feBlend662, _feColorMatrix1158, _feComposite662, _feColorMatrix1159, _feColorMatrix1160, _feComposite663, _feColorMatrix1161, _feFlood331, _feBlend663, _feBlend664, _feColorMatrix1162, _feComposite664, _feColorMatrix1163, _feComposite665, _feColorMatrix1164, _feFlood332, _feBlend665, _feBlend666, _feColorMatrix1165, _feComposite666, _feColorMatrix1166, _feColorMatrix1167, _feComposite667, _feColorMatrix1168, _feFlood333, _feBlend667, _feBlend668, _feColorMatrix1169, _feComposite668, _feColorMatrix1170, _feComposite669, _feColorMatrix1171, _feFlood334, _feBlend669, _feBlend670, _feColorMatrix1172, _feComposite670, _feColorMatrix1173, _feColorMatrix1174, _feComposite671, _feColorMatrix1175, _feFlood335, _feBlend671, _feBlend672, _feColorMatrix1176, _feComposite672, _feColorMatrix1177, _feComposite673, _feColorMatrix1178, _feFlood336, _feBlend673, _feBlend674, _feColorMatrix1179, _feComposite674, _feColorMatrix1180, _feColorMatrix1181, _feComposite675, _feColorMatrix1182, _feFlood337, _feBlend675, _feBlend676, _feColorMatrix1183, _feComposite676, _feColorMatrix1184, _feComposite677, _feColorMatrix1185, _feFlood338, _feBlend677, _feBlend678, _feColorMatrix1186, _feComposite678, _feColorMatrix1187, _feColorMatrix1188, _feComposite679, _feColorMatrix1189, _feFlood339, _feBlend679, _feBlend680, _feColorMatrix1190, _feComposite680, _feColorMatrix1191, _feComposite681, _feColorMatrix1192, _feFlood340, _feBlend681, _feBlend682, _feColorMatrix1193, _feComposite682, _feColorMatrix1194, _feColorMatrix1195, _feComposite683, _feColorMatrix1196, _feFlood341, _feBlend683, _feBlend684, _feColorMatrix1197, _feComposite684, _feColorMatrix1198, _feComposite685, _feColorMatrix1199, _feFlood342, _feBlend685, _feBlend686, _feColorMatrix1200, _feComposite686, _feColorMatrix1201, _feColorMatrix1202, _feComposite687, _feColorMatrix1203, _feFlood343, _feBlend687, _feBlend688, _feColorMatrix1204, _feComposite688, _feColorMatrix1205, _feComposite689, _feColorMatrix1206, _feFlood344, _feBlend689, _feBlend690, _feColorMatrix1207, _feComposite690, _feColorMatrix1208, _feColorMatrix1209, _feComposite691, _feColorMatrix1210, _feFlood345, _feBlend691, _feBlend692, _feColorMatrix1211, _feComposite692, _feColorMatrix1212, _feComposite693, _feColorMatrix1213, _feFlood346, _feBlend693, _feBlend694, _feColorMatrix1214, _feComposite694, _feColorMatrix1215, _feColorMatrix1216, _feComposite695, _feColorMatrix1217, _feFlood347, _feBlend695, _feBlend696, _feColorMatrix1218, _feComposite696, _feColorMatrix1219, _feComposite697, _feColorMatrix1220, _feFlood348, _feBlend697, _feBlend698, _feColorMatrix1221, _feComposite698, _feColorMatrix1222, _feColorMatrix1223;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIllustrationEon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 553,
    height: 488,
    fill: "none",
    viewBox: "0 0 553 488",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m41.696 348.18s-17.531-9.205-23.612-22.617c-6.0803-13.403-.1403-32.192-1.9718-38.499 11.22 11.84 18.117 15.273 23.018 28.932 4.9005 13.668 3.4733 28.348 2.5658 32.184z",
    fill: "#3788B8",
    style: {
      filter: "url(#filter7335)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m60.167 370.53s-18.051 14.277-37.051.494c-13.283-11.164-22.118-26.396-22.118-26.396s21.351 2.873 32.035 5.385c10.676 2.511 23.306 14.836 27.134 20.517z",
    fill: "#3788B8",
    style: {
      filter: "url(#filter7333)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m511.62 348.18s17.531-9.205 23.611-22.617c6.08-13.403.14-32.192 1.972-38.499-11.22 11.84-18.117 15.273-23.018 28.932-4.9 13.668-3.481 28.348-2.565 32.184z",
    fill: "#3788B8",
    style: {
      filter: "url(#filter7331)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m493.14 370.53s18.051 14.277 37.05.494c13.283-11.164 22.119-26.396 22.119-26.396s-21.351 2.873-32.035 5.385c-10.676 2.511-23.306 14.836-27.134 20.517z",
    fill: "#3788B8",
    style: {
      filter: "url(#filter7329)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m127.56 423.44s-17.837 15.364-63.855 3.771c-33.544-8.447-61.182-41.504-61.182-41.504s65.852-24.881 125.04 37.733z",
    fill: "#3788B8",
    style: {
      filter: "url(#filter7327)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m126.06 425.51s-35.459-4.117-69.655-67.258c-24.932-46.016-16.294-110.68-16.294-110.68s95.312 47.836 85.949 177.94z",
    fill: "#3788B8",
    style: {
      filter: "url(#filter7325)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m124.7 424.21s-28.198-21.835-24.725-93.522c2.5329-52.249 43.461-103.12 43.461-103.12s56.752 90.155-18.736 196.64z",
    fill: "#3788B8",
    style: {
      filter: "url(#filter7323)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m423.18 420.78s17.614 15.166 63.055 3.721c33.123-8.34 60.423-40.985 60.423-40.985s-65.027-24.577-123.48 37.264z",
    fill: "#3788B8",
    style: {
      filter: "url(#filter7321)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m425.76 425.51s35.458-4.117 69.655-67.258c24.931-46.016 16.285-110.68 16.285-110.68s-95.304 47.836-85.94 177.94z",
    fill: "#3788B8",
    style: {
      filter: "url(#filter7319)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m427.12 424.21s28.198-21.835 24.725-93.522c-2.533-52.249-43.461-103.12-43.461-103.12s-56.752 90.155 18.736 196.64z",
    fill: "#3788B8",
    style: {
      filter: "url(#filter7317)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m517.37 239.18c0-131.81-107.07-238.66-239.15-238.66-132.07 0-239.15 106.85-239.15 238.66 0 75.186 34.856 181.9 89.298 225.64h299.7c54.45-43.743 89.306-150.46 89.306-225.64z",
    fill: "url(#paint0_linear_0_1)",
    style: {
      filter: "url(#filter7315)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8,
    style: {
      filter: "url(#filter7313)"
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 127.1,
    y: 206.13,
    width: 302.78,
    height: 219.83,
    fill: "url(#pattern0)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m250.83 73.965c.004.1255-.018.2505-.064.3676-.045.1171-.114.2239-.201.3141-.088.0901-.193.1618-.309.2108s-.24.0742-.366.0743c-.126 0-.25-.0251-.366-.074s-.221-.1205-.309-.2105c-.088-.0901-.156-.1968-.202-.3139-.046-.117-.067-.242-.063-.3676.007-.244.109-.4757.284-.6458.176-.1701.411-.2653.655-.2654.245-1e-4.48.0949.655.2649.176.1699.278.4015.286.6455zm67.452 58.177c0 .185-.055.367-.159.521-.103.155-.25.275-.422.346s-.361.09-.543.053c-.183-.036-.35-.125-.482-.256-.131-.132-.221-.299-.257-.481s-.018-.371.053-.542c.072-.172.192-.318.347-.422.154-.103.336-.158.522-.158.52-.008.941.42.941.939zm-112.34 14.474c.004.126-.017.251-.063.368-.045.117-.114.224-.202.314-.087.09-.192.162-.308.211s-.24.074-.366.074-.251-.025-.367-.074c-.115-.049-.22-.121-.308-.211s-.157-.196-.202-.314c-.046-.117-.067-.242-.064-.367.007-.244.11-.476.285-.646s.41-.265.655-.265.48.095.655.264c.176.17.278.402.285.646zm-71.395-11.378c0 .185-.055.367-.159.521-.103.154-.25.275-.422.346-.171.071-.361.089-.543.053s-.35-.125-.482-.257c-.131-.131-.221-.298-.257-.48s-.018-.371.054-.543c.071-.171.191-.318.346-.421s.336-.158.522-.158c.52-.008.941.412.941.939zm276.61 57.304c.004.125-.017.25-.063.367s-.114.224-.202.314c-.087.09-.192.162-.308.211s-.241.074-.366.074c-.126 0-.251-.025-.367-.074-.116-.048-.221-.12-.308-.21-.088-.09-.157-.197-.202-.314-.046-.117-.068-.242-.064-.368.007-.244.109-.475.285-.645.175-.171.41-.266.655-.266.244 0 .479.095.655.265s.278.402.285.646z",
    fill: "white",
    style: {
      filter: "url(#filter7311)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m414.26 129.82.999 2.025 2.252.33-1.625 1.581.379 2.231-2.005-1.054-2.013 1.054.388-2.231-1.625-1.581 2.244-.33 1.006-2.025z",
    fill: "#3788B8",
    style: {
      filter: "url(#filter7309)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m181.58 47.339 1.254 2.5441 2.813.4035-2.038 1.976.487 2.7911-2.516-1.3174-2.508 1.3174.478-2.7911-2.029-1.976 2.805-.4035 1.254-2.5441zm281.3 124.27 1.262 2.536 2.805.412-2.029 1.976.478 2.791-2.516-1.317-2.508 1.317.478-2.791-2.029-1.976 2.805-.412 1.254-2.536z",
    fill: "#3788B8",
    style: {
      filter: "url(#filter7307)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m92.467 167.38c1.8362 0 3.3248-1.486 3.3248-3.318 0-1.833-1.4886-3.318-3.3248-3.318s-3.3247 1.485-3.3247 3.318c0 1.832 1.4885 3.318 3.3247 3.318z",
    fill: "#3788B8",
    style: {
      filter: "url(#filter7305)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m344.85 93.577c12.887 12.926 33.834 12.976 46.786.1153 12.953-12.86 13.002-33.757.124-46.683-12.887-12.926-33.833-12.976-46.786-.1153-12.952 12.852-13.002 33.757-.124 46.683z",
    fill: "url(#paint1_linear_0_1)",
    style: {
      filter: "url(#filter7303)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m407.74 321.06c-.231-1.951 11.006-40.961 23.505-58.308 12.498-17.348 26.548-49.417 26.548-49.417s4.727 28.52-8.266 47.243c-12.994 18.731-18.513 27.977-18.513 27.977s9.075-18.262 30.78-19.521c21.706-1.26 16.121 18.574 16.121 18.574s-23.942-34.16-73.656 43.126",
    fill: "url(#paint2_linear_0_1)",
    style: {
      filter: "url(#filter7301)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m378.04 358.9s-34.122 7.929-57.222-6.191c-23.1-14.112-38.247-34.136-38.247-34.136s25.806-8.669 42.447-5.236c16.64 3.433 31.201 22.222 31.242 20.707.042-1.515-17.754-25.548-19.197-41.356-1.444-15.817 6.08-45.432 6.08-45.432s21.912 16.846 27.365 30.027c5.462 13.173 9.702 41.62 9.702 41.62s-2.904-24.882 7.194-45.514c10.106-20.633 35.772-37.322 35.772-37.322s9.545 25.754 1.708 50.874c-7.838 25.12-25.996 41.636-25.996 41.636s25.121-18.089 40.623-20.575c15.502-2.479 37.01 10.958 37.01 10.958s-21.995 24.42-38.998 28.8c-17.012 4.389-34.106 2.141-34.106 2.141s23.587.403 37.472 9.773 25.699 28.71 25.699 28.71-32.868 3.886-53.592-6.62c-20.724-10.514-34.956-22.864-34.956-22.864z",
    fill: "url(#paint3_linear_0_1)",
    style: {
      filter: "url(#filter7299)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m410.52 350.4c-4.257-.452-7.103-.51-7.103-.51s2.756.354 7.103.51z",
    fill: "url(#paint4_linear_0_1)",
    style: {
      filter: "url(#filter7297)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m348.11 265.46s4.183 55.155 30.195 84.696c-3.63-8.266-13.389-22.427-18.801-42.039-5.404-19.604-11.394-42.657-11.394-42.657z",
    fill: "url(#paint5_linear_0_1)",
    style: {
      filter: "url(#filter7295)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m377.59 352.47s-48.915-14.137-67.815-22.922c-14.034-6.117-20.576-9.229-20.576-9.229s10.601 8.628 40.879 20.278c30.277 11.642 47.512 11.873 47.512 11.873z",
    fill: "url(#paint6_linear_0_1)",
    style: {
      filter: "url(#filter7293)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m383.73 353.53s29.997 7.953 55.226 20.847c11.938 6.2 19.445 10.662 19.445 10.662s-20.476-9.155-34.576-14.738c-14.099-5.598-40.095-16.771-40.095-16.771z",
    fill: "url(#paint7_linear_0_1)",
    style: {
      filter: "url(#filter7291)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m151.42 305.13c.231-1.952-11.006-40.961-23.504-58.309-12.499-17.347-26.549-49.416-26.549-49.416s-4.7271 28.52 8.267 47.243c12.993 18.73 18.513 27.976 18.513 27.976s-9.075-18.261-30.781-19.521c-21.706-1.259-16.12 18.575-16.12 18.575s23.942-34.16 73.656 43.126",
    fill: "url(#paint8_linear_0_1)",
    style: {
      filter: "url(#filter7289)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m389.89 220.72s-14.05 20.995-22.837 51.508c-8.794 30.513-5.304 64.755-5.304 64.755",
    stroke: "#353535",
    strokeMiterlimit: 10,
    strokeWidth: 2.3099,
    style: {
      filter: "url(#filter7287)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m384.83 255.72s-11.286 3.59-15.345 8.694c.124-5.615 1.84-25.951 1.84-25.951",
    stroke: "#353535",
    strokeMiterlimit: 10,
    strokeWidth: 2.3099,
    style: {
      filter: "url(#filter7285)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m377.68 288.29s-10.857 1.836-15.04 5.879c-2.615-6.076-5.032-21.909-5.032-21.909",
    stroke: "#353535",
    strokeMiterlimit: 10,
    strokeWidth: 2.3099,
    style: {
      filter: "url(#filter7283)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m367.78 316.07s-4.71 2.783-6.715 5.41c-3.531-5.294-12.895-15.191-12.895-15.191",
    stroke: "#353535",
    strokeMiterlimit: 10,
    strokeWidth: 2.3099,
    style: {
      filter: "url(#filter7281)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m388.18 222.68s13.818-.412 19.841-9.93c6.022-9.518 7.227-17.808 7.227-17.808s-12.779 1.926-20.295 8.62c-7.532 6.702-6.773 19.118-6.773 19.118z",
    fill: "#286385",
    style: {
      filter: "url(#filter7279)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m384.83 255.72s7.549-11.691 17.779-16.516c9.058-3.647 21.466 3.12 21.466 3.12s-1.501 9.222-15.353 14.433c-9.223 3.467-18.612 1.161-23.892-1.037z",
    fill: "#286385",
    style: {
      filter: "url(#filter7277)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m358.31 275.02s4.826-19.603-4.216-27.343c-9.05-7.731-12.581-9.55-12.581-9.55s-3.589 15.165.371 23.358c3.968 8.2 16.426 13.535 16.426 13.535z",
    fill: "#286385",
    style: {
      filter: "url(#filter7275)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m374.95 288.74s11.954-11.453 20.906-11.461c8.951-.008 18.216 3.985 18.216 3.985s-5.61 11.428-19.495 11.765c-13.877.346-19.627-4.289-19.627-4.289z",
    fill: "#286385",
    style: {
      filter: "url(#filter7273)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m349.78 307.95s-2.434-15.182-13.827-18.196c-9.702-2.379-13.86-.156-13.86-.156s.47 7.427 6.179 13.643c5.709 6.224 21.508 4.709 21.508 4.709z",
    fill: "#286385",
    style: {
      filter: "url(#filter7271)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m366.38 316.9s2.368-8.81 9.859-11.099c7.746-2.231 14.379 1.746 14.379 1.746s-.973 9.205-9.644 11.321c-8.679 2.116-14.594-1.968-14.594-1.968z",
    fill: "#286385",
    style: {
      filter: "url(#filter7269)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m371.77 240s5.082-14.409 1.898-21.382c-3.185-6.974-10.189-10.078-10.189-10.078s-5.437 8.052-3.473 15.808c1.963 7.756 11.764 15.652 11.764 15.652z",
    fill: "#286385",
    style: {
      filter: "url(#filter7267)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m149.68 223.88s19.717 15.808 37.298 42.27 24.568 60.169 24.568 60.169",
    stroke: "#353535",
    strokeMiterlimit: 10,
    strokeWidth: 2.3099,
    style: {
      filter: "url(#filter7265)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m165.04 255.73s11.847.033 17.259 3.688c-1.815-5.319-9.57-24.198-9.57-24.198",
    stroke: "#353535",
    strokeMiterlimit: 10,
    strokeWidth: 2.3099,
    style: {
      filter: "url(#filter7263)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m181.67 284.66s10.906-1.506 16.112 1.095c.66-6.578-1.798-22.403-1.798-22.403",
    stroke: "#353535",
    strokeMiterlimit: 10,
    strokeWidth: 2.3099,
    style: {
      filter: "url(#filter7261)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m199.49 308.18s5.338 1.243 8.036 3.145c1.774-6.109 7.722-18.36 7.722-18.36",
    stroke: "#353535",
    strokeMiterlimit: 10,
    strokeWidth: 2.3099,
    style: {
      filter: "url(#filter7259)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m151.9 225.23s-13.307 3.754-21.912-3.524-12.259-14.82-12.259-14.82 12.771-1.992 21.961 2.133c9.191 4.141 12.21 16.211 12.21 16.211z",
    fill: "#286385",
    style: {
      filter: "url(#filter7257)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m165.04 255.73s-10.717-8.884-21.928-10.416c-9.735-.757-19.528 9.419-19.528 9.419s4.207 8.341 18.991 9.156c9.834.535 18.093-4.471 22.465-8.159z",
    fill: "#286385",
    style: {
      filter: "url(#filter7255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m196.15 266.2s-10.51-17.249-4.207-27.343c6.303-10.086 9.124-12.885 9.124-12.885s7.995 13.387 6.683 22.395c-1.328 9.007-11.6 17.833-11.6 17.833z",
    fill: "#286385",
    style: {
      filter: "url(#filter7253)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m184.4 284.27s-14.85-7.336-23.389-4.66-16.178 9.263-16.178 9.263 8.794 9.221 22.135 5.376c13.348-3.837 17.432-9.979 17.432-9.979z",
    fill: "#286385",
    style: {
      filter: "url(#filter7251)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m214.21 295.04s-2.253-15.207 7.705-21.497c8.531-5.187 13.167-4.306 13.167-4.306s1.79 7.221-1.782 14.87c-3.572 7.64-19.09 10.933-19.09 10.933z",
    fill: "#286385",
    style: {
      filter: "url(#filter7249)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m201.07 308.55s-4.917-7.69-12.746-7.624c-8.061.198-13.192 5.986-13.192 5.986s3.696 8.488 12.606 7.896c8.918-.585 13.332-6.258 13.332-6.258z",
    fill: "#286385",
    style: {
      filter: "url(#filter7247)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m172.77 236.83s-9.191-12.218-8.25-19.826c.94-7.608 6.69-12.663 6.69-12.663s7.615 6.052 8.069 14.038c.454 7.978-6.509 18.451-6.509 18.451z",
    fill: "#286385",
    style: {
      filter: "url(#filter7245)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m361.54 427.82s-29.485 18.879-55.993 13.314c-26.507-5.566-47.503-19.373-47.503-19.373s21.409-16.796 38.239-19.126 36.861 10.497 36.39 9.056c-.47-1.441-25.302-18.13-31.977-32.546-6.674-14.417-9.528-44.831-9.528-44.831s26.301 8.547 35.871 19.135 23.124 35.963 23.124 35.963-11.088-22.469-8.505-45.292c2.59-22.823 21.169-47.136 21.169-47.136s17.647 21.07 18.695 47.359c1.056 26.289-10.511 47.926-10.511 47.926s17.589-25.449 31.367-32.975c13.777-7.525 38.552-2.058 38.552-2.058s-12.515 30.356-27.068 40.179c-14.553 9.822-31.416 13.428-31.416 13.428s22.357-7.509 38.585-3.326c16.228 4.182 33.858 18.451 33.858 18.451s-29.659 14.655-52.718 11.691c-23.075-2.956-40.631-9.839-40.631-9.839z",
    fill: "url(#paint9_linear_0_1)",
    style: {
      filter: "url(#filter7243)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m389.29 408.96c-4.158.996-6.864 1.893-6.864 1.893s2.706-.584 6.864-1.893z",
    fill: "url(#paint10_linear_0_1)",
    style: {
      filter: "url(#filter7241)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m301.96 349.8s22.465 50.569 56.9 69.696c-6.196-6.571-20.146-16.648-31.828-33.313-11.691-16.664-25.072-36.383-25.072-36.383z",
    fill: "url(#paint11_linear_0_1)",
    style: {
      filter: "url(#filter7239)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m358.97 421.91s-50.828 3.038-71.585 1.087c-15.279-1.071-22.482-1.812-22.482-1.812s12.887 4.586 45.326 5.426c32.431.848 48.741-4.701 48.741-4.701z",
    fill: "url(#paint12_linear_0_1)",
    style: {
      filter: "url(#filter7237)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m188.36 356.67s32.456-13.157 43.181-37.988c10.717-24.824 11.525-49.903 11.525-49.903s-26.095 7.773-37.711 20.147c-11.607 12.375-12.655 36.112-13.563 34.893-.907-1.218-.255-31.081-8.208-44.839-7.953-13.749-31.21-33.616-31.21-33.616s-8.168 26.371-5.016 40.277c3.151 13.906 16.112 39.586 16.112 39.586s-12.004-21.999-32.175-33.049c-20.179-11.04-50.795-9.912-50.795-9.912s7.0785 26.536 27.992 42.549c20.914 16.014 45.293 19.061 45.293 19.061s-30.979-.33-45.078 6.57c-14.1 6.891-23.909 30.249-23.909 30.249s32.076 7.295 48.51 1.087c16.434-6.2 29.106-17.875 29.106-17.875s-19.041 13.898-24.964 29.55c-5.924 15.643-4.414 38.243-4.414 38.243s29.098-15.733 39.963-36.243c10.873-20.509 15.361-38.787 15.361-38.787z",
    fill: "url(#paint13_linear_0_1)",
    style: {
      filter: "url(#filter7235)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m156.92 368.42c3.218-2.816 5.503-4.504 5.503-4.504s-2.038 1.869-5.503 4.504z",
    fill: "url(#paint14_linear_0_1)",
    style: {
      filter: "url(#filter7233)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m216.19 426.55s31.061 16.171 56.966 8.25c25.897-7.92 45.573-23.539 45.573-23.539s-22.828-14.82-39.798-15.635-35.772 13.758-35.425 12.276c.346-1.474 23.57-20.32 28.924-35.272 5.354-14.951 5.462-45.505 5.462-45.505s-25.427 10.86-34.007 22.263-19.8 37.889-19.8 37.889 9.026-23.366 4.406-45.867c-4.629-22.494-25.32-45.045-25.32-45.045s-15.683 22.559-14.363 48.84c1.312 26.273 14.768 46.79 14.768 46.79s-19.809-23.769-34.197-30.035c-14.396-6.266-38.585 1.4-38.585 1.4s15.197 29.121 30.575 37.601c15.369 8.481 32.496 10.564 32.496 10.564s-22.943-5.484-38.733.14c-15.783 5.623-32.06 21.406-32.06 21.406s30.855 11.947 53.551 6.924c22.704-5.022 39.567-13.445 39.567-13.445z",
    fill: "url(#paint15_linear_0_1)",
    style: {
      filter: "url(#filter7231)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m203.17 296.36s20.691 22.551 25.319 45.045c4.62 22.493-4.405 45.867-4.405 45.867s11.22-26.486 19.8-37.889 34.006-22.263 34.006-22.263-.115 30.554-5.461 45.505c-5.355 14.952-28.578 33.798-28.925 35.272-.346 1.482 18.464-13.099 35.426-12.276 16.97.815 39.798 15.635 39.798 15.635s-19.677 15.627-45.573 23.539c-25.905 7.921-56.967-8.25-56.967-8.25s-.288.149-.833.404c2.64-57.362-12.185-130.59-12.185-130.59z",
    fill: "#286385",
    opacity: 0.3,
    style: {
      filter: "url(#filter7229)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m186.86 410.24c4.233.626 7.005 1.276 7.005 1.276s-2.756-.337-7.005-1.276z",
    fill: "url(#paint16_linear_0_1)",
    style: {
      filter: "url(#filter7227)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m268.52 343.51s-17.837 52.372-50.408 74.504c5.586-7.098 18.571-18.386 28.71-36.03 10.148-17.635 21.698-38.474 21.698-38.474z",
    fill: "url(#paint17_linear_0_1)",
    style: {
      filter: "url(#filter7225)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m218.23 420.43s50.903-1.515 71.396-5.319c15.122-2.429 22.234-3.812 22.234-3.812s-12.425 5.714-44.649 9.46c-32.233 3.747-48.981-.329-48.981-.329z",
    fill: "url(#paint18_linear_0_1)",
    style: {
      filter: "url(#filter7223)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m213.5 419.29s-19.215-19.892-37.084-32.909c-17.861-13.025-38.23-20.213-38.23-20.213s26.746 15.989 36.778 23.177c10.024 7.188 38.536 29.945 38.536 29.945z",
    fill: "url(#paint19_linear_0_1)",
    style: {
      filter: "url(#filter7221)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m211.4 180.22s3.465 17.101-14.223 26.446c-5.915 2.05-16.953 2.239-23.083-3.598 9.001 4.363 17.011 5.096 22.935 2.791 3.358-2.808 13.027-6.471 14.371-25.639z",
    fill: "#353535",
    style: {
      filter: "url(#filter7219)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m201.92 181.98s3.869 14.631-4.983 24.305c-8.786-1.935-16.063-8.628-18.183-13.387 2.846 3.268 10.618 10.983 17.779 12.712 3.349-5.632 6.674-12.745 5.387-23.63z",
    fill: "#353535",
    style: {
      filter: "url(#filter7217)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m195.92 190.05s4.471 10.152 1.328 15.882c-1.675-.98-9.743-8.266-12.028-19.422 3.349 6.224 4.529 11.773 11.533 17.8.891-3.804-.536-12.737-.833-14.26z",
    fill: "#353535",
    style: {
      filter: "url(#filter7215)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m211.61 183.93s2.566-1.507 2.854-5.352c.281-3.853-2.004-5.228-3.201-3.582-.519-1.16-1.039-.584-1.047.165-.718-.724-2.145-.766-2.327.914-.181 1.68 1.279 7.509 3.721 7.855z",
    fill: "url(#paint20_linear_0_1)",
    style: {
      filter: "url(#filter7213)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m202.17 184.98s2.929-1.836 1.584-6.142c-.833-2.215-1.972-2.388-2.236-1.803-.322-.263-1.691-.469-1.765.708-.685-.362-1.865.609-1.543 1.976s1.081 4.594 3.96 5.261z",
    fill: "url(#paint21_linear_0_1)",
    style: {
      filter: "url(#filter7211)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m196.75 193.55s2.327-1.547.974-5.228c-.867-2.503-2.088-1.663-2.104-1.136-.47-.7-1.262-.568-1.353.049-.677-.321-1.535.643-1.213 2.001.314 1.367 1.32 4.133 3.696 4.314z",
    fill: "url(#paint22_linear_0_1)",
    style: {
      filter: "url(#filter7209)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m186.53 189.99s2.244-1.07 1.625-4.52c-.61-3.441-2.508-5.623-3.217-4.24-.693-.527-1.857-1.531-2.913.461-1.262.297-1.056 2.248-.495 3.68.553 1.433 2.599 4.718 5 4.619z",
    fill: "url(#paint23_linear_0_1)",
    style: {
      filter: "url(#filter7207)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m178.2 205.48s.668-2.388-2.335-4.191-5.898-1.812-5.313-.371c-.849.173-2.376.387-1.567 2.495-.611 1.144.998 2.272 2.45 2.799 1.436.511 5.264 1.137 6.765-.732z",
    fill: "url(#paint24_linear_0_1)",
    style: {
      filter: "url(#filter7205)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m180.68 195.21s1.081-1.095-.256-3.449c-.874-1.762-3.589-4.743-4.009-2.462-1.263.025-2.706-.305-2.104 2.248-1.147.666-.124 1.877 1.039 3.054 1.164 1.186 4.191 1.589 5.33.609z",
    fill: "url(#paint25_linear_0_1)",
    style: {
      filter: "url(#filter7203)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m197.74 204.85s.049.09.14.263c1.559 2.989 15.436 30.175 9.867 38.606.553-4.289-.124-9.658-3.935-20.484-3.812-10.827-7.277-17.62-7.277-17.62l1.262-.675",
    fill: "#353535",
    style: {
      filter: "url(#filter7201)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m333.92 186.11s-3.465 17.1 14.223 26.445c5.924 2.05 16.954 2.24 23.084-3.598-9.001 4.364-17.012 5.096-22.935 2.791-3.35-2.799-13.019-6.463-14.372-25.638z",
    fill: "#353535",
    style: {
      filter: "url(#filter7199)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m343.4 187.88s-3.869 14.63 4.983 24.304c8.787-1.934 16.063-8.628 18.183-13.387-2.846 3.269-10.617 10.983-17.778 12.712-3.35-5.631-6.666-12.745-5.388-23.629z",
    fill: "#353535",
    style: {
      filter: "url(#filter7197)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m349.4 195.95s-4.471 10.152-1.328 15.882c1.675-.979 9.743-8.266 12.029-19.422-3.35 6.224-4.53 11.774-11.534 17.8-.883-3.803.545-12.737.833-14.26z",
    fill: "#353535",
    style: {
      filter: "url(#filter7195)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m333.7 189.83s-2.565-1.507-2.854-5.352c-.281-3.853 2.005-5.228 3.201-3.581.52-1.161 1.039-.585 1.048.164.717-.724 2.145-.765 2.326.914.19 1.68-1.279 7.501-3.721 7.855z",
    fill: "url(#paint26_linear_0_1)",
    style: {
      filter: "url(#filter7193)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m343.16 190.88s-2.929-1.836-1.584-6.142c.833-2.214 1.972-2.387 2.236-1.803.321-.263 1.691-.469 1.765.708.685-.362 1.865.61 1.543 1.976-.322 1.367-1.081 4.595-3.96 5.261z",
    fill: "url(#paint27_linear_0_1)",
    style: {
      filter: "url(#filter7191)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m348.57 199.46s-2.326-1.548-.973-5.228c.866-2.503 2.087-1.664 2.103-1.137.471-.699 1.263-.568 1.353.05.677-.321 1.535.642 1.213 2-.313 1.359-1.328 4.134-3.696 4.315z",
    fill: "url(#paint28_linear_0_1)",
    style: {
      filter: "url(#filter7189)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m358.79 195.88s-2.244-1.07-1.625-4.52c.61-3.441 2.508-5.623 3.217-4.24.693-.527 1.856-1.531 2.912.461 1.263.297 1.056 2.248.503 3.681-.561 1.44-2.615 4.725-5.007 4.618z",
    fill: "url(#paint29_linear_0_1)",
    style: {
      filter: "url(#filter7187)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m367.13 211.38s-.668-2.388 2.335-4.191 5.898-1.811 5.313-.371c.849.173 2.376.387 1.567 2.495.611 1.144-.998 2.272-2.45 2.799-1.444.519-5.264 1.145-6.765-.732z",
    fill: "url(#paint30_linear_0_1)",
    style: {
      filter: "url(#filter7185)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m364.64 201.11s-1.081-1.095.256-3.45c.874-1.762 3.589-4.742 4.009-2.462 1.263.025 2.706-.304 2.104 2.248 1.147.667.124 1.877-1.039 3.054-1.164 1.186-4.191 1.589-5.33.61z",
    fill: "url(#paint31_linear_0_1)",
    style: {
      filter: "url(#filter7183)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m347.58 210.75s-.05.09-.14.263c-1.56 2.989-15.436 30.175-9.867 38.606-.553-4.289.124-9.658 3.935-20.484 3.812-10.827 7.277-17.62 7.277-17.62l-1.263-.675",
    fill: "#353535",
    style: {
      filter: "url(#filter7181)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m282.62 487.45c133.7 0 242.08-8.518 242.08-19.027 0-10.508-108.38-19.027-242.08-19.027s-242.08 8.519-242.08 19.027c0 10.509 108.38 19.027 242.08 19.027z",
    fill: "#3788B8",
    style: {
      filter: "url(#filter7179)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m189.04 465.09 2.995-9.995s.693-3.104 6.79-3.104h119.11s5.643-.247 7.252 3.902c2.145 5.525 2.764 8.266 2.764 8.266s1.955 4.249-5.297 4.249h-130.39s-3.226.247-3.226-3.318z",
    fill: "url(#paint32_linear_0_1)",
    style: {
      filter: "url(#filter7177)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m192.26 468.42h130.39c5.074 0 5.635-2.083 5.519-3.334h-139.13c0 3.565 3.218 3.334 3.218 3.334z",
    fill: "#353535",
    style: {
      filter: "url(#filter7175)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m402.02 422.71c0 7.607-6.187 13.782-13.81 13.782h-260.55c-7.623 0-13.81-6.175-13.81-13.782v-164.77c0-7.608 6.187-13.783 13.81-13.783h260.55c7.631 0 13.81 6.167 13.81 13.783v164.77z",
    fill: "#353535",
    style: {
      filter: "url(#filter7173)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m127.97 257.63h261.48v148.55h-261.48v-148.55z",
    fill: "#3788B8",
    style: {
      filter: "url(#filter7171)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m127.97 257.63h261.48v28.463h-261.48v-28.463z",
    fill: "url(#paint33_linear_0_1)",
    style: {
      filter: "url(#filter7169)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m328.92 267.79c0 1.367-1.105 2.47-2.475 2.47h-159.39c-1.369 0-2.475-1.103-2.475-2.47s1.106-2.47 2.475-2.47h159.39c1.37 0 2.475 1.103 2.475 2.47z",
    fill: "#286385",
    opacity: 0.5,
    style: {
      filter: "url(#filter7167)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m261.62 278.4c0 1.366-.652 2.47-1.46 2.47h-94.108c-.808 0-1.46-1.104-1.46-2.47 0-1.367.652-2.47 1.46-2.47h94.108c.808 0 1.46 1.103 1.46 2.47z",
    fill: "#286385",
    opacity: 0.5,
    style: {
      filter: "url(#filter7165)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m144.86 282.44c5.855 0 10.601-4.736 10.601-10.579 0-5.844-4.746-10.58-10.601-10.58s-10.601 4.736-10.601 10.58c0 5.843 4.746 10.579 10.601 10.579z",
    fill: "#3788B8",
    style: {
      filter: "url(#filter7163)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m144.51 272.45c2.765 0 5.007-2.237 5.007-4.997s-2.242-4.998-5.007-4.998c-2.766 0-5.008 2.238-5.008 4.998s2.242 4.997 5.008 4.997z",
    fill: "white",
    style: {
      filter: "url(#filter7161)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m152.88 278.76c-1.485-3.137-4.67-5.31-8.374-5.31-3.49 0-6.526 1.926-8.102 4.767 1.931 2.56 5 4.215 8.457 4.215 3.209 0 6.072-1.424 8.019-3.672z",
    fill: "white",
    style: {
      filter: "url(#filter7159)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m276.36 305.06c0 6.801-6.798 12.317-15.188 12.317-8.391 0-15.189-5.516-15.189-12.317 0-6.8 6.798-12.317 15.189-12.317 8.382.008 15.188 5.517 15.188 12.317z",
    fill: "#353535",
    style: {
      filter: "url(#filter7157)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m213.15 406.71s1.791-22.74 18.761-28.759c16.978-6.018 47.578-5.352 59.416 0 11.839 5.352 16.979 12.704 18.538 19.62 1.568 6.908 1.345 9.139 1.345 9.139h-98.06z",
    fill: "#286385",
    style: {
      filter: "url(#filter7155)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m262.87 396.74c8.745 0 15.832-7.04 15.832-15.718 0-2.305-.504-4.487-1.403-6.463-8.695-1.095-19.189-1.186-28.809-.115-.959 2.058-1.455 4.3-1.452 6.57 0 8.686 7.087 15.726 15.832 15.726z",
    fill: "url(#paint34_linear_0_1)",
    style: {
      filter: "url(#filter7153)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m248.49 374.45s4.496-2.734 4.496-8.398c0-5.665 19.693-1.663 19.693-1.663s1.955 8.175 4.628 10.168",
    fill: "url(#paint35_linear_0_1)",
    style: {
      filter: "url(#filter7151)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m244.86 363.02c-3.242-5.903-2.681-7.69-2.681-7.69s-4.133-2.783-4.356-7.467c-.223-4.685 1.114-5.13 1.114-5.13h3.795s.222-7.006 4.298-11.864c4.075-4.858 5.082-5.854 5.082-5.854s7.037 4.133 13.736 5.854 12.953 4.734 14.627 8.184l1.675 3.458s3.911-1.449 4.463 1.111c.561 2.561-.115 7.806-1.567 8.917-1.452 1.112-2.789.889-2.789.889s-1.452 8.25-5.808 13.149c-4.356 4.907-9.24 8.801-13.596 8.801-6.022.009-14.751-6.455-17.993-12.358z",
    fill: "url(#paint36_linear_0_1)",
    style: {
      filter: "url(#filter7149)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m242.18 350.2s-6.031-8.802-6.476-16.944c-.446-8.135 1.336-16.492 5.362-20.065 4.018-3.565 9.719-3.12 9.719-3.12s4.24-4.57 16.302-3.006c12.061 1.565 16.079 8.357 18.983 14.936 2.904 6.578.239 14.663-.561 17.388-.792 2.726-3.02 8.58-3.02 8.58s-.165-6.538-2.706-10.012c-2.541-3.475-9.454-5.755-13.373-6.941-3.919-1.185-9.916-3.614-12.111-4.808l-2.186-1.194s-6.584 6.463-7.763 10.456c-1.172 3.985-2.17 14.73-2.17 14.73z",
    fill: "#353535",
    style: {
      filter: "url(#filter7147)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m254.25 415.98c0-2.034 1.65-3.672 3.679-3.672 2.03 0 3.68 1.646 3.68 3.672 0 2.025-1.65 3.672-3.68 3.672-2.029 0-3.679-1.647-3.679-3.672z",
    stroke: "#231F20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3.6779,
    style: {
      filter: "url(#filter7145)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m113.91 423.94c.619 7.04 6.542 12.556 13.753 12.556h260.55c7.211 0 13.134-5.516 13.753-12.556h-288.06z",
    fill: "url(#paint37_linear_0_1)",
    style: {
      filter: "url(#filter7143)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m245.89 436.5h25.319v20.905h-25.319v-20.905z",
    fill: "url(#paint38_linear_0_1)",
    style: {
      filter: "url(#filter7141)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m278.77 174.31s3.753 3.063 4.884 3.557c1.13.502 5.379 1.128 5.948 2.058.561.939.247 7.995 1.064 10.992s2.376 9.056 1.378 11.617c-.998 2.56-2.756 4.059-2.756 4.932 0 .872-.561 10.365-.561 10.365s-13.018 3.376-20.336 6.744c-7.318 3.367-11.517 6.808-11.517 6.808s2.442-5.681 3.696-10.118c1.254-4.438 3.193-12.12 3.127-14.614-.066-2.495-5.882-30.48-5.882-30.48s2.004.313 3.003.123c.998-.189 5.445-1.811 6.946-2.684 1.502-.873 2.005-1.622 2.005-1.622l9.001 2.322z",
    fill: "url(#paint39_linear_0_1)",
    style: {
      filter: "url(#filter7139)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m296.54 193.99s28.537-2.248 28.289-1.622c-.247.626-6.13 23.358-6.13 23.358l-28.916 3.375 6.757-25.111z",
    fill: "url(#paint40_linear_0_1)",
    style: {
      filter: "url(#filter7137)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m324.83 192.37-.941-.749-28.347 1.432-6.822 25.606 1.064.436 6.757-25.103 28.289-1.622zm-35.929 25.169-10.197-.56v1.433l10.016.247.181-1.12z",
    fill: "#353535",
    style: {
      filter: "url(#filter7135)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m278.7 216.98 10.618-1.004-.421 1.564-10.197-.56z",
    fill: "url(#paint41_linear_0_1)",
    style: {
      filter: "url(#filter7133)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m290.74 210.39s-1.378-.206-3.209 0l-1.832.205s-.503 2.001-.42 3.335c.082 1.334.041 2.001.041 2.001l3.96-.247 1.46-5.294z",
    fill: "url(#paint42_linear_0_1)",
    style: {
      filter: "url(#filter7131)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m262.12 175.94c1.741-.576 4.505-1.647 5.627-2.305 1.501-.873 2.004-1.622 2.004-1.622l9.009 2.313s3.754 3.063 4.884 3.557c.264.115.702.239 1.221.371-.016.041-.033.066-.033.066s-.503 4.931-1.749 7.871c-1.254 2.939-3.069 3.309-5.065 3.556-1.997.247-7.384-4.371-10.387-7.615-2.161-2.339-4.414-4.924-5.511-6.192z",
    fill: "url(#paint43_linear_0_1)",
    style: {
      filter: "url(#filter7129)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m271.88 147.46s-5.132-.815-6.196 1.812c-1.064 2.626-.627 11.493-1.625 14.367-.999 2.873-1.254 4.619-1.436 6.307-.19 1.687-.313 2-1.13 3.062s-1.378 3.121-1.378 3.121.998.313 4.001-.873 5.635-3.244 5.635-3.244l2.129-24.552z",
    fill: "#353535",
    style: {
      filter: "url(#filter7127)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m286.4 156.83s-.751 4.248-1.501 5.993c-.751 1.746-1.064 2.627-1.064 2.627s-.685 4.874-3.564 8.184c-2.88 3.31-4.571 3.12-6.262 2.56-1.691-.559-4.942-3.746-5.322-7.121-.379-3.376-.379-3.689-.379-3.689s-2.318-.189-2.755-2.626c-.438-2.437.247-4.875 1.814-4.306 1.568.559 1.75 4.561 1.75 4.561s2.813-5.871 4.133-6.998c1.311-1.128 5.445-1.746 7.507-1.128 2.079.633 5.643 1.943 5.643 1.943z",
    fill: "url(#paint44_linear_0_1)",
    style: {
      filter: "url(#filter7125)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m286.4 156.82s.816-2.75-1.881-6.496c-2.69-3.746-7.945-5.557-12.012-3.186-4.068 2.371-5.693 6.183-6.006 8.06-.314 1.878-.438 3.434-.438 3.434s.999-.749 1.881.378c.875 1.128 1.189 3.994 1.189 3.994s.998-.313 1.691-2.125c.684-1.811 2.318-4.874 3.696-5.434 1.378-.559 3.877-.938 5.321-.625s6.559 2 6.559 2z",
    fill: "#353535",
    style: {
      filter: "url(#filter7123)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m289.59 179.94s3.193-1.144 4.612 2.1 3.25 10.909 3.25 10.909l-1.922.107-3.589 12.803-.751-1.746s1.502-1.078 1.081-4.75c-.421-3.664-1.922-9.073-2.087-11.074-.157-2.001-.594-8.349-.594-8.349z",
    fill: "url(#paint45_linear_0_1)",
    style: {
      filter: "url(#filter7121)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256.86 231.4s8.803-6.307 15.394-8.554c6.592-2.248 13.687-4.166 13.687-4.166l2.772-.025 1.394.519 13.605-1.746s4.001 4.66 6.756 13.906c2.756 9.246 3.424 16.401 4.092 18.822.669 2.412 2.088 5.08 2.088 5.08s-2.17 1.918-4.422 2.997l-2.253 1.086s-6.088-10.991-7.425-15.659l-1.336-4.661s-1.584-9.41-6.427-10.324-6.674 4.915-8.176 8.324c-1.501 3.417-5.255 7.994-8.01 8.497-2.756.502-14.1.164-16.525-.832-2.417-1.004-5.915-6.043-5.214-13.264z",
    fill: "url(#paint46_linear_0_1)",
    style: {
      filter: "url(#filter7119)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m279.86 245.02c2.541-1.35 5.462-5.105 6.74-8.019 1.502-3.417 3.342-9.246 8.176-8.324 4.843.914 6.427 10.324 6.427 10.324s0 .009.256.906c-.009.107-.009.173-.009.173s.999 8.324.083 14.655c-.916 6.332-3.696 22.815-3.696 22.815s-6.905-.247-6.905-.502c0-.256-.586-9.741-1.172-14.154s-1.171-9.995-1.171-13.576c0-3.582.082-4.66.082-4.66l-8.844.502c.017 0 .025-.05.033-.14z",
    fill: "url(#paint47_linear_0_1)",
    style: {
      filter: "url(#filter7117)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m297.54 277.56s-.247 3.746-.247 5.557c0 1.812.379 7.056-.817 10.556-1.188 3.499-2.442 6.059-5.569 6.372-3.126.313-4.314-1.432-4.446-3.869-.124-2.438.313-5.311 1.567-9.493 1.254-4.183 2.879-6.25 2.879-6.25l.438-3.244 6.195.371z",
    fill: "#353535",
    style: {
      filter: "url(#filter7115)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m289.29 283.3c.875-1.919 1.617-2.866 1.617-2.866l.437-3.244 6.196.379s-.247 3.746-.247 5.558c0 .601.041 1.58.049 2.75-.751-.239-1.609-.527-1.741-.626-.247-.189-1.377-2.124-2.879-1.746-1.501.379-2.194.75-2.194.75l-1.238-.955z",
    fill: "white",
    style: {
      filter: "url(#filter7113)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m316.44 255.58 2.566 3.376s.627 0 1.625.247 7.945 1.622 9.512 1.309c1.568-.313 4.505-.502 5.445.247.941.749 1.188 2.314 1.188 2.314s-3.316 3.433-6.633 4.561c-3.316 1.128-10.329 3.12-11.954 3.812-1.625.683-5.379 1.062-5.379 1.062s-1.501-4.438-1.815-5.994c-.313-1.564.19-4.059.19-4.059l-1.13-3.31c0-.008 4.636-1.696 6.385-3.565z",
    fill: "#353535",
    style: {
      filter: "url(#filter7111)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m319 258.94s-.379 3.12-.874 3.688c-.503.56-2.879 2.058-3.44 1.811s-1.502-1.934-2.005-2-1.501 0-1.501 0l-1.213-3.121s2.59-1.251 4.092-2.124c1.501-.873 2.376-1.622 2.376-1.622l2.565 3.368z",
    fill: "white",
    style: {
      filter: "url(#filter7109)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m285.69 210.61s-13.249-1.309-16.252-2.495-4.571-3.557-4.761-4.932c-.189-1.375-1.064-17.051-1.815-20.295-.75-3.244-2.945-6.62-5.692-6.62-2.756 0-4.191 3.812-4.381 9.683-.19 5.87 1.625 18.484 3.317 22.106 1.691 3.623 4.034 5.113 7.136 6.373 4.76 1.935 22.069 1.523 22.069 1.523s.049-2.972.379-5.343z",
    fill: "url(#paint48_linear_0_1)",
    style: {
      filter: "url(#filter7107)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m384.56 324.94s-5.511 3.31-6.443 5.681c-.941 2.371-3.878 11.617-5.256 16.615-1.377 4.998-4.067 12.926-3.382 14.861s7.507 7.122 7.507 7.122.999-1.375 1.939-2.997c.941-1.622 1.691-2.371 1.691-2.371l-4.257-4.125 6.947-14.861s2.252 5.244 2.689 7.747c.438 2.503.066 7.616-.94 10.119-.998 2.495-4.628 10.621-5.569 14.68-.94 4.059 1.625 30.982 1.625 30.982s5.759 2.058 17.837 1.688c12.078-.379 18.653-2.371 18.653-2.371s-4.818-24.486-5.948-33.164-1.625-16.302-1.625-19.423c0-3.12.437-4.372.437-4.372s.751-1.309 1.13-2.247l.38-.939s4.694 8.497 6.699 9.427c2.004.939 4.628.124 6.195-2.124 1.568-2.248 6.947-10.744 6.947-10.744l-4.884-4.874-5.635 7.121s-6.757-18.426-8.011-20.427c-1.254-2-2.755-3.062-5.065-3.433-2.318-.379-3.251.066-3.251.066l-20.41 2.363z",
    fill: "url(#paint49_linear_0_1)",
    style: {
      filter: "url(#filter7105)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m388.94 333.93s1.568 10.053 2.195 19.677c.627 9.617 0 17.867 0 17.867l-8.514-2.495-.503-21.613-2.5 5.245-.338 9.781 1.295 1.211-1.502 2.206-.082 4.915s-2.376 1.746-3.63 5.5c-1.254 3.755-1.502 7.246-1.502 7.246l.751.502s-.998 5.747-.379 7.616c.627 1.877 3.382 5.623 7.383 6.496 4.002.872 9.892.749 11.765-.124 1.873-.872 2.632-2.997 2.632-5.121s-.38-16.491-2.005-30.233c-1.625-13.741-2.756-26.231-2.756-26.231l-2.31-2.445z",
    fill: "#3788B8",
    style: {
      filter: "url(#filter7103)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m395.45 306.64s1.626-.626 2.376-2.314c.751-1.687 2.005-2.56 3.193-2.996 1.188-.437 3.564-1.688 4.504-3.434.941-1.745 1.568-3.31 1.568-3.31s2.69 2.125 2.945 3.994c.248 1.877-.066 5.055-.066 5.87s1.312 3.499.124 6.373c-1.188 2.873-4.133 7.615-5.198 8.118-1.064.502-2.499 0-2.499 0l-.248 2.626 2.813.996s2.566 5.805 2.566 7.369-1.567 4.059-5.131 3.121c-3.564-.939-5.817-2.997-6.823-4.125-1.007-1.128-1.502-2.001-1.502-2.001s1.188-3.12 1.254-5.245c.066-2.124.124-4.997.124-6.306s-.816-4.125-.816-4.125-3.07-2.561-2.756-4.562c.313-2 2.822-2.107 3.572-.049z",
    fill: "url(#paint50_linear_0_1)",
    style: {
      filter: "url(#filter7101)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m413.78 299.77c-.998-4.059-2.5-6.562-3.943-7.995-1.436-1.433-6.947-1.498-6.947-1.498s-5.255-1.128-9.322.436c-4.068 1.564-8.572 6.743-10.016 14.425-1.435 7.681-.817 14.301.437 18.549 1.254 4.249 3.127 7.493 4.942 10.243s5.569 5.368 5.569 5.187c0-.19-.998-10.432-.437-12.177 0 0 1.188-3.121 1.254-5.245s.123-4.998.123-6.307-.816-4.125-.816-4.125-3.069-2.56-2.756-4.561c.314-2.001 2.813-2.124 3.564-.066 0 0 1.625-.626 2.376-2.313.751-1.688 2.005-2.561 3.193-2.997 1.188-.437 3.564-1.688 4.504-3.434.941-1.745 1.568-3.309 1.568-3.309s2.689 2.124 2.945 3.993c.248 1.877-.066 5.055-.066 5.87s1.312 3.499.124 6.373c-1.188 2.873-4.133 7.616-5.198 8.118-1.064.502-2.499 0-2.499 0l-.248 2.626.47.165c.058-.025.091-.041.091-.041h2.442s3.82-2.437 5.321-5.434c1.51-2.997 4.332-12.424 3.325-16.483z",
    fill: "#353535",
    style: {
      filter: "url(#filter7099)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m377.48 368.41s7.763 5.5 8.2 6.06 2.195 4.685 6.262 5.557c4.067.873 4.15.437 4.15.437s1.979-2.248 1.171-2.997c-.817-.75-3.564-2.059-4.381-2.997-.816-.939-1.666-2.413-1.666-2.413v-1.21l-3.523-.123-7.573-6.431c-.009-.008-2.261 2.989-2.64 4.117z",
    fill: "white",
    style: {
      filter: "url(#filter7097)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m427.23 339.75s2.946-4.685 2.946-4.932-1.131-3.689-.875-5.434c.248-1.746.19-6.43.941-5.936.75.502 1.435 2.058 1.435 2.058l.627.996s10.89-5.368 11.261-5.055c.38.313.751.873.314 1.498-.437.626-3.317 2.372-3.317 2.372s1.312.625.999 1.934c-.314 1.309-.999.626-.999.815 0 .19.124 1.812-.998 3.557-1.13 1.746-4.504 4.685-4.504 4.685l-3.82 6.998-4.01-3.556z",
    fill: "url(#paint51_linear_0_1)",
    style: {
      filter: "url(#filter7095)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m433.74 319.82-4.505 12.803s-.066.872.875.996c.94.123 5.816-.066 5.816-.066s.685-.189.941-1.186c.247-.996 3.506-11.864 3.506-11.864s-.066-.56-.627-.683c-.561-.124-6.006 0-6.006 0z",
    fill: "#353535",
    style: {
      filter: "url(#filter7093)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m433.99 320.95-3.498 10.555 5.255-.066 3.193-10.432-4.95-.057z",
    fill: "white",
    style: {
      filter: "url(#filter7091)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m440.19 325.26s-3.069 1.128-3.753 1.745c-.685.626-.561 1.186-.066 1.309.503.124 4.694-.378 4.694-.378s.503-.313.561-1.252c.058-.938-.809-1.358-1.436-1.424z",
    fill: "white",
    style: {
      filter: "url(#filter7089)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m440.32 328.13s-3.506.066-4.191.684c-.685.625.19 1.432.685 1.564.503.123 3.564-.247 3.564-.247s.998-.066 1.064-.996c.066-.947-.503-.947-1.122-1.005zm-.569 2.248s-2.731.049-3.276.535c-.536.486.149 1.12.537 1.219.387.098 2.78-.198 2.78-.198s.784-.049.833-.782c.058-.725-.388-.725-.874-.774z",
    fill: "white",
    style: {
      filter: "url(#filter7087)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m383.45 408.99s1.419 8.908 1.337 10.744c-.083 1.836-.33 15.405.247 20.32.586 4.915 2.921 17.405 3.086 20.155s-.165 7.995-.504 10.407c-.338 2.413-.668 5.5.165 6.076.834.585 6.262.165 6.592-.329.33-.502-1.749-8.991-1.749-10.991 0-2.001 1.254-19.406 1.419-23.737s-.503-9.246-.247-13.577c.247-4.331.668-8.324 1.336-12.992s.916-4.998.668-4.998c-.255 0-8.093.338-12.35-1.078z",
    fill: "url(#paint52_linear_0_1)",
    style: {
      filter: "url(#filter7085)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m402.06 409.98s2.59 8.991 2.838 12.408c.247 3.417.165 9.073 1.584 13.494 1.419 4.413 7.095 14.82 8.258 17.57 1.171 2.75 2.087 5.08 1.501 6.332-.585 1.251-1.08 1.498-1.584 2.832-.503 1.334.33 3.161.33 3.161s5.511.75 6.84 2.586c1.336 1.836 4.257 4.997 5.593 5.327 1.337.329 3.754.164 4.422-.165s.586-1.416-.916-2.001c-1.501-.584-2.92-.996-3.918-2.494-.999-1.499-5.091-8.324-5.841-11.239-.751-2.915-6.18-34.975-6.089-37.643.083-2.667.421-2.412.083-6.249-.339-3.837-.421-5.5-.421-5.5s-9.76 1.754-12.68 1.581z",
    fill: "url(#paint53_linear_0_1)",
    style: {
      filter: "url(#filter7083)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m416.47 474.09 1.312.066s.247-6.06.817-5.994c.561.066 2.689.313 4.067 2.19s2.945 3.935 4.257 4.059c1.311.123 5.634.066 5.816-.066.19-.124.644-.749-.899-.815s-4.802-.066-4.802-.066-3.003-2.314-3.753-3.433c-.751-1.128-1.568-2.495-3.383-3.121s-4.925-1.128-4.925-1.128-.52 1.128-.206 1.499c.313.378 1.253.938 1.377 2 .14 1.063.322 4.809.322 4.809z",
    fill: "url(#paint54_linear_0_1)",
    style: {
      filter: "url(#filter7081)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m422.05 468.15s.874-.123 1.749-.872c.874-.75 1.13-1.622 1.13-1.622s2.318 4.125 3.25 4.619c.933.494 3.441 1.128 3.82 1.811.38.683-.148 1.433-.148 1.433s-3.738.502-4.802-.066c-1.064-.56-5.214-5.105-5.214-5.105",
    fill: "url(#paint55_linear_0_1)",
    style: {
      filter: "url(#filter7079)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m387.62 470.61s2.566 1.293 4.067.667c1.502-.625 1.749-1.185 1.749-1.185s.875 4.874.875 5.434.817.996-1.312 1.309c-2.128.313-5.511.313-5.692-.749-.182-1.063.313-5.476.313-5.476z",
    fill: "url(#paint56_linear_0_1)",
    style: {
      filter: "url(#filter7077)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m411.96 347.55s1.856-1.688 1.526-5.681c-.33-3.994-2.005-10.325-3.003-13.66-.998-3.334 5.841 22.486 9.512 24.313 3.672 1.828 6.006.503 6.006.503s-2.499 4.833-6.171 4.33c-3.671-.502-7.68-9.163-7.68-9.163",
    fill: "url(#paint57_linear_0_1)",
    style: {
      filter: "url(#filter7075)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m95.197 333.08s-1.8398 12.654-3.8363 25.4c-1.9965 12.745-2.838 17.24-2.4172 18.986.4207 1.745.9157 2.412.9157 2.165s11.6-42.056 11.6-42.303-3.8364-4.166-3.8364-4.166l-2.4255-.082z",
    fill: "url(#paint58_linear_0_1)",
    style: {
      filter: "url(#filter7073)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m109.14 317.84s-.585 2.667.751 4.084c1.337 1.416 6.006 1.416 7.763.082 1.749-1.334 4.67-4.751 4.67-4.751s7.507.165 9.091 2.915 3.754 10.16 2.088 18.154c-1.667 7.995-5.676 20.485-7.681 26.652-2.005 6.166-3.168 10.077-3.506 12.572-.33 2.495-.248 5.582-.248 5.582s-7.012 1.836-19.363-2.165c-12.35-4.002-13.431-4.66-13.431-4.66s2.673-8.662 4.3395-18.566c1.6665-9.905 3.5063-24.486 3.5063-24.486l-2.838-.503s4.8427-11.156 9.5118-13.321c4.678-2.174 5.346-1.589 5.346-1.589z",
    fill: "url(#paint59_linear_0_1)",
    style: {
      filter: "url(#filter7071)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m121.98 317.34s-.082-2.083.083-4.833.247-3.417.247-3.417 3.251-4.084 3.168-5.994c-.082-1.918-1.839-1.918-2.755-.914-.916.996-2.087 1.918-2.087 1.918l-1.337-.164-4.76-3.499s0-4.413-.998-4.578c-.999-.165-4.175.831-5.256.42-1.089-.42-1.839-.996-1.839-.667s-1.502 4.833-1.419 6.331c.082 1.499 1.254 2.586 1.08 3.417-.165.832-.75 3.664-.503 4.413.248.749 2.17 1.663 2.17 1.663s.082 4.66.586 5.5c.503.832.75.914.75.914s-.75 3.244 1.337 4.578c1.303.831 4.125 1.441 6.839 0 1.65-.873 2.945-2.618 4.694-5.088z",
    fill: "url(#paint60_linear_0_1)",
    style: {
      filter: "url(#filter7069)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m125.49 303.11c-.082-1.918-1.84-1.918-2.755-.914-.916.996-2.088 1.918-2.088 1.918l-1.336-.164-4.76-3.499s0-4.413-.999-4.578c-.998-.165-4.174.831-5.255.42-1.089-.42-1.84-.996-1.84-.667 0 0-.668-.247-1.254-1.334-.585-1.078-.915-2.412.248-3.746 1.171-1.334 9.512-3.417 12.433-2.915 2.92.503 6.756 2.083 7.845 5.747s-.082 10.662-.082 10.662l-.347.107c.132-.395.207-.741.19-1.037z",
    fill: "#353535",
    style: {
      filter: "url(#filter7067)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m90.405 376.89s-1.881 10.366-5.0077 22.238c-3.1268 11.864-4.5045 18.237-3.5063 21.613.9983 3.375 11.517 16.862 12.771 18.862 1.254 2.001 17.77 17.867 17.77 17.867s3.383-5.747 4.761-11.239l1.377-5.5s-20.905-18.862-20.905-19.365c0-.502.5033-9.122.5033-9.122s1.749-24.354 1.5015-24.733-6.7568-9.74-6.7568-9.74l-2.508-.881z",
    fill: "url(#paint61_linear_0_1)",
    style: {
      filter: "url(#filter7065)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m118.56 440.72s2.252.543 2.252 1.21-1.501 7.995-1.419 10.16c.083 2.166.586 7.328-.668 10.909-1.254 3.582-3.589 5.583-4.925 5.08-1.337-.502-1.922-1.169-1.502-2.585.421-1.416 2.088-5.409 1.667-6.578s-1.172-2.001-1.172-2.001 4.851-9.575 5.767-16.195z",
    fill: "#353535",
    style: {
      filter: "url(#filter7063)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m121.15 383.38s-2.335 7.665-3.836 12.161c-1.502 4.495-2.879 9.452-5.255 27.442-2.376 17.989-6.881 44.468-6.881 44.468s-3.63.502-7.887-.503c-4.257-1.004-6.2618-2.749-6.2618-2.749s6.2618-34.852 7.0125-50.841c.7508-15.989.5033-21.736-.7507-23.737s-3.5062-5.368-4.1332-7.995c-.627-2.626-.2476-3.869-.2476-3.869s16.805 6.998 28.24 5.623z",
    fill: "url(#paint62_linear_0_1)",
    style: {
      filter: "url(#filter7061)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m104.21 467.66s.504 2.001-.082 2.413c-.586.42-2.838 1.498-4.092 2.33-1.254.831-3.4238 2.997-7.6808 3.664s-4.5045.749-5.841.247c-1.3365-.503-2.5905-1.416-2.5905-1.416s.0825-1.499 1.5015-2.997c1.419-1.499 5.3378-4.166 5.841-5.327.5033-1.169.8333-1.746.8333-1.746s4.1002 3.162 12.11 2.832z",
    fill: "#353535",
    style: {
      filter: "url(#filter7059)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m117.56 334.16s-6.385 14.491-7.383 14.614c-.999.124-19.528-1.745-21.533-4.619-2.0047-2.873-3.1267-9.493-4.0012-9.995s-1.5015-.379-1.5015-.379.0412 6.291-.2063 6.538-2.9205.502-4.1745-.247c-1.254-.75-3.3412-2.001-4.3395-2.166-.9982-.164-2.5905.503-1.9222 1.334.6682.832 2.3347 2.33 2.3347 2.33s.0825 3.829 3.2505 5.912 8.844 4.33 8.844 4.33 18.191 7.913 22.193 8.242c4.001.329 5.337-.502 7.68-2.165 2.335-1.664 8.176-9.164 10.849-13.24 2.673-4.083 2.756-5.746 2.756-5.746s-8.085-.906-12.846-4.743z",
    fill: "url(#paint63_linear_0_1)",
    style: {
      filter: "url(#filter7057)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m82.938 340.33c-.2475.247-2.9205.502-4.1745-.247s-3.3412-2.001-4.3395-2.165c0 0-2.2522-7.246-2.2522-7.995s9.009-.831 9.4297-.584c.4208.247 1.5428 4.454 1.5428 4.454s.0412 6.29-.2063 6.537z",
    fill: "#353535",
    style: {
      filter: "url(#filter7055)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m121.15 323.09-4.34 11.329s4.34 2.166 8.68 3.5c4.339 1.333 5.675 1.169 5.675 1.169s2.005-4.166 2.17-12.326",
    fill: "url(#paint64_linear_0_1)",
    style: {
      filter: "url(#filter7053)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m97.622 333.17s2.3347-7.748 3.5059-9.913c1.172-2.165 1.667-3.161 1.667-3.161s-3.5064 3.161-6.0062 7.665c-2.4997 4.495-2.4997 4.997-2.4997 4.997s2.1615.832 3.333.412z",
    fill: "url(#paint65_linear_0_1)",
    style: {
      filter: "url(#filter7051)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m179.39 232.6s-19.296-9.221-22.308-9.304c-3.011-.082-6.179 2.248-6.872 4.413-.693 2.166.776 6.735 3.63 10.103 2.855 3.367 5.099 4.33 10.577 7.854s10.881 8.818 18.76 9.781c7.879.964 11.732-.403 18.917-.156 7.178.239 16.137-2.404 19.528-4.891 3.399-2.486 8.415-5.689 11.501-7.533 3.085-1.844 6.022-5.615 7.639-8.093 1.625-2.487 2.624-6.974 1.774-8.497s-3.399-3.928-6.485-3.047c-3.085.881-23.083 9.222-23.083 9.222l-33.578.148z",
    fill: "url(#paint66_linear_0_1)",
    style: {
      filter: "url(#filter7049)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m189.81 185.3s-11.657 2.725-13.513 4.413c-1.856 1.68-5.099 4.973-5.866 9.617-.775 4.652-.388 10.02-.388 10.02s1.081 1.523 5.94 2.247c4.868.725 4.249.56 4.249.56l-.85 20.444s.85 3.367 9.339 4.413c8.49 1.045 16.368.321 19.916-.964 3.547-1.284 4.628-3.367 4.628-3.367s.619-11.782.85-15.149c.231-3.368.388-5.047.074-5.13-.305-.082 3.704-.477 7.491-2.807 3.787-2.322 4.628-3.047 4.628-3.047s-.156-13.305-4.479-16.351-13.935-5.533-17.664-5.854c-3.704-.329-14.355.955-14.355.955z",
    fill: "url(#paint67_linear_0_1)",
    style: {
      filter: "url(#filter7047)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m189.94 184.03-.346 4.693s2.78 3.491 6.889 3.491c4.108 0 8.109-3.968 8.109-3.968l-.404-3.911",
    fill: "url(#paint68_linear_0_1)",
    style: {
      filter: "url(#filter7045)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m186.7 171.17s-1.386-.659-1.501.724c-.116 1.384.693 5.113 1.386 5.41.693.304 1.155.42 1.155.42s.693 3.911 1.097 4.931c.404 1.021 4.801 4.875 6.022 5.229 1.213.362 4.167.477 5.734-.305 1.568-.782 4.224-3.968 5.041-5.772.808-1.803.866-4.149.866-4.149s1.155-.124 1.502-1.441c.346-1.326.924-5.047.173-5.475-.751-.42-.347-4.389-2.03-5.171s-15.807-4.989-16.846-3.845c-1.04 1.145-1.799 3.73-1.914 4.512-.107.782-.685 4.932-.685 4.932z",
    fill: "url(#paint69_linear_0_1)",
    style: {
      filter: "url(#filter7043)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m188.41 175.91s-.157-4.89-.075-5.129c.075-.239.924-4.166.924-4.166s2.162 1.441 8.646 1.605c6.485.157 7.566-.156 7.566-.156v8.019l.775-.156s.157-4.331.924-4.57c.776-.239 1.081-.239 1.081-.239s.074-9.863-.305-11.46c-.388-1.606-3.474-3.928-5.866-4.413-2.393-.478-11.501.082-14.355 2.404-2.855 2.322-2.467 3.211-2.549 5.936-.075 2.725.305 7.533.305 7.533s1.312-.238 1.468.322c.157.559.537 4.248.537 4.248l.924.222z",
    fill: "#353535",
    style: {
      filter: "url(#filter7041)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m170.2 209.58c-.165-.074.462 4.874 2.318 11.963 1.857 7.097 2.55 9.081 3.127 9.682.578.601 3.589.906 5.676.058 2.087-.84 6.6-4.57 8.63-7.517 2.029-2.948 4.05-5.533 4.05-5.533l.116-9.139 5.907-.42s-1.155-1.26-2.203-1.507c-1.039-.238-5.503 2.166-5.503 2.166l-3.242 7.212-7.12 2.824-.635-7.336c0 .017-5.041.256-11.121-2.453z",
    fill: "url(#paint70_linear_0_1)",
    style: {
      filter: "url(#filter7039)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m203.89 225.82c0 .263-.206.477-.462.477h-8.918c-.062-.001-.123-.014-.179-.038-.057-.025-.108-.061-.151-.105s-.077-.097-.099-.154c-.023-.057-.034-.119-.033-.18v-16.417c0-.264.206-.478.462-.478h8.918c.256 0 .462.214.462.478v16.417z",
    fill: "#353535",
    style: {
      filter: "url(#filter7037)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m194.75 210h1.04v.963h-1.04v-.963z",
    fill: "white",
    style: {
      filter: "url(#filter7035)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m185.08 236.52s1.856 2.585 6.831 3.31c4.983.724 11.814-.124 13.142-.963 1.329-.84 1.568-2.289 1.568-2.289s-9.62 2.527-21.541-.058z",
    fill: "url(#paint71_linear_0_1)",
    style: {
      filter: "url(#filter7033)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m193.76 237.31h6.427v3.549h-6.427v-3.549zm-2.565 10.597c-.306 0-14.512 1.202-16.443 2.165-1.93.963-3.399 2.964-1.625 5.294 1.774 2.322 5.33 3.368 9.653 2.643s13.818-4.166 13.818-4.166l-.462-1.202-4.941-4.734z",
    fill: "#353535",
    style: {
      filter: "url(#filter7031)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m182.4 238.29c-6.873-3.606-25.782-14.672-25.782-14.672s-.099-.115-.28-.288c-2.772.272-5.495 2.388-6.13 4.38-.693 2.166.776 6.735 3.63 10.103 2.384 2.807 4.348 3.952 8.11 6.298.569.272 1.089.502 1.534.675 4.711 1.845 21.772 10.103 21.772 10.103s1.543-.799 3.704-3.928c2.162-3.128 1.312-7.937 1.312-7.937s-1.006-1.128-7.87-4.734z",
    fill: "url(#paint72_linear_0_1)",
    style: {
      filter: "url(#filter7029)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m190.5 243.74 9.496 4.569s-1.155 0-1.543 1.606c-.388 1.605.074 2.642.074 2.642h-1.93l-7.26-2.404c.008 0 1.782-3.845 1.163-6.413z",
    fill: "url(#paint73_linear_0_1)",
    style: {
      filter: "url(#filter7027)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m196.14 252.64s1.006 2.322 2.161 2.725 10.733 2.643 15.056 2.569c4.323-.083 6.716-.964 7.178-4.01s-2.005-3.771-4.868-4.166c-2.854-.403-15.666-1.441-15.666-1.441s-1.386.478-1.543 1.606c-.157 1.119-.231 2.569-.231 2.569l-2.087.148z",
    fill: "#353535",
    style: {
      filter: "url(#filter7025)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m196.14 246.46c.231-.157 6.179-3.368 6.179-3.368l.775 5.451-3.085-.239-3.869-1.844z",
    fill: "url(#paint74_linear_0_1)",
    style: {
      filter: "url(#filter7023)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m236.87 223.06c-7.31 3.458-34.262 19.883-34.559 20.031l.775 5.451s6.254.963 10.577 1.12c3.679.139 5.733 1.374 6.261 1.737.652-.338 1.221-.684 1.683-1.021 3.399-2.487 8.415-5.689 11.501-7.534 3.085-1.844 6.022-5.615 7.639-8.093 1.626-2.487 2.624-6.974 1.774-8.497-.759-1.383-2.937-3.491-5.651-3.194z",
    fill: "url(#paint75_linear_0_1)",
    style: {
      filter: "url(#filter7021)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m193.01 213.68c-.289.42-.693 1.021 0 1.86.693.84.635 1.145.635 1.145s-.866.84-.866 1.68c0 .839.404 1.564.404 1.564s-.347 1.202-.173 1.564l.173.362s-.982 1.441 1.039 2.586c2.03 1.144 8.688 3.548 8.688 3.548s6.022 3.129 11.987 3.911 8.86-1.144 9.553-2.404 1.741-9.139 1.914-13.165c.174-4.026-.231-9.682-.231-9.682s-1.848 2.223-6.426 3.91c-4.571 1.68-4.86 1.507-4.86 1.68 0 .181.174 6.554.405 7.813.231 1.26.693 2.347.693 2.347s-4.926.058-6.831.181c-1.914.124-3.243-.058-3.243-.058s1.213-2.766.578-4.388-1.213-3.063-1.097-3.911c.115-.84 0-1.202-.289-1.202s-1.271.305-1.386 1.145c-.116.839-.116 4.149-.116 4.149s-10.263-5.055-10.551-4.635z",
    fill: "url(#paint76_linear_0_1)",
    style: {
      filter: "url(#filter7019)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m208.48 460.8s-.998.832-3.671 1.169l-2.673.33s.586-4.998-.668-6.167-7.26-4.084-8.844-11.741 1.254-16.318 7.342-19.151c6.089-2.832 11.262-3.079 15.271.247 4.001 3.335 6.344 8.991 6.674 13.24.33 4.248.248 6.907.248 6.907l-13.679 15.166z",
    fill: "#353535",
    style: {
      filter: "url(#filter7017)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m212.49 455.39s-4.422-3.746-5.841-3.499-4.002 2-4.926.914c-.915-1.079-1.419-3.335-1.749-3.5-.33-.164-.998-.584-.915-1.078.082-.502.668-1.087.668-1.087s-.998.585-1.172-.082c-.165-.667-.165-1.416-.165-1.416s-2.004.247-1.749-.997c.248-1.251 1.172-3.993.834-4.997-.33-.997-1.923-3.911 0-6.332 1.922-2.412 6.006-5.244 9.429-.749 3.424 4.495 4.175 6.998 6.18 8.414 2.004 1.417 3.085 2.413 2.499 3.5-.585 1.078-1.501 2.585-1.501 3.499s.082 2.75.082 2.75l-.247 6.661-1.427-2.001z",
    fill: "url(#paint77_linear_0_1)",
    style: {
      filter: "url(#filter7015)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m179.36 468.71s-.998 2.413 1.502 3.994c2.499 1.58 25.863 4.495 26.952 3.91 1.081-.584 6.427-10.077 6.427-10.077l-.247-10.992-1.502-.164s-2.755 2.412-4.587 6.166c-1.831 3.746-5.09 9.658-5.09 9.658s-9.1-.585-10.181-1.918c-1.08-1.334-2.59-3.911-3.836-3.911-1.254 0-3.506-.082-3.506-.082l-5.932 3.416z",
    fill: "url(#paint78_linear_0_1)",
    style: {
      filter: "url(#filter7013)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m218.41 445.07s-3.589 2.586-4.002 5.245c-.42 2.668-.33 15.322-.165 16.236s5.091 15.742 8.597 15.907 6.171-2.997 11.096-2.585c4.925.42 16.442 1.086 20.609 1.251 4.174.165 5.42.42 5.42.42l.082-18.401s-6.509 1.416-11.096-.33c-4.587-1.745-9.091-5.911-11.517-8.497-2.417-2.585-8.093-8.414-19.024-9.246z",
    fill: "url(#paint79_linear_0_1)",
    style: {
      filter: "url(#filter7011)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m216.28 447.68s-.874 2.001-.874 6.867-.248 22.107-.248 22.107-7.26.461-11.682-.124c-4.422-.584-9.43-2.33-9.43-2.33s-1.336-2.33-3.25-3.746c-1.922-1.416-5.008-5.08-5.338-4.833s-.33.831.083 2.495c.412 1.663.915 3.079.915 3.079s-3.003.165-3.506-.667-2.59-6.331-2.59-6.331-.586.996-.834 2.412c-.247 1.416.586 6.076 2.756 7.747 2.17 1.664 6.757 2.833 10.593 4.084 3.836 1.252 16.69 3.417 21.862 3.746 5.173.33 6.84.42 7.343-.082s4.257-15.66 4.422-22.065c.165-6.414-.833-12.243-4.175-13.404-3.333-1.161-5.42.09-6.047 1.045z",
    fill: "url(#paint80_linear_0_1)",
    style: {
      filter: "url(#filter7009)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m181.03 466.05s-4.257-6.331-4.257-6.825 4.587.329 4.587.329l4.092 6.076s-.247 1.169-.082 1.836.421 1.746.421 1.746l-3.342-.083-1.419-3.079z",
    fill: "url(#paint81_linear_0_1)",
    style: {
      filter: "url(#filter7007)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m260.05 463.14s8.803-4.701 14.058-4.454 10.643 5.368 14.768 6.496c4.133 1.128 13.018 2.997 13.018 2.997l-.627 14.491s-24.28.379-32.043 0-9.264-1.128-9.264-1.128-.454-15.199.09-18.402z",
    fill: "url(#paint82_linear_0_1)",
    style: {
      filter: "url(#filter7005)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m301.85 468.63s3.672.914 7.681 2.001c4.001 1.087 4.843.914 4.843.914s-1.172-9.493-.586-13.659c.586-4.167 2.756-12.655 3.086-15.323.33-2.667.33-3.746 0-4.413s-.916-1.087-.916-1.087-1.337 0-3.003-1.333c-1.667-1.334-3.506-3.911-3.506-3.911s9.594-11.494 14.52-16.072c4.925-4.577 6.921-5.162 7.507-4.413s.165 3.08-1.171 5.5c-1.337 2.412-5.091 11.329-5.421 14.491-.33 3.161.083 19.9.834 31.649.75 11.74 1.336 16.738.833 17.817-.503 1.086-2.673 1.58-2.673 1.58l-22.613.289.585-14.03z",
    fill: "url(#paint83_linear_0_1)",
    style: {
      filter: "url(#filter7003)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m323.97 415.75c-4.925 4.578-14.52 16.072-14.52 16.072s1.832 2.585 3.506 3.911c1.667 1.333 3.003 1.333 3.003 1.333s.669-6.166 4.175-10.744c3.259-4.257 5.659-7.295 8.86-6.76.528-1.177.999-2.149 1.32-2.741 1.337-2.413 1.749-4.751 1.172-5.5-.594-.733-2.599-.148-7.516 4.429z",
    fill: "url(#paint84_linear_0_1)",
    style: {
      filter: "url(#filter7001)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m309.53 470.63c4.001 1.087 4.843.914 4.843.914s-.718-5.871-.743-10.407c-2.524-2.833-11.641-13.067-15.856-17.488-4.926-5.162-7.929-17.405-8.094-17.652s-.247-1.581-.42-2.33c-.174-.749-2.253-5.08-3.342-5.665-1.089-.584-2.499 3.417-2.334 9.823.165 6.413.585 20.402.585 20.402s3.507.667 5.008.584c1.502-.082 2.838-1.251 2.838-1.251s.833 0 1.419.584c.586.585 2.838 4.998 5.255 9.741 1.931 3.787 4.917 9.369 6.056 11.477 1.336.346 3.028.79 4.785 1.268z",
    fill: "url(#paint85_linear_0_1)",
    style: {
      filter: "url(#filter6999)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m287.17 430.24c.248-2.668 2.335-4.751 2.335-4.751.008 0 .017-.008.033-.008-.091-.527-.165-1.309-.28-1.819-.165-.75-2.253-5.08-3.342-5.665s-2.499 3.417-2.334 9.822c.165 6.414.585 20.402.585 20.402s3.507.667 5.008.585c1.502-.082 2.838-1.251 2.838-1.251-3.927-5.574-5.09-14.647-4.843-17.315z",
    fill: "url(#paint86_linear_0_1)",
    style: {
      filter: "url(#filter6997)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m193.87 430.2-12.507 29.36 3.614 5.533 27.514-9.699",
    fill: "url(#paint87_linear_0_1)",
    style: {
      filter: "url(#filter6995)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m127.97 257.63-55.795 72.289 9.4297-.585 1.5428 4.455 44.806-15.825",
    fill: "url(#paint88_linear_0_1)",
    style: {
      filter: "url(#filter6993)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m131.8 66.391 62.312 142.72 9.323-.181 73.383-135.8",
    fill: "url(#paint89_linear_0_1)",
    style: {
      filter: "url(#filter6991)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m238.72 164.64 52.024 45.753 4.802-17.34 28.347-1.432-10.403-128.86",
    fill: "url(#paint90_linear_0_1)",
    style: {
      filter: "url(#filter6989)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m395.57 328.94 34.923 2.569 5.255-.066 3.193-10.432-4.95-.057-26.904-26.364",
    fill: "url(#paint91_linear_0_1)",
    style: {
      filter: "url(#filter6987)"
    }
  }), /*#__PURE__*/React.createElement("defs", null, _pattern || (_pattern = /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    transform: "scale(.0027248 .0037453)",
    xlinkHref: "#image0_0_1"
  }))), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_1",
    x1: 278.22,
    x2: 278.22,
    y1: -4.4235,
    y2: 465.31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3788B8",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#353535",
    offset: 1
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_0_1",
    x1: 374.55,
    x2: 361.55,
    y1: 39.324,
    y2: 104.07,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88CFDA",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#89CFD9",
    offset: 0.008
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8D9BB",
    offset: 0.478
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0DFA7",
    offset: 0.822
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE1A0",
    offset: 1
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_0_1",
    x1: 396.49,
    x2: 519.25,
    y1: 300.26,
    y2: 214.27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_0_1",
    x1: 354.57,
    x2: 440.1,
    y1: 386.59,
    y2: 244.41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7633FF",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7137FF",
    offset: 0.159
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6243FF",
    offset: 0.353
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4957FF",
    offset: 0.568
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2672FF",
    offset: 0.794
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0090FF",
    offset: 1
  }))), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_0_1",
    x1: 406.79,
    x2: 406.46,
    y1: 350.51,
    y2: 351.06,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CEC228",
    offset: 0.074
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2AE18",
    offset: 0.58
  }))), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_0_1",
    x1: 356.24,
    x2: 368.6,
    y1: 309.36,
    y2: 306.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7700BB",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  }))), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_0_1",
    x1: 294.73,
    x2: 372.09,
    y1: 345,
    y2: 327.74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7700BB",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  }))), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_0_1",
    x1: 388.85,
    x2: 453.28,
    y1: 376.45,
    y2: 362.07,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7700BB",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  }))), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_0_1",
    x1: 162.68,
    x2: 39.898,
    y1: 284.3,
    y2: 198.34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1
  }))), _linearGradient0 || (_linearGradient0 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_0_1",
    x1: 334.65,
    x2: 411.58,
    y1: 440.88,
    y2: 318.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59023F",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#590444",
    offset: 0.119
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A0A53",
    offset: 0.265
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5C156C",
    offset: 0.426
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E238F",
    offset: 0.597
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6135BC",
    offset: 0.776
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#644CF2",
    offset: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6551FF",
    offset: 1
  }))), _linearGradient1 || (_linearGradient1 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_0_1",
    x1: 385.8,
    x2: 385.67,
    y1: 410.3,
    y2: 410.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CEC228",
    offset: 0.074
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2AE18",
    offset: 0.58
  }))), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_0_1",
    x1: 324.36,
    x2: 335.08,
    y1: 388.46,
    y2: 381.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7700BB",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  }))), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_0_1",
    x1: 278.38,
    x2: 345.43,
    y1: 442.61,
    y2: 400.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7700BB",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  }))), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_0_1",
    x1: 195.6,
    x2: 16.867,
    y1: 354.28,
    y2: 258.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7633FF",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7137FF",
    offset: 0.159
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6243FF",
    offset: 0.353
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4957FF",
    offset: 0.568
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2672FF",
    offset: 0.794
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0090FF",
    offset: 1
  }))), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_0_1",
    x1: 160.03,
    x2: 160.62,
    y1: 366.33,
    y2: 366.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CEC228",
    offset: 0.074
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2AE18",
    offset: 0.58
  }))), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_0_1",
    x1: 236.73,
    x2: 156.28,
    y1: 441.71,
    y2: 304.41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59023F",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#590444",
    offset: 0.119
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A0A53",
    offset: 0.265
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5C156C",
    offset: 0.426
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E238F",
    offset: 0.597
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6135BC",
    offset: 0.776
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#644CF2",
    offset: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6551FF",
    offset: 1
  }))), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_0_1",
    x1: 190.46,
    x2: 190.63,
    y1: 411.29,
    y2: 411.91,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CEC228",
    offset: 0.074
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2AE18",
    offset: 0.58
  }))), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_0_1",
    x1: 249.72,
    x2: 238.44,
    y1: 384.03,
    y2: 378.27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7700BB",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  }))), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_0_1",
    x1: 300.38,
    x2: 229.8,
    y1: 433.84,
    y2: 397.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7700BB",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  }))), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_0_1",
    x1: 216.77,
    x2: 135.5,
    y1: 412.94,
    y2: 371.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7700BB",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  }))), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_0_1",
    x1: 207.34,
    x2: 214.31,
    y1: 176.96,
    y2: 180.14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7633FF",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7137FF",
    offset: 0.159
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6243FF",
    offset: 0.353
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4957FF",
    offset: 0.568
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2672FF",
    offset: 0.794
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0090FF",
    offset: 1
  }))), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_0_1",
    x1: 198.06,
    x2: 204.23,
    y1: 179.05,
    y2: 181.86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7633FF",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7137FF",
    offset: 0.159
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6243FF",
    offset: 0.353
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4957FF",
    offset: 0.568
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2672FF",
    offset: 0.794
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0090FF",
    offset: 1
  }))), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_0_1",
    x1: 192.86,
    x2: 198.35,
    y1: 188.48,
    y2: 190.99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7633FF",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7137FF",
    offset: 0.159
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6243FF",
    offset: 0.353
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4957FF",
    offset: 0.568
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2672FF",
    offset: 0.794
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0090FF",
    offset: 1
  }))), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_0_1",
    x1: 180.87,
    x2: 188.67,
    y1: 183.18,
    y2: 186.74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7633FF",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7137FF",
    offset: 0.159
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6243FF",
    offset: 0.353
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4957FF",
    offset: 0.568
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2672FF",
    offset: 0.794
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0090FF",
    offset: 1
  }))), _linearGradient23 || (_linearGradient23 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_0_1",
    x1: 168.96,
    x2: 178.07,
    y1: 201.58,
    y2: 205.74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7633FF",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7137FF",
    offset: 0.159
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6243FF",
    offset: 0.353
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4957FF",
    offset: 0.568
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2672FF",
    offset: 0.794
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0090FF",
    offset: 1
  }))), _linearGradient24 || (_linearGradient24 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_0_1",
    x1: 173.96,
    x2: 181.32,
    y1: 190.56,
    y2: 193.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7633FF",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7137FF",
    offset: 0.159
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6243FF",
    offset: 0.353
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4957FF",
    offset: 0.568
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2672FF",
    offset: 0.794
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0090FF",
    offset: 1
  }))), _linearGradient25 || (_linearGradient25 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_0_1",
    x1: 337.95,
    x2: 330.99,
    y1: 182.86,
    y2: 186.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7633FF",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7137FF",
    offset: 0.159
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6243FF",
    offset: 0.353
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4957FF",
    offset: 0.568
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2672FF",
    offset: 0.794
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0090FF",
    offset: 1
  }))), _linearGradient26 || (_linearGradient26 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_0_1",
    x1: 347.23,
    x2: 341.06,
    y1: 184.95,
    y2: 187.76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7633FF",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7137FF",
    offset: 0.159
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6243FF",
    offset: 0.353
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4957FF",
    offset: 0.568
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2672FF",
    offset: 0.794
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0090FF",
    offset: 1
  }))), _linearGradient27 || (_linearGradient27 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_0_1",
    x1: 352.44,
    x2: 346.95,
    y1: 194.38,
    y2: 196.89,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7633FF",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7137FF",
    offset: 0.159
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6243FF",
    offset: 0.353
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4957FF",
    offset: 0.568
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2672FF",
    offset: 0.794
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0090FF",
    offset: 1
  }))), _linearGradient28 || (_linearGradient28 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_0_1",
    x1: 364.42,
    x2: 356.63,
    y1: 189.08,
    y2: 192.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7633FF",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7137FF",
    offset: 0.159
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6243FF",
    offset: 0.353
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4957FF",
    offset: 0.568
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2672FF",
    offset: 0.794
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0090FF",
    offset: 1
  }))), _linearGradient29 || (_linearGradient29 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_0_1",
    x1: 376.34,
    x2: 367.22,
    y1: 207.48,
    y2: 211.64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7633FF",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7137FF",
    offset: 0.159
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6243FF",
    offset: 0.353
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4957FF",
    offset: 0.568
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2672FF",
    offset: 0.794
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0090FF",
    offset: 1
  }))), _linearGradient30 || (_linearGradient30 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_0_1",
    x1: 371.33,
    x2: 363.97,
    y1: 196.46,
    y2: 199.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7633FF",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7137FF",
    offset: 0.159
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6243FF",
    offset: 0.353
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4957FF",
    offset: 0.568
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2672FF",
    offset: 0.794
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0090FF",
    offset: 1
  }))), _linearGradient31 || (_linearGradient31 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_0_1",
    x1: 256.39,
    x2: 258.38,
    y1: 449.79,
    y2: 463.79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#270036",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F008B",
    offset: 0.594
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4C24B1",
    offset: 1
  }))), _linearGradient32 || (_linearGradient32 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_0_1",
    x1: 204.21,
    x2: 396.54,
    y1: 319.44,
    y2: 150.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A1BAFF",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A7BFFF",
    offset: 0.015
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C3D3FF",
    offset: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9E3FF",
    offset: 0.175
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAF0FF",
    offset: 0.274
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F8FF",
    offset: 0.396
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF",
    offset: 0.563
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    offset: 1
  }))), _linearGradient33 || (_linearGradient33 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_0_1",
    x1: 247.04,
    x2: 278.7,
    y1: 385.21,
    y2: 385.21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A1BAFF",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A7BFFF",
    offset: 0.015
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C3D3FF",
    offset: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9E3FF",
    offset: 0.175
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAF0FF",
    offset: 0.274
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F8FF",
    offset: 0.396
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF",
    offset: 0.563
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    offset: 1
  }))), _linearGradient34 || (_linearGradient34 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_0_1",
    x1: 248.49,
    x2: 277.3,
    y1: 368.79,
    y2: 368.79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A1BAFF",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A7BFFF",
    offset: 0.015
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C3D3FF",
    offset: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9E3FF",
    offset: 0.175
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAF0FF",
    offset: 0.274
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F8FF",
    offset: 0.396
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF",
    offset: 0.563
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    offset: 1
  }))), _linearGradient35 || (_linearGradient35 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_0_1",
    x1: 237.8,
    x2: 286.83,
    y1: 350.2,
    y2: 350.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A1BAFF",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A7BFFF",
    offset: 0.015
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C3D3FF",
    offset: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9E3FF",
    offset: 0.175
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAF0FF",
    offset: 0.274
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F8FF",
    offset: 0.396
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF",
    offset: 0.563
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    offset: 1
  }))), _linearGradient36 || (_linearGradient36 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_0_1",
    x1: 113.9,
    x2: 401.96,
    y1: 430.22,
    y2: 430.22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A1BAFF",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    offset: 1
  }))), _linearGradient37 || (_linearGradient37 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_0_1",
    x1: 245.89,
    x2: 271.21,
    y1: 446.95,
    y2: 446.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#270036",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F008B",
    offset: 0.594
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4C24B1",
    offset: 1
  }))), _linearGradient38 || (_linearGradient38 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_0_1",
    x1: 256.86,
    x2: 292.36,
    y1: 201.7,
    y2: 201.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7633FF",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7137FF",
    offset: 0.159
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6243FF",
    offset: 0.353
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4957FF",
    offset: 0.568
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2672FF",
    offset: 0.794
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0090FF",
    offset: 1
  }))), _linearGradient39 || (_linearGradient39 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_0_1",
    x1: 289.78,
    x2: 324.83,
    y1: 205.68,
    y2: 205.68,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A1BAFF",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A7BFFF",
    offset: 0.015
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C3D3FF",
    offset: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9E3FF",
    offset: 0.175
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAF0FF",
    offset: 0.274
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F8FF",
    offset: 0.396
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF",
    offset: 0.563
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    offset: 1
  }))), _linearGradient40 || (_linearGradient40 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_0_1",
    x1: 278.7,
    x2: 289.32,
    y1: 216.76,
    y2: 216.76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A1BAFF",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A7BFFF",
    offset: 0.015
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C3D3FF",
    offset: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9E3FF",
    offset: 0.175
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAF0FF",
    offset: 0.274
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F8FF",
    offset: 0.396
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF",
    offset: 0.563
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    offset: 1
  }))), _linearGradient41 || (_linearGradient41 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_0_1",
    x1: 285.26,
    x2: 290.74,
    y1: 213.12,
    y2: 213.12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A1BAFF",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A7BFFF",
    offset: 0.015
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C3D3FF",
    offset: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9E3FF",
    offset: 0.175
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAF0FF",
    offset: 0.274
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F8FF",
    offset: 0.396
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF",
    offset: 0.563
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    offset: 1
  }))), _linearGradient42 || (_linearGradient42 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_0_1",
    x1: 262.12,
    x2: 284.87,
    y1: 180.88,
    y2: 180.88,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A1BAFF",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A7BFFF",
    offset: 0.015
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C3D3FF",
    offset: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9E3FF",
    offset: 0.175
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAF0FF",
    offset: 0.274
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F8FF",
    offset: 0.396
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF",
    offset: 0.563
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    offset: 1
  }))), _linearGradient43 || (_linearGradient43 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_0_1",
    x1: 265.43,
    x2: 286.4,
    y1: 165.58,
    y2: 165.58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A1BAFF",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A7BFFF",
    offset: 0.015
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C3D3FF",
    offset: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9E3FF",
    offset: 0.175
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAF0FF",
    offset: 0.274
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F8FF",
    offset: 0.396
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF",
    offset: 0.563
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    offset: 1
  }))), _linearGradient44 || (_linearGradient44 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_0_1",
    x1: 289.59,
    x2: 297.46,
    y1: 192.8,
    y2: 192.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7633FF",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7137FF",
    offset: 0.159
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6243FF",
    offset: 0.353
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4957FF",
    offset: 0.568
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2672FF",
    offset: 0.794
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0090FF",
    offset: 1
  }))), _linearGradient45 || (_linearGradient45 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_0_1",
    x1: 256.77,
    x2: 316.65,
    y1: 238.38,
    y2: 238.38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#270036",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F008B",
    offset: 0.594
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4C24B1",
    offset: 1
  }))), _linearGradient46 || (_linearGradient46 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_0_1",
    x1: 279.85,
    x2: 301.93,
    y1: 253.07,
    y2: 253.07,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311842",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#190C4B",
    offset: 0.461
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000054",
    offset: 1
  }))), _linearGradient47 || (_linearGradient47 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_0_1",
    x1: 240.76,
    x2: 273.68,
    y1: 196.11,
    y2: 196.11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7633FF",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7137FF",
    offset: 0.159
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6243FF",
    offset: 0.353
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4957FF",
    offset: 0.568
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2672FF",
    offset: 0.794
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0090FF",
    offset: 1
  }))), _linearGradient48 || (_linearGradient48 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_0_1",
    x1: 456.02,
    x2: 362.9,
    y1: 367.12,
    y2: 365.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7633FF",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#624BFF",
    offset: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F76FF",
    offset: 0.303
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2498FF",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10B0FF",
    offset: 0.686
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#04BFFF",
    offset: 0.857
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C4FF",
    offset: 1
  }))), _linearGradient49 || (_linearGradient49 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_0_1",
    x1: 391.86,
    x2: 410.59,
    y1: 313.93,
    y2: 313.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A1BAFF",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A7BFFF",
    offset: 0.015
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C3D3FF",
    offset: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9E3FF",
    offset: 0.175
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAF0FF",
    offset: 0.274
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F8FF",
    offset: 0.396
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF",
    offset: 0.563
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    offset: 1
  }))), _linearGradient50 || (_linearGradient50 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_0_1",
    x1: 427.24,
    x2: 444.08,
    y1: 332.37,
    y2: 332.37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A1BAFF",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A7BFFF",
    offset: 0.015
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C3D3FF",
    offset: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9E3FF",
    offset: 0.175
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAF0FF",
    offset: 0.274
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F8FF",
    offset: 0.396
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF",
    offset: 0.563
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    offset: 1
  }))), _linearGradient51 || (_linearGradient51 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_0_1",
    x1: 383.45,
    x2: 395.9,
    y1: 442.98,
    y2: 442.98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A1BAFF",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A7BFFF",
    offset: 0.015
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C3D3FF",
    offset: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9E3FF",
    offset: 0.175
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAF0FF",
    offset: 0.274
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F8FF",
    offset: 0.396
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF",
    offset: 0.563
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    offset: 1
  }))), _linearGradient52 || (_linearGradient52 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_0_1",
    x1: 402.06,
    x2: 432.25,
    y1: 441.14,
    y2: 441.14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A1BAFF",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A7BFFF",
    offset: 0.015
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C3D3FF",
    offset: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9E3FF",
    offset: 0.175
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAF0FF",
    offset: 0.274
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F8FF",
    offset: 0.396
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF",
    offset: 0.563
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    offset: 1
  }))), _linearGradient53 || (_linearGradient53 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_0_1",
    x1: 414.68,
    x2: 432.96,
    y1: 470.12,
    y2: 470.12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#270036",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F008B",
    offset: 0.594
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4C24B1",
    offset: 1
  }))), _linearGradient54 || (_linearGradient54 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_0_1",
    x1: 421.84,
    x2: 432.13,
    y1: 469.69,
    y2: 469.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#270036",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F008B",
    offset: 0.594
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4C24B1",
    offset: 1
  }))), _linearGradient55 || (_linearGradient55 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_0_1",
    x1: 387.27,
    x2: 394.47,
    y1: 473.56,
    y2: 473.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#270036",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F008B",
    offset: 0.594
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4C24B1",
    offset: 1
  }))), _linearGradient56 || (_linearGradient56 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_0_1",
    x1: 410.39,
    x2: 426,
    y1: 342.65,
    y2: 342.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7633FF",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E53FF",
    offset: 0.216
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C6DFF",
    offset: 0.436
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1480FF",
    offset: 0.646
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#058CFF",
    offset: 0.839
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0090FF",
    offset: 1
  }))), _linearGradient57 || (_linearGradient57 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_0_1",
    x1: 88.837,
    x2: 101.46,
    y1: 356.38,
    y2: 356.38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A1BAFF",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A7BFFF",
    offset: 0.015
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C3D3FF",
    offset: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9E3FF",
    offset: 0.175
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAF0FF",
    offset: 0.274
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F8FF",
    offset: 0.396
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF",
    offset: 0.563
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    offset: 1
  }))), _linearGradient58 || (_linearGradient58 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_0_1",
    x1: 89.276,
    x2: 134.1,
    y1: 350.41,
    y2: 350.41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7633FF",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E53FF",
    offset: 0.216
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C6DFF",
    offset: 0.436
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1480FF",
    offset: 0.646
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#058CFF",
    offset: 0.839
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0090FF",
    offset: 1
  }))), _linearGradient59 || (_linearGradient59 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_0_1",
    x1: 105.04,
    x2: 125.49,
    y1: 309.4,
    y2: 309.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A1BAFF",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A7BFFF",
    offset: 0.015
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C3D3FF",
    offset: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9E3FF",
    offset: 0.175
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAF0FF",
    offset: 0.274
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F8FF",
    offset: 0.396
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF",
    offset: 0.563
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    offset: 1
  }))), _linearGradient60 || (_linearGradient60 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_0_1",
    x1: 87.423,
    x2: 151.85,
    y1: 399.31,
    y2: 498.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#270036",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F008B",
    offset: 0.594
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4C24B1",
    offset: 1
  }))), _linearGradient61 || (_linearGradient61 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_0_1",
    x1: 106.51,
    x2: 94.045,
    y1: 383.68,
    y2: 459.64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#270036",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F008B",
    offset: 0.594
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4C24B1",
    offset: 1
  }))), _linearGradient62 || (_linearGradient62 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_0_1",
    x1: 72.344,
    x2: 130.41,
    y1: 346.96,
    y2: 346.96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A1BAFF",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A7BFFF",
    offset: 0.015
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C3D3FF",
    offset: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9E3FF",
    offset: 0.175
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAF0FF",
    offset: 0.274
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F8FF",
    offset: 0.396
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF",
    offset: 0.563
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    offset: 1
  }))), _linearGradient63 || (_linearGradient63 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_0_1",
    x1: 116.81,
    x2: 133.34,
    y1: 331.09,
    y2: 331.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7633FF",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E53FF",
    offset: 0.216
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C6DFF",
    offset: 0.436
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1480FF",
    offset: 0.646
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#058CFF",
    offset: 0.839
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0090FF",
    offset: 1
  }))), _linearGradient64 || (_linearGradient64 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_0_1",
    x1: 94.282,
    x2: 102.79,
    y1: 326.69,
    y2: 326.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7633FF",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E53FF",
    offset: 0.216
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C6DFF",
    offset: 0.436
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1480FF",
    offset: 0.646
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#058CFF",
    offset: 0.839
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0090FF",
    offset: 1
  }))), _linearGradient65 || (_linearGradient65 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_0_1",
    x1: 150.03,
    x2: 242.84,
    y1: 239.41,
    y2: 239.41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311842",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#190C4B",
    offset: 0.461
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000054",
    offset: 1
  }))), _linearGradient66 || (_linearGradient66 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_0_1",
    x1: 197.18,
    x2: 199.43,
    y1: 188.12,
    y2: 232.33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1DACFF",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1CA9FB",
    offset: 0.136
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B9FEF",
    offset: 0.274
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#188EDA",
    offset: 0.414
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1476BD",
    offset: 0.555
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F5898",
    offset: 0.696
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#08326B",
    offset: 0.839
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#010737",
    offset: 0.979
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00002E",
    offset: 1
  }))), _linearGradient67 || (_linearGradient67 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_0_1",
    x1: 189.6,
    x2: 204.59,
    y1: 188.12,
    y2: 188.12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A1BAFF",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A7BFFF",
    offset: 0.015
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C3D3FF",
    offset: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9E3FF",
    offset: 0.175
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAF0FF",
    offset: 0.274
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F8FF",
    offset: 0.396
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF",
    offset: 0.563
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    offset: 1
  }))), _linearGradient68 || (_linearGradient68 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_0_1",
    x1: 185.18,
    x2: 208.55,
    y1: 174.84,
    y2: 174.84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A1BAFF",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A7BFFF",
    offset: 0.015
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C3D3FF",
    offset: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9E3FF",
    offset: 0.175
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAF0FF",
    offset: 0.274
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F8FF",
    offset: 0.396
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF",
    offset: 0.563
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    offset: 1
  }))), _linearGradient69 || (_linearGradient69 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_0_1",
    x1: 170.17,
    x2: 200.02,
    y1: 219.49,
    y2: 219.49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A1BAFF",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A7BFFF",
    offset: 0.015
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C3D3FF",
    offset: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9E3FF",
    offset: 0.175
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAF0FF",
    offset: 0.274
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F8FF",
    offset: 0.396
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF",
    offset: 0.563
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    offset: 1
  }))), _linearGradient70 || (_linearGradient70 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_0_1",
    x1: 185.08,
    x2: 206.62,
    y1: 238.31,
    y2: 238.31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7633FF",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7231FA",
    offset: 0.129
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#682DEB",
    offset: 0.287
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5625D2",
    offset: 0.461
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E1BAF",
    offset: 0.646
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F0D83",
    offset: 0.837
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000057",
    offset: 1
  }))), _linearGradient71 || (_linearGradient71 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_0_1",
    x1: 150.03,
    x2: 190.44,
    y1: 239.1,
    y2: 239.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7633FF",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7231FA",
    offset: 0.129
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#682DEB",
    offset: 0.287
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5625D2",
    offset: 0.461
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E1BAF",
    offset: 0.646
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F0D83",
    offset: 0.837
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000057",
    offset: 1
  }))), _linearGradient72 || (_linearGradient72 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_0_1",
    x1: 189.34,
    x2: 200,
    y1: 248.15,
    y2: 248.15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A1BAFF",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A7BFFF",
    offset: 0.015
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C3D3FF",
    offset: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9E3FF",
    offset: 0.175
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAF0FF",
    offset: 0.274
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F8FF",
    offset: 0.396
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF",
    offset: 0.563
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    offset: 1
  }))), _linearGradient73 || (_linearGradient73 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_0_1",
    x1: 196.14,
    x2: 203.08,
    y1: 245.82,
    y2: 245.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A1BAFF",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A7BFFF",
    offset: 0.015
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C3D3FF",
    offset: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9E3FF",
    offset: 0.175
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAF0FF",
    offset: 0.274
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F8FF",
    offset: 0.396
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF",
    offset: 0.563
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    offset: 1
  }))), _linearGradient74 || (_linearGradient74 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_0_1",
    x1: 202.31,
    x2: 242.84,
    y1: 237.22,
    y2: 237.22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7633FF",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7231FA",
    offset: 0.129
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#682DEB",
    offset: 0.287
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5625D2",
    offset: 0.461
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E1BAF",
    offset: 0.646
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F0D83",
    offset: 0.837
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000057",
    offset: 1
  }))), _linearGradient75 || (_linearGradient75 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_0_1",
    x1: 192.63,
    x2: 226.4,
    y1: 219.36,
    y2: 219.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A1BAFF",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A7BFFF",
    offset: 0.015
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C3D3FF",
    offset: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9E3FF",
    offset: 0.175
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAF0FF",
    offset: 0.274
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F8FF",
    offset: 0.396
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF",
    offset: 0.563
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    offset: 1
  }))), _linearGradient76 || (_linearGradient76 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_0_1",
    x1: 196.53,
    x2: 215.73,
    y1: 443.79,
    y2: 443.79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A1BAFF",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A7BFFF",
    offset: 0.015
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C3D3FF",
    offset: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9E3FF",
    offset: 0.175
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAF0FF",
    offset: 0.274
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F8FF",
    offset: 0.396
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF",
    offset: 0.563
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    offset: 1
  }))), _linearGradient77 || (_linearGradient77 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_0_1",
    x1: 205.25,
    x2: 191.67,
    y1: 452.16,
    y2: 477.11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8990FF",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D95FF",
    offset: 0.011
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5B0FF",
    offset: 0.086
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9C6FF",
    offset: 0.172
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8D7FF",
    offset: 0.271
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3E3FF",
    offset: 0.393
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9EAFF",
    offset: 0.561
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBECFF",
    offset: 1
  }))), _linearGradient78 || (_linearGradient78 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_0_1",
    x1: 214.1,
    x2: 260.05,
    y1: 463.76,
    y2: 463.76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8815FF",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8917FF",
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E42FF",
    offset: 0.233
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AF64FF",
    offset: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BA7CFF",
    offset: 0.654
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C28BFF",
    offset: 0.843
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C490FF",
    offset: 1
  }))), _linearGradient79 || (_linearGradient79 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_0_1",
    x1: 225.16,
    x2: 185.51,
    y1: 452.09,
    y2: 487.15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A1BAFF",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A7BFFF",
    offset: 0.015
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C3D3FF",
    offset: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9E3FF",
    offset: 0.175
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAF0FF",
    offset: 0.274
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F8FF",
    offset: 0.396
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF",
    offset: 0.563
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    offset: 1
  }))), _linearGradient80 || (_linearGradient80 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_0_1",
    x1: 176.77,
    x2: 185.78,
    y1: 464.14,
    y2: 464.14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7633FF",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E53FF",
    offset: 0.216
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C6DFF",
    offset: 0.436
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1480FF",
    offset: 0.646
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#058CFF",
    offset: 0.839
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0090FF",
    offset: 1
  }))), _linearGradient81 || (_linearGradient81 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_0_1",
    x1: 259.78,
    x2: 301.9,
    y1: 470.75,
    y2: 470.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7633FF",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E53FF",
    offset: 0.216
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C6DFF",
    offset: 0.436
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1480FF",
    offset: 0.646
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#058CFF",
    offset: 0.839
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0090FF",
    offset: 1
  }))), _linearGradient82 || (_linearGradient82 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_0_1",
    x1: 301.27,
    x2: 331.73,
    y1: 446.86,
    y2: 446.86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A1BAFF",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A7BFFF",
    offset: 0.015
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C3D3FF",
    offset: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9E3FF",
    offset: 0.175
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAF0FF",
    offset: 0.274
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F8FF",
    offset: 0.396
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF",
    offset: 0.563
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    offset: 1
  }))), _linearGradient83 || (_linearGradient83 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_0_1",
    x1: 309.45,
    x2: 331.73,
    y1: 424.07,
    y2: 424.07,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7633FF",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E53FF",
    offset: 0.216
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C6DFF",
    offset: 0.436
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1480FF",
    offset: 0.646
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#058CFF",
    offset: 0.839
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0090FF",
    offset: 1
  }))), _linearGradient84 || (_linearGradient84 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear_0_1",
    x1: 316.25,
    x2: 285.78,
    y1: 468.28,
    y2: 433.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A1BAFF",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A7BFFF",
    offset: 0.015
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C3D3FF",
    offset: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9E3FF",
    offset: 0.175
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAF0FF",
    offset: 0.274
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F8FF",
    offset: 0.396
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF",
    offset: 0.563
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    offset: 1
  }))), _linearGradient85 || (_linearGradient85 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_0_1",
    x1: 283.57,
    x2: 292.01,
    y1: 433.38,
    y2: 433.38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7633FF",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E53FF",
    offset: 0.216
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C6DFF",
    offset: 0.436
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1480FF",
    offset: 0.646
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#058CFF",
    offset: 0.839
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0090FF",
    offset: 1
  }))), _linearGradient86 || (_linearGradient86 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear_0_1",
    x1: 203.33,
    x2: 175.86,
    y1: 442.67,
    y2: 464.76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7633FF",
    stopOpacity: 0,
    offset: 0.004
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7051FF",
    stopOpacity: 0.0882,
    offset: 0.092
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6685FF",
    stopOpacity: 0.2596,
    offset: 0.263
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5EB1FF",
    stopOpacity: 0.4279,
    offset: 0.43
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#57D3FF",
    stopOpacity: 0.5893,
    offset: 0.591
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53EBFF",
    stopOpacity: 0.7421,
    offset: 0.743
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50FAFF",
    stopOpacity: 0.8829,
    offset: 0.883
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4FFFFF",
    offset: 1
  }))), _linearGradient87 || (_linearGradient87 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint88_linear_0_1",
    x1: 141.65,
    x2: 56.979,
    y1: 276.83,
    y2: 344.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7633FF",
    stopOpacity: 0,
    offset: 0.004
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7051FF",
    stopOpacity: 0.0882,
    offset: 0.092
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6685FF",
    stopOpacity: 0.2596,
    offset: 0.263
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5EB1FF",
    stopOpacity: 0.4279,
    offset: 0.43
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#57D3FF",
    stopOpacity: 0.5893,
    offset: 0.591
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53EBFF",
    stopOpacity: 0.7421,
    offset: 0.743
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50FAFF",
    stopOpacity: 0.8829,
    offset: 0.883
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4FFFFF",
    offset: 1
  }))), _linearGradient88 || (_linearGradient88 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint89_linear_0_1",
    x1: 204.22,
    x2: 195.26,
    y1: 71.487,
    y2: 242.73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7633FF",
    stopOpacity: 0,
    offset: 0.004
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7051FF",
    stopOpacity: 0.0882,
    offset: 0.092
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6685FF",
    stopOpacity: 0.2596,
    offset: 0.263
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5EB1FF",
    stopOpacity: 0.4279,
    offset: 0.43
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#57D3FF",
    stopOpacity: 0.5893,
    offset: 0.591
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53EBFF",
    stopOpacity: 0.7421,
    offset: 0.743
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50FAFF",
    stopOpacity: 0.8829,
    offset: 0.883
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4FFFFF",
    offset: 1
  }))), _linearGradient89 || (_linearGradient89 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint90_linear_0_1",
    x1: 275.04,
    x2: 358.88,
    y1: 116.95,
    y2: 177.99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7633FF",
    stopOpacity: 0,
    offset: 0.004
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7051FF",
    stopOpacity: 0.0882,
    offset: 0.092
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6685FF",
    stopOpacity: 0.2596,
    offset: 0.263
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5EB1FF",
    stopOpacity: 0.4279,
    offset: 0.43
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#57D3FF",
    stopOpacity: 0.5893,
    offset: 0.591
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53EBFF",
    stopOpacity: 0.7421,
    offset: 0.743
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50FAFF",
    stopOpacity: 0.8829,
    offset: 0.883
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4FFFFF",
    offset: 1
  }))), _linearGradient90 || (_linearGradient90 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint91_linear_0_1",
    x1: 400.88,
    x2: 438.3,
    y1: 311.62,
    y2: 323.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7633FF",
    stopOpacity: 0,
    offset: 0.004
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7051FF",
    stopOpacity: 0.0882,
    offset: 0.092
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6685FF",
    stopOpacity: 0.2596,
    offset: 0.263
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5EB1FF",
    stopOpacity: 0.4279,
    offset: 0.43
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#57D3FF",
    stopOpacity: 0.5893,
    offset: 0.591
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53EBFF",
    stopOpacity: 0.7421,
    offset: 0.743
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50FAFF",
    stopOpacity: 0.8829,
    offset: 0.883
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4FFFFF",
    offset: 1
  }))), _image || (_image = /*#__PURE__*/React.createElement("image", {
    id: "image0_0_1",
    width: 367,
    height: 267,
    xlinkHref: "data:image/png;base64,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"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6987",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite || (_feComposite = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix || (_feColorMatrix = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood || (_feFlood = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend || (_feBlend = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend2 || (_feBlend2 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix2 || (_feColorMatrix2 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite2 || (_feComposite2 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix3 || (_feColorMatrix3 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite3 || (_feComposite3 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix4 || (_feColorMatrix4 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood2 || (_feFlood2 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend3 || (_feBlend3 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend4 || (_feBlend4 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix5 || (_feColorMatrix5 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite4 || (_feComposite4 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix6 || (_feColorMatrix6 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix7 || (_feColorMatrix7 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter6989",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite5 || (_feComposite5 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix8 || (_feColorMatrix8 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood3 || (_feFlood3 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend5 || (_feBlend5 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend6 || (_feBlend6 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix9 || (_feColorMatrix9 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite6 || (_feComposite6 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix0 || (_feColorMatrix0 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite7 || (_feComposite7 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix1 || (_feColorMatrix1 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood4 || (_feFlood4 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend7 || (_feBlend7 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend8 || (_feBlend8 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix10 || (_feColorMatrix10 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite8 || (_feComposite8 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix11 || (_feColorMatrix11 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix12 || (_feColorMatrix12 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter6991",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite9 || (_feComposite9 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix13 || (_feColorMatrix13 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood5 || (_feFlood5 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend9 || (_feBlend9 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend0 || (_feBlend0 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix14 || (_feColorMatrix14 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite0 || (_feComposite0 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix15 || (_feColorMatrix15 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite1 || (_feComposite1 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix16 || (_feColorMatrix16 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood6 || (_feFlood6 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend1 || (_feBlend1 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend10 || (_feBlend10 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix17 || (_feColorMatrix17 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite10 || (_feComposite10 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix18 || (_feColorMatrix18 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix19 || (_feColorMatrix19 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter6993",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite11 || (_feComposite11 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix20 || (_feColorMatrix20 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood7 || (_feFlood7 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend11 || (_feBlend11 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend12 || (_feBlend12 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix21 || (_feColorMatrix21 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite12 || (_feComposite12 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix22 || (_feColorMatrix22 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite13 || (_feComposite13 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix23 || (_feColorMatrix23 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood8 || (_feFlood8 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend13 || (_feBlend13 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend14 || (_feBlend14 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix24 || (_feColorMatrix24 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite14 || (_feComposite14 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix25 || (_feColorMatrix25 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix26 || (_feColorMatrix26 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter6995",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite15 || (_feComposite15 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix27 || (_feColorMatrix27 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood9 || (_feFlood9 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend15 || (_feBlend15 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend16 || (_feBlend16 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix28 || (_feColorMatrix28 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite16 || (_feComposite16 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix29 || (_feColorMatrix29 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite17 || (_feComposite17 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix30 || (_feColorMatrix30 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood0 || (_feFlood0 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend17 || (_feBlend17 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend18 || (_feBlend18 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix31 || (_feColorMatrix31 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite18 || (_feComposite18 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix32 || (_feColorMatrix32 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix33 || (_feColorMatrix33 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter6997",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite19 || (_feComposite19 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix34 || (_feColorMatrix34 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood1 || (_feFlood1 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend19 || (_feBlend19 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend20 || (_feBlend20 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix35 || (_feColorMatrix35 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite20 || (_feComposite20 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix36 || (_feColorMatrix36 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite21 || (_feComposite21 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix37 || (_feColorMatrix37 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood10 || (_feFlood10 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend21 || (_feBlend21 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend22 || (_feBlend22 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix38 || (_feColorMatrix38 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite22 || (_feComposite22 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix39 || (_feColorMatrix39 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix40 || (_feColorMatrix40 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter6999",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite23 || (_feComposite23 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix41 || (_feColorMatrix41 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood11 || (_feFlood11 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend23 || (_feBlend23 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend24 || (_feBlend24 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix42 || (_feColorMatrix42 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite24 || (_feComposite24 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix43 || (_feColorMatrix43 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite25 || (_feComposite25 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix44 || (_feColorMatrix44 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood12 || (_feFlood12 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend25 || (_feBlend25 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend26 || (_feBlend26 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix45 || (_feColorMatrix45 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite26 || (_feComposite26 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix46 || (_feColorMatrix46 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix47 || (_feColorMatrix47 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7001",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite27 || (_feComposite27 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix48 || (_feColorMatrix48 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood13 || (_feFlood13 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend27 || (_feBlend27 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend28 || (_feBlend28 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix49 || (_feColorMatrix49 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite28 || (_feComposite28 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix50 || (_feColorMatrix50 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite29 || (_feComposite29 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix51 || (_feColorMatrix51 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood14 || (_feFlood14 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend29 || (_feBlend29 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend30 || (_feBlend30 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix52 || (_feColorMatrix52 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite30 || (_feComposite30 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix53 || (_feColorMatrix53 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix54 || (_feColorMatrix54 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7003",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite31 || (_feComposite31 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix55 || (_feColorMatrix55 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood15 || (_feFlood15 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend31 || (_feBlend31 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend32 || (_feBlend32 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix56 || (_feColorMatrix56 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite32 || (_feComposite32 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix57 || (_feColorMatrix57 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite33 || (_feComposite33 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix58 || (_feColorMatrix58 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood16 || (_feFlood16 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend33 || (_feBlend33 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend34 || (_feBlend34 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix59 || (_feColorMatrix59 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite34 || (_feComposite34 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix60 || (_feColorMatrix60 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix61 || (_feColorMatrix61 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7005",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite35 || (_feComposite35 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix62 || (_feColorMatrix62 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood17 || (_feFlood17 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend35 || (_feBlend35 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend36 || (_feBlend36 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix63 || (_feColorMatrix63 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite36 || (_feComposite36 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix64 || (_feColorMatrix64 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite37 || (_feComposite37 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix65 || (_feColorMatrix65 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood18 || (_feFlood18 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend37 || (_feBlend37 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend38 || (_feBlend38 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix66 || (_feColorMatrix66 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite38 || (_feComposite38 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix67 || (_feColorMatrix67 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix68 || (_feColorMatrix68 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7007",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite39 || (_feComposite39 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix69 || (_feColorMatrix69 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood19 || (_feFlood19 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend39 || (_feBlend39 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend40 || (_feBlend40 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix70 || (_feColorMatrix70 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite40 || (_feComposite40 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix71 || (_feColorMatrix71 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite41 || (_feComposite41 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix72 || (_feColorMatrix72 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood20 || (_feFlood20 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend41 || (_feBlend41 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend42 || (_feBlend42 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix73 || (_feColorMatrix73 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite42 || (_feComposite42 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix74 || (_feColorMatrix74 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix75 || (_feColorMatrix75 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7009",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite43 || (_feComposite43 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix76 || (_feColorMatrix76 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood21 || (_feFlood21 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend43 || (_feBlend43 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend44 || (_feBlend44 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix77 || (_feColorMatrix77 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite44 || (_feComposite44 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix78 || (_feColorMatrix78 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite45 || (_feComposite45 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix79 || (_feColorMatrix79 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood22 || (_feFlood22 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend45 || (_feBlend45 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend46 || (_feBlend46 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix80 || (_feColorMatrix80 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite46 || (_feComposite46 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix81 || (_feColorMatrix81 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix82 || (_feColorMatrix82 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7011",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite47 || (_feComposite47 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix83 || (_feColorMatrix83 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood23 || (_feFlood23 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend47 || (_feBlend47 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend48 || (_feBlend48 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix84 || (_feColorMatrix84 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite48 || (_feComposite48 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix85 || (_feColorMatrix85 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite49 || (_feComposite49 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix86 || (_feColorMatrix86 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood24 || (_feFlood24 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend49 || (_feBlend49 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend50 || (_feBlend50 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix87 || (_feColorMatrix87 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite50 || (_feComposite50 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix88 || (_feColorMatrix88 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix89 || (_feColorMatrix89 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7013",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite51 || (_feComposite51 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix90 || (_feColorMatrix90 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood25 || (_feFlood25 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend51 || (_feBlend51 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend52 || (_feBlend52 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix91 || (_feColorMatrix91 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite52 || (_feComposite52 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix92 || (_feColorMatrix92 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite53 || (_feComposite53 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix93 || (_feColorMatrix93 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood26 || (_feFlood26 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend53 || (_feBlend53 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend54 || (_feBlend54 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix94 || (_feColorMatrix94 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite54 || (_feComposite54 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix95 || (_feColorMatrix95 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix96 || (_feColorMatrix96 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7015",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite55 || (_feComposite55 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix97 || (_feColorMatrix97 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood27 || (_feFlood27 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend55 || (_feBlend55 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend56 || (_feBlend56 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix98 || (_feColorMatrix98 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite56 || (_feComposite56 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix99 || (_feColorMatrix99 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite57 || (_feComposite57 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix100 || (_feColorMatrix100 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood28 || (_feFlood28 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend57 || (_feBlend57 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend58 || (_feBlend58 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix101 || (_feColorMatrix101 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite58 || (_feComposite58 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix102 || (_feColorMatrix102 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix103 || (_feColorMatrix103 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7017",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite59 || (_feComposite59 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix104 || (_feColorMatrix104 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood29 || (_feFlood29 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend59 || (_feBlend59 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend60 || (_feBlend60 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix105 || (_feColorMatrix105 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite60 || (_feComposite60 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix106 || (_feColorMatrix106 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite61 || (_feComposite61 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix107 || (_feColorMatrix107 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood30 || (_feFlood30 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend61 || (_feBlend61 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend62 || (_feBlend62 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix108 || (_feColorMatrix108 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite62 || (_feComposite62 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix109 || (_feColorMatrix109 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix110 || (_feColorMatrix110 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7019",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite63 || (_feComposite63 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix111 || (_feColorMatrix111 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood31 || (_feFlood31 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend63 || (_feBlend63 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend64 || (_feBlend64 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix112 || (_feColorMatrix112 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite64 || (_feComposite64 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix113 || (_feColorMatrix113 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite65 || (_feComposite65 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix114 || (_feColorMatrix114 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood32 || (_feFlood32 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend65 || (_feBlend65 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend66 || (_feBlend66 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix115 || (_feColorMatrix115 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite66 || (_feComposite66 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix116 || (_feColorMatrix116 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix117 || (_feColorMatrix117 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7021",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite67 || (_feComposite67 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix118 || (_feColorMatrix118 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood33 || (_feFlood33 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend67 || (_feBlend67 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend68 || (_feBlend68 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix119 || (_feColorMatrix119 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite68 || (_feComposite68 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix120 || (_feColorMatrix120 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite69 || (_feComposite69 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix121 || (_feColorMatrix121 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood34 || (_feFlood34 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend69 || (_feBlend69 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend70 || (_feBlend70 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix122 || (_feColorMatrix122 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite70 || (_feComposite70 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix123 || (_feColorMatrix123 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix124 || (_feColorMatrix124 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7023",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite71 || (_feComposite71 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix125 || (_feColorMatrix125 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood35 || (_feFlood35 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend71 || (_feBlend71 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend72 || (_feBlend72 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix126 || (_feColorMatrix126 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite72 || (_feComposite72 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix127 || (_feColorMatrix127 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite73 || (_feComposite73 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix128 || (_feColorMatrix128 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood36 || (_feFlood36 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend73 || (_feBlend73 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend74 || (_feBlend74 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix129 || (_feColorMatrix129 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite74 || (_feComposite74 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix130 || (_feColorMatrix130 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix131 || (_feColorMatrix131 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7025",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite75 || (_feComposite75 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix132 || (_feColorMatrix132 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood37 || (_feFlood37 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend75 || (_feBlend75 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend76 || (_feBlend76 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix133 || (_feColorMatrix133 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite76 || (_feComposite76 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix134 || (_feColorMatrix134 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite77 || (_feComposite77 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix135 || (_feColorMatrix135 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood38 || (_feFlood38 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend77 || (_feBlend77 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend78 || (_feBlend78 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix136 || (_feColorMatrix136 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite78 || (_feComposite78 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix137 || (_feColorMatrix137 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix138 || (_feColorMatrix138 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7027",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite79 || (_feComposite79 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix139 || (_feColorMatrix139 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood39 || (_feFlood39 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend79 || (_feBlend79 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend80 || (_feBlend80 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix140 || (_feColorMatrix140 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite80 || (_feComposite80 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix141 || (_feColorMatrix141 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite81 || (_feComposite81 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix142 || (_feColorMatrix142 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood40 || (_feFlood40 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend81 || (_feBlend81 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend82 || (_feBlend82 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix143 || (_feColorMatrix143 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite82 || (_feComposite82 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix144 || (_feColorMatrix144 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix145 || (_feColorMatrix145 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7029",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite83 || (_feComposite83 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix146 || (_feColorMatrix146 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood41 || (_feFlood41 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend83 || (_feBlend83 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend84 || (_feBlend84 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix147 || (_feColorMatrix147 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite84 || (_feComposite84 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix148 || (_feColorMatrix148 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite85 || (_feComposite85 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix149 || (_feColorMatrix149 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood42 || (_feFlood42 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend85 || (_feBlend85 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend86 || (_feBlend86 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix150 || (_feColorMatrix150 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite86 || (_feComposite86 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix151 || (_feColorMatrix151 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix152 || (_feColorMatrix152 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7031",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite87 || (_feComposite87 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix153 || (_feColorMatrix153 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood43 || (_feFlood43 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend87 || (_feBlend87 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend88 || (_feBlend88 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix154 || (_feColorMatrix154 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite88 || (_feComposite88 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix155 || (_feColorMatrix155 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite89 || (_feComposite89 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix156 || (_feColorMatrix156 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood44 || (_feFlood44 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend89 || (_feBlend89 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend90 || (_feBlend90 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix157 || (_feColorMatrix157 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite90 || (_feComposite90 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix158 || (_feColorMatrix158 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix159 || (_feColorMatrix159 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7033",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite91 || (_feComposite91 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix160 || (_feColorMatrix160 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood45 || (_feFlood45 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend91 || (_feBlend91 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend92 || (_feBlend92 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix161 || (_feColorMatrix161 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite92 || (_feComposite92 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix162 || (_feColorMatrix162 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite93 || (_feComposite93 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix163 || (_feColorMatrix163 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood46 || (_feFlood46 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend93 || (_feBlend93 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend94 || (_feBlend94 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix164 || (_feColorMatrix164 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite94 || (_feComposite94 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix165 || (_feColorMatrix165 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix166 || (_feColorMatrix166 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7035",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite95 || (_feComposite95 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix167 || (_feColorMatrix167 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood47 || (_feFlood47 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend95 || (_feBlend95 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend96 || (_feBlend96 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix168 || (_feColorMatrix168 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite96 || (_feComposite96 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix169 || (_feColorMatrix169 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite97 || (_feComposite97 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix170 || (_feColorMatrix170 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood48 || (_feFlood48 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend97 || (_feBlend97 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend98 || (_feBlend98 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix171 || (_feColorMatrix171 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite98 || (_feComposite98 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix172 || (_feColorMatrix172 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix173 || (_feColorMatrix173 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7037",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite99 || (_feComposite99 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix174 || (_feColorMatrix174 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood49 || (_feFlood49 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend99 || (_feBlend99 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend100 || (_feBlend100 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix175 || (_feColorMatrix175 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite100 || (_feComposite100 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix176 || (_feColorMatrix176 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite101 || (_feComposite101 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix177 || (_feColorMatrix177 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood50 || (_feFlood50 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend101 || (_feBlend101 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend102 || (_feBlend102 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix178 || (_feColorMatrix178 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite102 || (_feComposite102 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix179 || (_feColorMatrix179 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix180 || (_feColorMatrix180 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7039",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite103 || (_feComposite103 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix181 || (_feColorMatrix181 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood51 || (_feFlood51 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend103 || (_feBlend103 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend104 || (_feBlend104 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix182 || (_feColorMatrix182 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite104 || (_feComposite104 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix183 || (_feColorMatrix183 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite105 || (_feComposite105 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix184 || (_feColorMatrix184 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood52 || (_feFlood52 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend105 || (_feBlend105 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend106 || (_feBlend106 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix185 || (_feColorMatrix185 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite106 || (_feComposite106 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix186 || (_feColorMatrix186 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix187 || (_feColorMatrix187 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7041",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite107 || (_feComposite107 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix188 || (_feColorMatrix188 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood53 || (_feFlood53 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend107 || (_feBlend107 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend108 || (_feBlend108 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix189 || (_feColorMatrix189 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite108 || (_feComposite108 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix190 || (_feColorMatrix190 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite109 || (_feComposite109 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix191 || (_feColorMatrix191 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood54 || (_feFlood54 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend109 || (_feBlend109 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend110 || (_feBlend110 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix192 || (_feColorMatrix192 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite110 || (_feComposite110 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix193 || (_feColorMatrix193 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix194 || (_feColorMatrix194 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7043",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite111 || (_feComposite111 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix195 || (_feColorMatrix195 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood55 || (_feFlood55 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend111 || (_feBlend111 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend112 || (_feBlend112 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix196 || (_feColorMatrix196 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite112 || (_feComposite112 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix197 || (_feColorMatrix197 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite113 || (_feComposite113 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix198 || (_feColorMatrix198 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood56 || (_feFlood56 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend113 || (_feBlend113 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend114 || (_feBlend114 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix199 || (_feColorMatrix199 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite114 || (_feComposite114 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix200 || (_feColorMatrix200 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix201 || (_feColorMatrix201 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7045",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite115 || (_feComposite115 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix202 || (_feColorMatrix202 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood57 || (_feFlood57 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend115 || (_feBlend115 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend116 || (_feBlend116 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix203 || (_feColorMatrix203 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite116 || (_feComposite116 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix204 || (_feColorMatrix204 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite117 || (_feComposite117 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix205 || (_feColorMatrix205 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood58 || (_feFlood58 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend117 || (_feBlend117 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend118 || (_feBlend118 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix206 || (_feColorMatrix206 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite118 || (_feComposite118 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix207 || (_feColorMatrix207 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix208 || (_feColorMatrix208 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7047",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite119 || (_feComposite119 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix209 || (_feColorMatrix209 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood59 || (_feFlood59 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend119 || (_feBlend119 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend120 || (_feBlend120 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix210 || (_feColorMatrix210 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite120 || (_feComposite120 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix211 || (_feColorMatrix211 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite121 || (_feComposite121 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix212 || (_feColorMatrix212 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood60 || (_feFlood60 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend121 || (_feBlend121 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend122 || (_feBlend122 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix213 || (_feColorMatrix213 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite122 || (_feComposite122 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix214 || (_feColorMatrix214 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix215 || (_feColorMatrix215 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7049",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite123 || (_feComposite123 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix216 || (_feColorMatrix216 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood61 || (_feFlood61 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend123 || (_feBlend123 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend124 || (_feBlend124 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix217 || (_feColorMatrix217 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite124 || (_feComposite124 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix218 || (_feColorMatrix218 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite125 || (_feComposite125 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix219 || (_feColorMatrix219 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood62 || (_feFlood62 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend125 || (_feBlend125 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend126 || (_feBlend126 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix220 || (_feColorMatrix220 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite126 || (_feComposite126 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix221 || (_feColorMatrix221 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix222 || (_feColorMatrix222 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7051",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite127 || (_feComposite127 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix223 || (_feColorMatrix223 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood63 || (_feFlood63 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend127 || (_feBlend127 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend128 || (_feBlend128 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix224 || (_feColorMatrix224 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite128 || (_feComposite128 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix225 || (_feColorMatrix225 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite129 || (_feComposite129 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix226 || (_feColorMatrix226 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood64 || (_feFlood64 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend129 || (_feBlend129 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend130 || (_feBlend130 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix227 || (_feColorMatrix227 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite130 || (_feComposite130 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix228 || (_feColorMatrix228 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix229 || (_feColorMatrix229 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7053",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite131 || (_feComposite131 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix230 || (_feColorMatrix230 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood65 || (_feFlood65 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend131 || (_feBlend131 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend132 || (_feBlend132 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix231 || (_feColorMatrix231 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite132 || (_feComposite132 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix232 || (_feColorMatrix232 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite133 || (_feComposite133 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix233 || (_feColorMatrix233 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood66 || (_feFlood66 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend133 || (_feBlend133 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend134 || (_feBlend134 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix234 || (_feColorMatrix234 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite134 || (_feComposite134 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix235 || (_feColorMatrix235 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix236 || (_feColorMatrix236 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7055",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite135 || (_feComposite135 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix237 || (_feColorMatrix237 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood67 || (_feFlood67 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend135 || (_feBlend135 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend136 || (_feBlend136 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix238 || (_feColorMatrix238 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite136 || (_feComposite136 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix239 || (_feColorMatrix239 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite137 || (_feComposite137 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix240 || (_feColorMatrix240 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood68 || (_feFlood68 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend137 || (_feBlend137 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend138 || (_feBlend138 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix241 || (_feColorMatrix241 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite138 || (_feComposite138 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix242 || (_feColorMatrix242 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix243 || (_feColorMatrix243 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7057",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite139 || (_feComposite139 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix244 || (_feColorMatrix244 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood69 || (_feFlood69 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend139 || (_feBlend139 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend140 || (_feBlend140 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix245 || (_feColorMatrix245 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite140 || (_feComposite140 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix246 || (_feColorMatrix246 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite141 || (_feComposite141 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix247 || (_feColorMatrix247 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood70 || (_feFlood70 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend141 || (_feBlend141 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend142 || (_feBlend142 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix248 || (_feColorMatrix248 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite142 || (_feComposite142 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix249 || (_feColorMatrix249 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix250 || (_feColorMatrix250 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7059",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite143 || (_feComposite143 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix251 || (_feColorMatrix251 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood71 || (_feFlood71 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend143 || (_feBlend143 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend144 || (_feBlend144 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix252 || (_feColorMatrix252 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite144 || (_feComposite144 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix253 || (_feColorMatrix253 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite145 || (_feComposite145 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix254 || (_feColorMatrix254 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood72 || (_feFlood72 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend145 || (_feBlend145 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend146 || (_feBlend146 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix255 || (_feColorMatrix255 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite146 || (_feComposite146 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix256 || (_feColorMatrix256 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix257 || (_feColorMatrix257 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7061",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite147 || (_feComposite147 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix258 || (_feColorMatrix258 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood73 || (_feFlood73 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend147 || (_feBlend147 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend148 || (_feBlend148 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix259 || (_feColorMatrix259 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite148 || (_feComposite148 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix260 || (_feColorMatrix260 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite149 || (_feComposite149 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix261 || (_feColorMatrix261 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood74 || (_feFlood74 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend149 || (_feBlend149 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend150 || (_feBlend150 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix262 || (_feColorMatrix262 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite150 || (_feComposite150 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix263 || (_feColorMatrix263 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix264 || (_feColorMatrix264 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7063",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite151 || (_feComposite151 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix265 || (_feColorMatrix265 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood75 || (_feFlood75 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend151 || (_feBlend151 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend152 || (_feBlend152 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix266 || (_feColorMatrix266 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite152 || (_feComposite152 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix267 || (_feColorMatrix267 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite153 || (_feComposite153 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix268 || (_feColorMatrix268 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood76 || (_feFlood76 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend153 || (_feBlend153 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend154 || (_feBlend154 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix269 || (_feColorMatrix269 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite154 || (_feComposite154 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix270 || (_feColorMatrix270 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix271 || (_feColorMatrix271 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7065",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite155 || (_feComposite155 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix272 || (_feColorMatrix272 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood77 || (_feFlood77 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend155 || (_feBlend155 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend156 || (_feBlend156 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix273 || (_feColorMatrix273 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite156 || (_feComposite156 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix274 || (_feColorMatrix274 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite157 || (_feComposite157 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix275 || (_feColorMatrix275 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood78 || (_feFlood78 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend157 || (_feBlend157 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend158 || (_feBlend158 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix276 || (_feColorMatrix276 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite158 || (_feComposite158 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix277 || (_feColorMatrix277 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix278 || (_feColorMatrix278 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7067",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite159 || (_feComposite159 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix279 || (_feColorMatrix279 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood79 || (_feFlood79 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend159 || (_feBlend159 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend160 || (_feBlend160 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix280 || (_feColorMatrix280 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite160 || (_feComposite160 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix281 || (_feColorMatrix281 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite161 || (_feComposite161 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix282 || (_feColorMatrix282 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood80 || (_feFlood80 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend161 || (_feBlend161 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend162 || (_feBlend162 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix283 || (_feColorMatrix283 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite162 || (_feComposite162 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix284 || (_feColorMatrix284 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix285 || (_feColorMatrix285 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7069",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite163 || (_feComposite163 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix286 || (_feColorMatrix286 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood81 || (_feFlood81 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend163 || (_feBlend163 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend164 || (_feBlend164 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix287 || (_feColorMatrix287 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite164 || (_feComposite164 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix288 || (_feColorMatrix288 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite165 || (_feComposite165 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix289 || (_feColorMatrix289 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood82 || (_feFlood82 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend165 || (_feBlend165 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend166 || (_feBlend166 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix290 || (_feColorMatrix290 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite166 || (_feComposite166 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix291 || (_feColorMatrix291 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix292 || (_feColorMatrix292 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7071",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite167 || (_feComposite167 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix293 || (_feColorMatrix293 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood83 || (_feFlood83 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend167 || (_feBlend167 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend168 || (_feBlend168 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix294 || (_feColorMatrix294 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite168 || (_feComposite168 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix295 || (_feColorMatrix295 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite169 || (_feComposite169 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix296 || (_feColorMatrix296 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood84 || (_feFlood84 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend169 || (_feBlend169 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend170 || (_feBlend170 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix297 || (_feColorMatrix297 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite170 || (_feComposite170 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix298 || (_feColorMatrix298 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix299 || (_feColorMatrix299 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7073",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite171 || (_feComposite171 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix300 || (_feColorMatrix300 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood85 || (_feFlood85 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend171 || (_feBlend171 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend172 || (_feBlend172 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix301 || (_feColorMatrix301 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite172 || (_feComposite172 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix302 || (_feColorMatrix302 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite173 || (_feComposite173 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix303 || (_feColorMatrix303 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood86 || (_feFlood86 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend173 || (_feBlend173 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend174 || (_feBlend174 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix304 || (_feColorMatrix304 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite174 || (_feComposite174 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix305 || (_feColorMatrix305 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix306 || (_feColorMatrix306 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7075",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite175 || (_feComposite175 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix307 || (_feColorMatrix307 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood87 || (_feFlood87 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend175 || (_feBlend175 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend176 || (_feBlend176 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix308 || (_feColorMatrix308 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite176 || (_feComposite176 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix309 || (_feColorMatrix309 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite177 || (_feComposite177 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix310 || (_feColorMatrix310 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood88 || (_feFlood88 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend177 || (_feBlend177 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend178 || (_feBlend178 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix311 || (_feColorMatrix311 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite178 || (_feComposite178 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix312 || (_feColorMatrix312 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix313 || (_feColorMatrix313 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7077",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite179 || (_feComposite179 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix314 || (_feColorMatrix314 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood89 || (_feFlood89 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend179 || (_feBlend179 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend180 || (_feBlend180 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix315 || (_feColorMatrix315 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite180 || (_feComposite180 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix316 || (_feColorMatrix316 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite181 || (_feComposite181 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix317 || (_feColorMatrix317 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood90 || (_feFlood90 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend181 || (_feBlend181 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend182 || (_feBlend182 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix318 || (_feColorMatrix318 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite182 || (_feComposite182 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix319 || (_feColorMatrix319 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix320 || (_feColorMatrix320 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7079",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite183 || (_feComposite183 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix321 || (_feColorMatrix321 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood91 || (_feFlood91 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend183 || (_feBlend183 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend184 || (_feBlend184 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix322 || (_feColorMatrix322 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite184 || (_feComposite184 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix323 || (_feColorMatrix323 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite185 || (_feComposite185 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix324 || (_feColorMatrix324 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood92 || (_feFlood92 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend185 || (_feBlend185 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend186 || (_feBlend186 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix325 || (_feColorMatrix325 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite186 || (_feComposite186 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix326 || (_feColorMatrix326 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix327 || (_feColorMatrix327 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7081",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite187 || (_feComposite187 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix328 || (_feColorMatrix328 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood93 || (_feFlood93 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend187 || (_feBlend187 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend188 || (_feBlend188 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix329 || (_feColorMatrix329 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite188 || (_feComposite188 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix330 || (_feColorMatrix330 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite189 || (_feComposite189 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix331 || (_feColorMatrix331 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood94 || (_feFlood94 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend189 || (_feBlend189 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend190 || (_feBlend190 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix332 || (_feColorMatrix332 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite190 || (_feComposite190 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix333 || (_feColorMatrix333 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix334 || (_feColorMatrix334 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7083",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite191 || (_feComposite191 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix335 || (_feColorMatrix335 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood95 || (_feFlood95 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend191 || (_feBlend191 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend192 || (_feBlend192 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix336 || (_feColorMatrix336 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite192 || (_feComposite192 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix337 || (_feColorMatrix337 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite193 || (_feComposite193 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix338 || (_feColorMatrix338 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood96 || (_feFlood96 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend193 || (_feBlend193 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend194 || (_feBlend194 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix339 || (_feColorMatrix339 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite194 || (_feComposite194 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix340 || (_feColorMatrix340 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix341 || (_feColorMatrix341 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7085",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite195 || (_feComposite195 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix342 || (_feColorMatrix342 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood97 || (_feFlood97 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend195 || (_feBlend195 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend196 || (_feBlend196 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix343 || (_feColorMatrix343 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite196 || (_feComposite196 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix344 || (_feColorMatrix344 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite197 || (_feComposite197 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix345 || (_feColorMatrix345 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood98 || (_feFlood98 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend197 || (_feBlend197 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend198 || (_feBlend198 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix346 || (_feColorMatrix346 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite198 || (_feComposite198 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix347 || (_feColorMatrix347 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix348 || (_feColorMatrix348 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7087",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite199 || (_feComposite199 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix349 || (_feColorMatrix349 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood99 || (_feFlood99 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend199 || (_feBlend199 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend200 || (_feBlend200 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix350 || (_feColorMatrix350 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite200 || (_feComposite200 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix351 || (_feColorMatrix351 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite201 || (_feComposite201 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix352 || (_feColorMatrix352 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood100 || (_feFlood100 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend201 || (_feBlend201 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend202 || (_feBlend202 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix353 || (_feColorMatrix353 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite202 || (_feComposite202 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix354 || (_feColorMatrix354 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix355 || (_feColorMatrix355 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7089",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite203 || (_feComposite203 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix356 || (_feColorMatrix356 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood101 || (_feFlood101 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend203 || (_feBlend203 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend204 || (_feBlend204 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix357 || (_feColorMatrix357 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite204 || (_feComposite204 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix358 || (_feColorMatrix358 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite205 || (_feComposite205 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix359 || (_feColorMatrix359 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood102 || (_feFlood102 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend205 || (_feBlend205 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend206 || (_feBlend206 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix360 || (_feColorMatrix360 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite206 || (_feComposite206 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix361 || (_feColorMatrix361 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix362 || (_feColorMatrix362 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7091",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite207 || (_feComposite207 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix363 || (_feColorMatrix363 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood103 || (_feFlood103 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend207 || (_feBlend207 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend208 || (_feBlend208 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix364 || (_feColorMatrix364 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite208 || (_feComposite208 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix365 || (_feColorMatrix365 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite209 || (_feComposite209 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix366 || (_feColorMatrix366 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood104 || (_feFlood104 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend209 || (_feBlend209 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend210 || (_feBlend210 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix367 || (_feColorMatrix367 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite210 || (_feComposite210 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix368 || (_feColorMatrix368 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix369 || (_feColorMatrix369 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7093",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite211 || (_feComposite211 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix370 || (_feColorMatrix370 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood105 || (_feFlood105 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend211 || (_feBlend211 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend212 || (_feBlend212 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix371 || (_feColorMatrix371 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite212 || (_feComposite212 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix372 || (_feColorMatrix372 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite213 || (_feComposite213 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix373 || (_feColorMatrix373 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood106 || (_feFlood106 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend213 || (_feBlend213 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend214 || (_feBlend214 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix374 || (_feColorMatrix374 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite214 || (_feComposite214 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix375 || (_feColorMatrix375 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix376 || (_feColorMatrix376 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7095",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite215 || (_feComposite215 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix377 || (_feColorMatrix377 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood107 || (_feFlood107 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend215 || (_feBlend215 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend216 || (_feBlend216 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix378 || (_feColorMatrix378 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite216 || (_feComposite216 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix379 || (_feColorMatrix379 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite217 || (_feComposite217 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix380 || (_feColorMatrix380 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood108 || (_feFlood108 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend217 || (_feBlend217 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend218 || (_feBlend218 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix381 || (_feColorMatrix381 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite218 || (_feComposite218 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix382 || (_feColorMatrix382 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix383 || (_feColorMatrix383 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7097",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite219 || (_feComposite219 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix384 || (_feColorMatrix384 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood109 || (_feFlood109 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend219 || (_feBlend219 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend220 || (_feBlend220 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix385 || (_feColorMatrix385 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite220 || (_feComposite220 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix386 || (_feColorMatrix386 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite221 || (_feComposite221 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix387 || (_feColorMatrix387 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood110 || (_feFlood110 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend221 || (_feBlend221 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend222 || (_feBlend222 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix388 || (_feColorMatrix388 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite222 || (_feComposite222 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix389 || (_feColorMatrix389 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix390 || (_feColorMatrix390 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7099",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite223 || (_feComposite223 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix391 || (_feColorMatrix391 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood111 || (_feFlood111 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend223 || (_feBlend223 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend224 || (_feBlend224 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix392 || (_feColorMatrix392 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite224 || (_feComposite224 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix393 || (_feColorMatrix393 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite225 || (_feComposite225 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix394 || (_feColorMatrix394 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood112 || (_feFlood112 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend225 || (_feBlend225 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend226 || (_feBlend226 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix395 || (_feColorMatrix395 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite226 || (_feComposite226 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix396 || (_feColorMatrix396 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix397 || (_feColorMatrix397 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7101",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite227 || (_feComposite227 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix398 || (_feColorMatrix398 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood113 || (_feFlood113 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend227 || (_feBlend227 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend228 || (_feBlend228 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix399 || (_feColorMatrix399 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite228 || (_feComposite228 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix400 || (_feColorMatrix400 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite229 || (_feComposite229 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix401 || (_feColorMatrix401 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood114 || (_feFlood114 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend229 || (_feBlend229 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend230 || (_feBlend230 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix402 || (_feColorMatrix402 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite230 || (_feComposite230 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix403 || (_feColorMatrix403 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix404 || (_feColorMatrix404 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7103",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite231 || (_feComposite231 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix405 || (_feColorMatrix405 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood115 || (_feFlood115 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend231 || (_feBlend231 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend232 || (_feBlend232 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix406 || (_feColorMatrix406 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite232 || (_feComposite232 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix407 || (_feColorMatrix407 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite233 || (_feComposite233 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix408 || (_feColorMatrix408 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood116 || (_feFlood116 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend233 || (_feBlend233 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend234 || (_feBlend234 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix409 || (_feColorMatrix409 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite234 || (_feComposite234 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix410 || (_feColorMatrix410 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix411 || (_feColorMatrix411 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7105",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite235 || (_feComposite235 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix412 || (_feColorMatrix412 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood117 || (_feFlood117 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend235 || (_feBlend235 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend236 || (_feBlend236 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix413 || (_feColorMatrix413 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite236 || (_feComposite236 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix414 || (_feColorMatrix414 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite237 || (_feComposite237 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix415 || (_feColorMatrix415 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood118 || (_feFlood118 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend237 || (_feBlend237 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend238 || (_feBlend238 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix416 || (_feColorMatrix416 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite238 || (_feComposite238 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix417 || (_feColorMatrix417 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix418 || (_feColorMatrix418 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7107",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite239 || (_feComposite239 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix419 || (_feColorMatrix419 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood119 || (_feFlood119 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend239 || (_feBlend239 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend240 || (_feBlend240 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix420 || (_feColorMatrix420 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite240 || (_feComposite240 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix421 || (_feColorMatrix421 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite241 || (_feComposite241 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix422 || (_feColorMatrix422 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood120 || (_feFlood120 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend241 || (_feBlend241 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend242 || (_feBlend242 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix423 || (_feColorMatrix423 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite242 || (_feComposite242 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix424 || (_feColorMatrix424 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix425 || (_feColorMatrix425 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7109",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite243 || (_feComposite243 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix426 || (_feColorMatrix426 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood121 || (_feFlood121 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend243 || (_feBlend243 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend244 || (_feBlend244 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix427 || (_feColorMatrix427 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite244 || (_feComposite244 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix428 || (_feColorMatrix428 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite245 || (_feComposite245 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix429 || (_feColorMatrix429 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood122 || (_feFlood122 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend245 || (_feBlend245 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend246 || (_feBlend246 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix430 || (_feColorMatrix430 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite246 || (_feComposite246 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix431 || (_feColorMatrix431 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix432 || (_feColorMatrix432 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7111",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite247 || (_feComposite247 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix433 || (_feColorMatrix433 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood123 || (_feFlood123 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend247 || (_feBlend247 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend248 || (_feBlend248 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix434 || (_feColorMatrix434 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite248 || (_feComposite248 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix435 || (_feColorMatrix435 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite249 || (_feComposite249 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix436 || (_feColorMatrix436 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood124 || (_feFlood124 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend249 || (_feBlend249 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend250 || (_feBlend250 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix437 || (_feColorMatrix437 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite250 || (_feComposite250 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix438 || (_feColorMatrix438 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix439 || (_feColorMatrix439 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7113",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite251 || (_feComposite251 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix440 || (_feColorMatrix440 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood125 || (_feFlood125 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend251 || (_feBlend251 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend252 || (_feBlend252 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix441 || (_feColorMatrix441 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite252 || (_feComposite252 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix442 || (_feColorMatrix442 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite253 || (_feComposite253 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix443 || (_feColorMatrix443 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood126 || (_feFlood126 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend253 || (_feBlend253 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend254 || (_feBlend254 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix444 || (_feColorMatrix444 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite254 || (_feComposite254 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix445 || (_feColorMatrix445 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix446 || (_feColorMatrix446 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7115",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite255 || (_feComposite255 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix447 || (_feColorMatrix447 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood127 || (_feFlood127 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend255 || (_feBlend255 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend256 || (_feBlend256 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix448 || (_feColorMatrix448 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite256 || (_feComposite256 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix449 || (_feColorMatrix449 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite257 || (_feComposite257 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix450 || (_feColorMatrix450 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood128 || (_feFlood128 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend257 || (_feBlend257 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend258 || (_feBlend258 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix451 || (_feColorMatrix451 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite258 || (_feComposite258 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix452 || (_feColorMatrix452 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix453 || (_feColorMatrix453 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7117",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite259 || (_feComposite259 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix454 || (_feColorMatrix454 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood129 || (_feFlood129 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend259 || (_feBlend259 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend260 || (_feBlend260 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix455 || (_feColorMatrix455 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite260 || (_feComposite260 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix456 || (_feColorMatrix456 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite261 || (_feComposite261 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix457 || (_feColorMatrix457 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood130 || (_feFlood130 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend261 || (_feBlend261 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend262 || (_feBlend262 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix458 || (_feColorMatrix458 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite262 || (_feComposite262 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix459 || (_feColorMatrix459 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix460 || (_feColorMatrix460 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7119",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite263 || (_feComposite263 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix461 || (_feColorMatrix461 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood131 || (_feFlood131 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend263 || (_feBlend263 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend264 || (_feBlend264 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix462 || (_feColorMatrix462 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite264 || (_feComposite264 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix463 || (_feColorMatrix463 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite265 || (_feComposite265 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix464 || (_feColorMatrix464 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood132 || (_feFlood132 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend265 || (_feBlend265 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend266 || (_feBlend266 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix465 || (_feColorMatrix465 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite266 || (_feComposite266 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix466 || (_feColorMatrix466 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix467 || (_feColorMatrix467 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7121",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite267 || (_feComposite267 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix468 || (_feColorMatrix468 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood133 || (_feFlood133 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend267 || (_feBlend267 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend268 || (_feBlend268 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix469 || (_feColorMatrix469 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite268 || (_feComposite268 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix470 || (_feColorMatrix470 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite269 || (_feComposite269 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix471 || (_feColorMatrix471 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood134 || (_feFlood134 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend269 || (_feBlend269 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend270 || (_feBlend270 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix472 || (_feColorMatrix472 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite270 || (_feComposite270 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix473 || (_feColorMatrix473 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix474 || (_feColorMatrix474 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7123",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite271 || (_feComposite271 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix475 || (_feColorMatrix475 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood135 || (_feFlood135 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend271 || (_feBlend271 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend272 || (_feBlend272 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix476 || (_feColorMatrix476 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite272 || (_feComposite272 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix477 || (_feColorMatrix477 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite273 || (_feComposite273 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix478 || (_feColorMatrix478 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood136 || (_feFlood136 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend273 || (_feBlend273 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend274 || (_feBlend274 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix479 || (_feColorMatrix479 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite274 || (_feComposite274 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix480 || (_feColorMatrix480 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix481 || (_feColorMatrix481 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7125",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite275 || (_feComposite275 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix482 || (_feColorMatrix482 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood137 || (_feFlood137 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend275 || (_feBlend275 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend276 || (_feBlend276 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix483 || (_feColorMatrix483 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite276 || (_feComposite276 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix484 || (_feColorMatrix484 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite277 || (_feComposite277 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix485 || (_feColorMatrix485 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood138 || (_feFlood138 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend277 || (_feBlend277 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend278 || (_feBlend278 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix486 || (_feColorMatrix486 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite278 || (_feComposite278 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix487 || (_feColorMatrix487 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix488 || (_feColorMatrix488 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7127",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite279 || (_feComposite279 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix489 || (_feColorMatrix489 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood139 || (_feFlood139 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend279 || (_feBlend279 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend280 || (_feBlend280 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix490 || (_feColorMatrix490 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite280 || (_feComposite280 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix491 || (_feColorMatrix491 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite281 || (_feComposite281 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix492 || (_feColorMatrix492 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood140 || (_feFlood140 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend281 || (_feBlend281 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend282 || (_feBlend282 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix493 || (_feColorMatrix493 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite282 || (_feComposite282 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix494 || (_feColorMatrix494 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix495 || (_feColorMatrix495 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7129",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite283 || (_feComposite283 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix496 || (_feColorMatrix496 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood141 || (_feFlood141 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend283 || (_feBlend283 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend284 || (_feBlend284 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix497 || (_feColorMatrix497 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite284 || (_feComposite284 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix498 || (_feColorMatrix498 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite285 || (_feComposite285 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix499 || (_feColorMatrix499 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood142 || (_feFlood142 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend285 || (_feBlend285 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend286 || (_feBlend286 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix500 || (_feColorMatrix500 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite286 || (_feComposite286 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix501 || (_feColorMatrix501 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix502 || (_feColorMatrix502 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7131",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite287 || (_feComposite287 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix503 || (_feColorMatrix503 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood143 || (_feFlood143 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend287 || (_feBlend287 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend288 || (_feBlend288 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix504 || (_feColorMatrix504 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite288 || (_feComposite288 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix505 || (_feColorMatrix505 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite289 || (_feComposite289 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix506 || (_feColorMatrix506 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood144 || (_feFlood144 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend289 || (_feBlend289 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend290 || (_feBlend290 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix507 || (_feColorMatrix507 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite290 || (_feComposite290 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix508 || (_feColorMatrix508 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix509 || (_feColorMatrix509 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7133",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite291 || (_feComposite291 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix510 || (_feColorMatrix510 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood145 || (_feFlood145 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend291 || (_feBlend291 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend292 || (_feBlend292 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix511 || (_feColorMatrix511 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite292 || (_feComposite292 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix512 || (_feColorMatrix512 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite293 || (_feComposite293 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix513 || (_feColorMatrix513 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood146 || (_feFlood146 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend293 || (_feBlend293 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend294 || (_feBlend294 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix514 || (_feColorMatrix514 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite294 || (_feComposite294 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix515 || (_feColorMatrix515 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix516 || (_feColorMatrix516 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7135",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite295 || (_feComposite295 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix517 || (_feColorMatrix517 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood147 || (_feFlood147 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend295 || (_feBlend295 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend296 || (_feBlend296 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix518 || (_feColorMatrix518 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite296 || (_feComposite296 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix519 || (_feColorMatrix519 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite297 || (_feComposite297 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix520 || (_feColorMatrix520 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood148 || (_feFlood148 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend297 || (_feBlend297 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend298 || (_feBlend298 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix521 || (_feColorMatrix521 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite298 || (_feComposite298 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix522 || (_feColorMatrix522 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix523 || (_feColorMatrix523 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7137",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite299 || (_feComposite299 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix524 || (_feColorMatrix524 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood149 || (_feFlood149 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend299 || (_feBlend299 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend300 || (_feBlend300 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix525 || (_feColorMatrix525 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite300 || (_feComposite300 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix526 || (_feColorMatrix526 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite301 || (_feComposite301 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix527 || (_feColorMatrix527 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood150 || (_feFlood150 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend301 || (_feBlend301 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend302 || (_feBlend302 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix528 || (_feColorMatrix528 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite302 || (_feComposite302 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix529 || (_feColorMatrix529 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix530 || (_feColorMatrix530 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7139",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite303 || (_feComposite303 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix531 || (_feColorMatrix531 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood151 || (_feFlood151 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend303 || (_feBlend303 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend304 || (_feBlend304 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix532 || (_feColorMatrix532 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite304 || (_feComposite304 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix533 || (_feColorMatrix533 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite305 || (_feComposite305 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix534 || (_feColorMatrix534 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood152 || (_feFlood152 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend305 || (_feBlend305 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend306 || (_feBlend306 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix535 || (_feColorMatrix535 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite306 || (_feComposite306 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix536 || (_feColorMatrix536 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix537 || (_feColorMatrix537 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7141",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite307 || (_feComposite307 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix538 || (_feColorMatrix538 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood153 || (_feFlood153 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend307 || (_feBlend307 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend308 || (_feBlend308 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix539 || (_feColorMatrix539 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite308 || (_feComposite308 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix540 || (_feColorMatrix540 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite309 || (_feComposite309 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix541 || (_feColorMatrix541 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood154 || (_feFlood154 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend309 || (_feBlend309 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend310 || (_feBlend310 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix542 || (_feColorMatrix542 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite310 || (_feComposite310 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix543 || (_feColorMatrix543 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix544 || (_feColorMatrix544 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7143",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite311 || (_feComposite311 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix545 || (_feColorMatrix545 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood155 || (_feFlood155 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend311 || (_feBlend311 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend312 || (_feBlend312 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix546 || (_feColorMatrix546 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite312 || (_feComposite312 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix547 || (_feColorMatrix547 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite313 || (_feComposite313 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix548 || (_feColorMatrix548 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood156 || (_feFlood156 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend313 || (_feBlend313 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend314 || (_feBlend314 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix549 || (_feColorMatrix549 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite314 || (_feComposite314 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix550 || (_feColorMatrix550 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix551 || (_feColorMatrix551 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7145",
    x: -0.24989,
    y: -0.2504,
    width: 1.4998,
    height: 1.5008,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite315 || (_feComposite315 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix552 || (_feColorMatrix552 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood157 || (_feFlood157 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend315 || (_feBlend315 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend316 || (_feBlend316 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix553 || (_feColorMatrix553 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite316 || (_feComposite316 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix554 || (_feColorMatrix554 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite317 || (_feComposite317 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix555 || (_feColorMatrix555 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood158 || (_feFlood158 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend317 || (_feBlend317 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend318 || (_feBlend318 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix556 || (_feColorMatrix556 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite318 || (_feComposite318 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix557 || (_feColorMatrix557 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix558 || (_feColorMatrix558 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7147",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite319 || (_feComposite319 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix559 || (_feColorMatrix559 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood159 || (_feFlood159 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend319 || (_feBlend319 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend320 || (_feBlend320 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix560 || (_feColorMatrix560 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite320 || (_feComposite320 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix561 || (_feColorMatrix561 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite321 || (_feComposite321 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix562 || (_feColorMatrix562 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood160 || (_feFlood160 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend321 || (_feBlend321 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend322 || (_feBlend322 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix563 || (_feColorMatrix563 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite322 || (_feComposite322 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix564 || (_feColorMatrix564 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix565 || (_feColorMatrix565 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7149",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite323 || (_feComposite323 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix566 || (_feColorMatrix566 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood161 || (_feFlood161 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend323 || (_feBlend323 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend324 || (_feBlend324 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix567 || (_feColorMatrix567 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite324 || (_feComposite324 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix568 || (_feColorMatrix568 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite325 || (_feComposite325 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix569 || (_feColorMatrix569 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood162 || (_feFlood162 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend325 || (_feBlend325 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend326 || (_feBlend326 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix570 || (_feColorMatrix570 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite326 || (_feComposite326 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix571 || (_feColorMatrix571 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix572 || (_feColorMatrix572 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7151",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite327 || (_feComposite327 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix573 || (_feColorMatrix573 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood163 || (_feFlood163 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend327 || (_feBlend327 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend328 || (_feBlend328 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix574 || (_feColorMatrix574 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite328 || (_feComposite328 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix575 || (_feColorMatrix575 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite329 || (_feComposite329 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix576 || (_feColorMatrix576 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood164 || (_feFlood164 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend329 || (_feBlend329 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend330 || (_feBlend330 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix577 || (_feColorMatrix577 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite330 || (_feComposite330 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix578 || (_feColorMatrix578 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix579 || (_feColorMatrix579 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7153",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite331 || (_feComposite331 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix580 || (_feColorMatrix580 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood165 || (_feFlood165 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend331 || (_feBlend331 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend332 || (_feBlend332 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix581 || (_feColorMatrix581 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite332 || (_feComposite332 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix582 || (_feColorMatrix582 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite333 || (_feComposite333 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix583 || (_feColorMatrix583 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood166 || (_feFlood166 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend333 || (_feBlend333 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend334 || (_feBlend334 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix584 || (_feColorMatrix584 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite334 || (_feComposite334 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix585 || (_feColorMatrix585 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix586 || (_feColorMatrix586 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7155",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite335 || (_feComposite335 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix587 || (_feColorMatrix587 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood167 || (_feFlood167 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend335 || (_feBlend335 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend336 || (_feBlend336 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix588 || (_feColorMatrix588 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite336 || (_feComposite336 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix589 || (_feColorMatrix589 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite337 || (_feComposite337 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix590 || (_feColorMatrix590 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood168 || (_feFlood168 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend337 || (_feBlend337 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend338 || (_feBlend338 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix591 || (_feColorMatrix591 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite338 || (_feComposite338 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix592 || (_feColorMatrix592 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix593 || (_feColorMatrix593 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7157",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite339 || (_feComposite339 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix594 || (_feColorMatrix594 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood169 || (_feFlood169 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend339 || (_feBlend339 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend340 || (_feBlend340 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix595 || (_feColorMatrix595 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite340 || (_feComposite340 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix596 || (_feColorMatrix596 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite341 || (_feComposite341 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix597 || (_feColorMatrix597 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood170 || (_feFlood170 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend341 || (_feBlend341 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend342 || (_feBlend342 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix598 || (_feColorMatrix598 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite342 || (_feComposite342 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix599 || (_feColorMatrix599 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix600 || (_feColorMatrix600 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7159",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite343 || (_feComposite343 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix601 || (_feColorMatrix601 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood171 || (_feFlood171 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend343 || (_feBlend343 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend344 || (_feBlend344 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix602 || (_feColorMatrix602 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite344 || (_feComposite344 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix603 || (_feColorMatrix603 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite345 || (_feComposite345 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix604 || (_feColorMatrix604 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood172 || (_feFlood172 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend345 || (_feBlend345 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend346 || (_feBlend346 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix605 || (_feColorMatrix605 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite346 || (_feComposite346 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix606 || (_feColorMatrix606 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix607 || (_feColorMatrix607 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7161",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite347 || (_feComposite347 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix608 || (_feColorMatrix608 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood173 || (_feFlood173 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend347 || (_feBlend347 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend348 || (_feBlend348 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix609 || (_feColorMatrix609 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite348 || (_feComposite348 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix610 || (_feColorMatrix610 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite349 || (_feComposite349 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix611 || (_feColorMatrix611 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood174 || (_feFlood174 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend349 || (_feBlend349 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend350 || (_feBlend350 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix612 || (_feColorMatrix612 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite350 || (_feComposite350 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix613 || (_feColorMatrix613 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix614 || (_feColorMatrix614 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7163",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite351 || (_feComposite351 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix615 || (_feColorMatrix615 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood175 || (_feFlood175 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend351 || (_feBlend351 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend352 || (_feBlend352 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix616 || (_feColorMatrix616 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite352 || (_feComposite352 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix617 || (_feColorMatrix617 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite353 || (_feComposite353 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix618 || (_feColorMatrix618 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood176 || (_feFlood176 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend353 || (_feBlend353 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend354 || (_feBlend354 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix619 || (_feColorMatrix619 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite354 || (_feComposite354 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix620 || (_feColorMatrix620 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix621 || (_feColorMatrix621 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7165",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite355 || (_feComposite355 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix622 || (_feColorMatrix622 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood177 || (_feFlood177 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend355 || (_feBlend355 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend356 || (_feBlend356 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix623 || (_feColorMatrix623 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite356 || (_feComposite356 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix624 || (_feColorMatrix624 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite357 || (_feComposite357 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix625 || (_feColorMatrix625 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood178 || (_feFlood178 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend357 || (_feBlend357 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend358 || (_feBlend358 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix626 || (_feColorMatrix626 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite358 || (_feComposite358 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix627 || (_feColorMatrix627 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix628 || (_feColorMatrix628 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7167",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite359 || (_feComposite359 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix629 || (_feColorMatrix629 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood179 || (_feFlood179 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend359 || (_feBlend359 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend360 || (_feBlend360 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix630 || (_feColorMatrix630 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite360 || (_feComposite360 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix631 || (_feColorMatrix631 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite361 || (_feComposite361 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix632 || (_feColorMatrix632 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood180 || (_feFlood180 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend361 || (_feBlend361 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend362 || (_feBlend362 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix633 || (_feColorMatrix633 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite362 || (_feComposite362 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix634 || (_feColorMatrix634 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix635 || (_feColorMatrix635 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7169",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite363 || (_feComposite363 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix636 || (_feColorMatrix636 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood181 || (_feFlood181 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend363 || (_feBlend363 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend364 || (_feBlend364 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix637 || (_feColorMatrix637 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite364 || (_feComposite364 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix638 || (_feColorMatrix638 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite365 || (_feComposite365 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix639 || (_feColorMatrix639 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood182 || (_feFlood182 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend365 || (_feBlend365 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend366 || (_feBlend366 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix640 || (_feColorMatrix640 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite366 || (_feComposite366 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix641 || (_feColorMatrix641 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix642 || (_feColorMatrix642 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7171",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite367 || (_feComposite367 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix643 || (_feColorMatrix643 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood183 || (_feFlood183 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend367 || (_feBlend367 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend368 || (_feBlend368 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix644 || (_feColorMatrix644 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite368 || (_feComposite368 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix645 || (_feColorMatrix645 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite369 || (_feComposite369 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix646 || (_feColorMatrix646 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood184 || (_feFlood184 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend369 || (_feBlend369 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend370 || (_feBlend370 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix647 || (_feColorMatrix647 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite370 || (_feComposite370 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix648 || (_feColorMatrix648 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix649 || (_feColorMatrix649 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7173",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite371 || (_feComposite371 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix650 || (_feColorMatrix650 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood185 || (_feFlood185 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend371 || (_feBlend371 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend372 || (_feBlend372 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix651 || (_feColorMatrix651 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite372 || (_feComposite372 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix652 || (_feColorMatrix652 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite373 || (_feComposite373 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix653 || (_feColorMatrix653 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood186 || (_feFlood186 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend373 || (_feBlend373 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend374 || (_feBlend374 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix654 || (_feColorMatrix654 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite374 || (_feComposite374 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix655 || (_feColorMatrix655 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix656 || (_feColorMatrix656 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7175",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite375 || (_feComposite375 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix657 || (_feColorMatrix657 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood187 || (_feFlood187 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend375 || (_feBlend375 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend376 || (_feBlend376 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix658 || (_feColorMatrix658 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite376 || (_feComposite376 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix659 || (_feColorMatrix659 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite377 || (_feComposite377 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix660 || (_feColorMatrix660 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood188 || (_feFlood188 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend377 || (_feBlend377 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend378 || (_feBlend378 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix661 || (_feColorMatrix661 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite378 || (_feComposite378 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix662 || (_feColorMatrix662 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix663 || (_feColorMatrix663 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7177",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite379 || (_feComposite379 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix664 || (_feColorMatrix664 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood189 || (_feFlood189 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend379 || (_feBlend379 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend380 || (_feBlend380 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix665 || (_feColorMatrix665 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite380 || (_feComposite380 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix666 || (_feColorMatrix666 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite381 || (_feComposite381 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix667 || (_feColorMatrix667 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood190 || (_feFlood190 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend381 || (_feBlend381 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend382 || (_feBlend382 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix668 || (_feColorMatrix668 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite382 || (_feComposite382 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix669 || (_feColorMatrix669 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix670 || (_feColorMatrix670 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7179",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite383 || (_feComposite383 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix671 || (_feColorMatrix671 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood191 || (_feFlood191 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend383 || (_feBlend383 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend384 || (_feBlend384 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix672 || (_feColorMatrix672 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite384 || (_feComposite384 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix673 || (_feColorMatrix673 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite385 || (_feComposite385 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix674 || (_feColorMatrix674 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood192 || (_feFlood192 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend385 || (_feBlend385 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend386 || (_feBlend386 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix675 || (_feColorMatrix675 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite386 || (_feComposite386 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix676 || (_feColorMatrix676 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix677 || (_feColorMatrix677 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7181",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite387 || (_feComposite387 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix678 || (_feColorMatrix678 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood193 || (_feFlood193 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend387 || (_feBlend387 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend388 || (_feBlend388 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix679 || (_feColorMatrix679 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite388 || (_feComposite388 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix680 || (_feColorMatrix680 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite389 || (_feComposite389 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix681 || (_feColorMatrix681 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood194 || (_feFlood194 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend389 || (_feBlend389 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend390 || (_feBlend390 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix682 || (_feColorMatrix682 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite390 || (_feComposite390 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix683 || (_feColorMatrix683 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix684 || (_feColorMatrix684 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7183",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite391 || (_feComposite391 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix685 || (_feColorMatrix685 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood195 || (_feFlood195 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend391 || (_feBlend391 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend392 || (_feBlend392 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix686 || (_feColorMatrix686 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite392 || (_feComposite392 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix687 || (_feColorMatrix687 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite393 || (_feComposite393 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix688 || (_feColorMatrix688 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood196 || (_feFlood196 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend393 || (_feBlend393 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend394 || (_feBlend394 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix689 || (_feColorMatrix689 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite394 || (_feComposite394 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix690 || (_feColorMatrix690 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix691 || (_feColorMatrix691 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7185",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite395 || (_feComposite395 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix692 || (_feColorMatrix692 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood197 || (_feFlood197 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend395 || (_feBlend395 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend396 || (_feBlend396 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix693 || (_feColorMatrix693 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite396 || (_feComposite396 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix694 || (_feColorMatrix694 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite397 || (_feComposite397 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix695 || (_feColorMatrix695 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood198 || (_feFlood198 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend397 || (_feBlend397 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend398 || (_feBlend398 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix696 || (_feColorMatrix696 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite398 || (_feComposite398 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix697 || (_feColorMatrix697 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix698 || (_feColorMatrix698 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7187",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite399 || (_feComposite399 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix699 || (_feColorMatrix699 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood199 || (_feFlood199 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend399 || (_feBlend399 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend400 || (_feBlend400 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix700 || (_feColorMatrix700 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite400 || (_feComposite400 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix701 || (_feColorMatrix701 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite401 || (_feComposite401 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix702 || (_feColorMatrix702 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood200 || (_feFlood200 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend401 || (_feBlend401 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend402 || (_feBlend402 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix703 || (_feColorMatrix703 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite402 || (_feComposite402 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix704 || (_feColorMatrix704 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix705 || (_feColorMatrix705 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7189",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite403 || (_feComposite403 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix706 || (_feColorMatrix706 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood201 || (_feFlood201 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend403 || (_feBlend403 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend404 || (_feBlend404 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix707 || (_feColorMatrix707 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite404 || (_feComposite404 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix708 || (_feColorMatrix708 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite405 || (_feComposite405 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix709 || (_feColorMatrix709 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood202 || (_feFlood202 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend405 || (_feBlend405 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend406 || (_feBlend406 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix710 || (_feColorMatrix710 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite406 || (_feComposite406 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix711 || (_feColorMatrix711 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix712 || (_feColorMatrix712 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7191",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite407 || (_feComposite407 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix713 || (_feColorMatrix713 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood203 || (_feFlood203 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend407 || (_feBlend407 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend408 || (_feBlend408 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix714 || (_feColorMatrix714 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite408 || (_feComposite408 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix715 || (_feColorMatrix715 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite409 || (_feComposite409 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix716 || (_feColorMatrix716 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood204 || (_feFlood204 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend409 || (_feBlend409 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend410 || (_feBlend410 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix717 || (_feColorMatrix717 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite410 || (_feComposite410 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix718 || (_feColorMatrix718 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix719 || (_feColorMatrix719 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7193",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite411 || (_feComposite411 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix720 || (_feColorMatrix720 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood205 || (_feFlood205 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend411 || (_feBlend411 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend412 || (_feBlend412 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix721 || (_feColorMatrix721 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite412 || (_feComposite412 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix722 || (_feColorMatrix722 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite413 || (_feComposite413 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix723 || (_feColorMatrix723 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood206 || (_feFlood206 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend413 || (_feBlend413 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend414 || (_feBlend414 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix724 || (_feColorMatrix724 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite414 || (_feComposite414 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix725 || (_feColorMatrix725 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix726 || (_feColorMatrix726 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7195",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite415 || (_feComposite415 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix727 || (_feColorMatrix727 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood207 || (_feFlood207 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend415 || (_feBlend415 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend416 || (_feBlend416 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix728 || (_feColorMatrix728 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite416 || (_feComposite416 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix729 || (_feColorMatrix729 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite417 || (_feComposite417 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix730 || (_feColorMatrix730 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood208 || (_feFlood208 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend417 || (_feBlend417 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend418 || (_feBlend418 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix731 || (_feColorMatrix731 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite418 || (_feComposite418 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix732 || (_feColorMatrix732 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix733 || (_feColorMatrix733 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7197",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite419 || (_feComposite419 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix734 || (_feColorMatrix734 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood209 || (_feFlood209 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend419 || (_feBlend419 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend420 || (_feBlend420 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix735 || (_feColorMatrix735 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite420 || (_feComposite420 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix736 || (_feColorMatrix736 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite421 || (_feComposite421 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix737 || (_feColorMatrix737 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood210 || (_feFlood210 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend421 || (_feBlend421 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend422 || (_feBlend422 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix738 || (_feColorMatrix738 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite422 || (_feComposite422 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix739 || (_feColorMatrix739 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix740 || (_feColorMatrix740 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7199",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite423 || (_feComposite423 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix741 || (_feColorMatrix741 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood211 || (_feFlood211 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend423 || (_feBlend423 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend424 || (_feBlend424 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix742 || (_feColorMatrix742 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite424 || (_feComposite424 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix743 || (_feColorMatrix743 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite425 || (_feComposite425 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix744 || (_feColorMatrix744 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood212 || (_feFlood212 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend425 || (_feBlend425 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend426 || (_feBlend426 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix745 || (_feColorMatrix745 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite426 || (_feComposite426 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix746 || (_feColorMatrix746 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix747 || (_feColorMatrix747 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7201",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite427 || (_feComposite427 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix748 || (_feColorMatrix748 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood213 || (_feFlood213 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend427 || (_feBlend427 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend428 || (_feBlend428 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix749 || (_feColorMatrix749 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite428 || (_feComposite428 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix750 || (_feColorMatrix750 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite429 || (_feComposite429 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix751 || (_feColorMatrix751 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood214 || (_feFlood214 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend429 || (_feBlend429 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend430 || (_feBlend430 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix752 || (_feColorMatrix752 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite430 || (_feComposite430 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix753 || (_feColorMatrix753 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix754 || (_feColorMatrix754 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7203",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite431 || (_feComposite431 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix755 || (_feColorMatrix755 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood215 || (_feFlood215 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend431 || (_feBlend431 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend432 || (_feBlend432 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix756 || (_feColorMatrix756 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite432 || (_feComposite432 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix757 || (_feColorMatrix757 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite433 || (_feComposite433 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix758 || (_feColorMatrix758 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood216 || (_feFlood216 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend433 || (_feBlend433 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend434 || (_feBlend434 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix759 || (_feColorMatrix759 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite434 || (_feComposite434 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix760 || (_feColorMatrix760 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix761 || (_feColorMatrix761 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7205",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite435 || (_feComposite435 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix762 || (_feColorMatrix762 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood217 || (_feFlood217 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend435 || (_feBlend435 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend436 || (_feBlend436 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix763 || (_feColorMatrix763 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite436 || (_feComposite436 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix764 || (_feColorMatrix764 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite437 || (_feComposite437 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix765 || (_feColorMatrix765 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood218 || (_feFlood218 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend437 || (_feBlend437 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend438 || (_feBlend438 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix766 || (_feColorMatrix766 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite438 || (_feComposite438 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix767 || (_feColorMatrix767 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix768 || (_feColorMatrix768 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7207",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite439 || (_feComposite439 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix769 || (_feColorMatrix769 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood219 || (_feFlood219 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend439 || (_feBlend439 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend440 || (_feBlend440 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix770 || (_feColorMatrix770 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite440 || (_feComposite440 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix771 || (_feColorMatrix771 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite441 || (_feComposite441 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix772 || (_feColorMatrix772 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood220 || (_feFlood220 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend441 || (_feBlend441 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend442 || (_feBlend442 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix773 || (_feColorMatrix773 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite442 || (_feComposite442 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix774 || (_feColorMatrix774 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix775 || (_feColorMatrix775 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7209",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite443 || (_feComposite443 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix776 || (_feColorMatrix776 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood221 || (_feFlood221 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend443 || (_feBlend443 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend444 || (_feBlend444 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix777 || (_feColorMatrix777 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite444 || (_feComposite444 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix778 || (_feColorMatrix778 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite445 || (_feComposite445 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix779 || (_feColorMatrix779 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood222 || (_feFlood222 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend445 || (_feBlend445 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend446 || (_feBlend446 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix780 || (_feColorMatrix780 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite446 || (_feComposite446 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix781 || (_feColorMatrix781 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix782 || (_feColorMatrix782 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7211",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite447 || (_feComposite447 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix783 || (_feColorMatrix783 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood223 || (_feFlood223 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend447 || (_feBlend447 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend448 || (_feBlend448 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix784 || (_feColorMatrix784 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite448 || (_feComposite448 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix785 || (_feColorMatrix785 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite449 || (_feComposite449 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix786 || (_feColorMatrix786 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood224 || (_feFlood224 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend449 || (_feBlend449 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend450 || (_feBlend450 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix787 || (_feColorMatrix787 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite450 || (_feComposite450 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix788 || (_feColorMatrix788 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix789 || (_feColorMatrix789 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7213",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite451 || (_feComposite451 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix790 || (_feColorMatrix790 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood225 || (_feFlood225 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend451 || (_feBlend451 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend452 || (_feBlend452 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix791 || (_feColorMatrix791 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite452 || (_feComposite452 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix792 || (_feColorMatrix792 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite453 || (_feComposite453 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix793 || (_feColorMatrix793 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood226 || (_feFlood226 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend453 || (_feBlend453 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend454 || (_feBlend454 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix794 || (_feColorMatrix794 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite454 || (_feComposite454 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix795 || (_feColorMatrix795 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix796 || (_feColorMatrix796 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7215",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite455 || (_feComposite455 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix797 || (_feColorMatrix797 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood227 || (_feFlood227 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend455 || (_feBlend455 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend456 || (_feBlend456 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix798 || (_feColorMatrix798 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite456 || (_feComposite456 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix799 || (_feColorMatrix799 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite457 || (_feComposite457 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix800 || (_feColorMatrix800 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood228 || (_feFlood228 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend457 || (_feBlend457 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend458 || (_feBlend458 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix801 || (_feColorMatrix801 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite458 || (_feComposite458 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix802 || (_feColorMatrix802 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix803 || (_feColorMatrix803 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7217",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite459 || (_feComposite459 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix804 || (_feColorMatrix804 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood229 || (_feFlood229 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend459 || (_feBlend459 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend460 || (_feBlend460 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix805 || (_feColorMatrix805 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite460 || (_feComposite460 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix806 || (_feColorMatrix806 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite461 || (_feComposite461 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix807 || (_feColorMatrix807 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood230 || (_feFlood230 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend461 || (_feBlend461 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend462 || (_feBlend462 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix808 || (_feColorMatrix808 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite462 || (_feComposite462 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix809 || (_feColorMatrix809 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix810 || (_feColorMatrix810 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7219",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite463 || (_feComposite463 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix811 || (_feColorMatrix811 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood231 || (_feFlood231 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend463 || (_feBlend463 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend464 || (_feBlend464 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix812 || (_feColorMatrix812 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite464 || (_feComposite464 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix813 || (_feColorMatrix813 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite465 || (_feComposite465 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix814 || (_feColorMatrix814 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood232 || (_feFlood232 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend465 || (_feBlend465 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend466 || (_feBlend466 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix815 || (_feColorMatrix815 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite466 || (_feComposite466 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix816 || (_feColorMatrix816 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix817 || (_feColorMatrix817 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7221",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite467 || (_feComposite467 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix818 || (_feColorMatrix818 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood233 || (_feFlood233 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend467 || (_feBlend467 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend468 || (_feBlend468 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix819 || (_feColorMatrix819 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite468 || (_feComposite468 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix820 || (_feColorMatrix820 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite469 || (_feComposite469 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix821 || (_feColorMatrix821 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood234 || (_feFlood234 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend469 || (_feBlend469 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend470 || (_feBlend470 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix822 || (_feColorMatrix822 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite470 || (_feComposite470 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix823 || (_feColorMatrix823 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix824 || (_feColorMatrix824 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7223",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite471 || (_feComposite471 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix825 || (_feColorMatrix825 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood235 || (_feFlood235 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend471 || (_feBlend471 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend472 || (_feBlend472 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix826 || (_feColorMatrix826 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite472 || (_feComposite472 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix827 || (_feColorMatrix827 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite473 || (_feComposite473 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix828 || (_feColorMatrix828 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood236 || (_feFlood236 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend473 || (_feBlend473 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend474 || (_feBlend474 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix829 || (_feColorMatrix829 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite474 || (_feComposite474 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix830 || (_feColorMatrix830 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix831 || (_feColorMatrix831 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7225",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite475 || (_feComposite475 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix832 || (_feColorMatrix832 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood237 || (_feFlood237 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend475 || (_feBlend475 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend476 || (_feBlend476 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix833 || (_feColorMatrix833 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite476 || (_feComposite476 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix834 || (_feColorMatrix834 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite477 || (_feComposite477 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix835 || (_feColorMatrix835 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood238 || (_feFlood238 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend477 || (_feBlend477 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend478 || (_feBlend478 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix836 || (_feColorMatrix836 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite478 || (_feComposite478 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix837 || (_feColorMatrix837 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix838 || (_feColorMatrix838 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7227",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite479 || (_feComposite479 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix839 || (_feColorMatrix839 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood239 || (_feFlood239 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend479 || (_feBlend479 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend480 || (_feBlend480 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix840 || (_feColorMatrix840 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite480 || (_feComposite480 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix841 || (_feColorMatrix841 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite481 || (_feComposite481 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix842 || (_feColorMatrix842 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood240 || (_feFlood240 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend481 || (_feBlend481 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend482 || (_feBlend482 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix843 || (_feColorMatrix843 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite482 || (_feComposite482 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix844 || (_feColorMatrix844 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix845 || (_feColorMatrix845 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7229",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite483 || (_feComposite483 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix846 || (_feColorMatrix846 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood241 || (_feFlood241 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend483 || (_feBlend483 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend484 || (_feBlend484 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix847 || (_feColorMatrix847 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite484 || (_feComposite484 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix848 || (_feColorMatrix848 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite485 || (_feComposite485 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix849 || (_feColorMatrix849 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood242 || (_feFlood242 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend485 || (_feBlend485 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend486 || (_feBlend486 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix850 || (_feColorMatrix850 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite486 || (_feComposite486 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix851 || (_feColorMatrix851 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix852 || (_feColorMatrix852 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7231",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite487 || (_feComposite487 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix853 || (_feColorMatrix853 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood243 || (_feFlood243 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend487 || (_feBlend487 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend488 || (_feBlend488 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix854 || (_feColorMatrix854 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite488 || (_feComposite488 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix855 || (_feColorMatrix855 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite489 || (_feComposite489 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix856 || (_feColorMatrix856 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood244 || (_feFlood244 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend489 || (_feBlend489 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend490 || (_feBlend490 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix857 || (_feColorMatrix857 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite490 || (_feComposite490 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix858 || (_feColorMatrix858 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix859 || (_feColorMatrix859 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7233",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite491 || (_feComposite491 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix860 || (_feColorMatrix860 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood245 || (_feFlood245 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend491 || (_feBlend491 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend492 || (_feBlend492 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix861 || (_feColorMatrix861 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite492 || (_feComposite492 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix862 || (_feColorMatrix862 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite493 || (_feComposite493 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix863 || (_feColorMatrix863 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood246 || (_feFlood246 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend493 || (_feBlend493 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend494 || (_feBlend494 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix864 || (_feColorMatrix864 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite494 || (_feComposite494 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix865 || (_feColorMatrix865 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix866 || (_feColorMatrix866 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7235",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite495 || (_feComposite495 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix867 || (_feColorMatrix867 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood247 || (_feFlood247 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend495 || (_feBlend495 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend496 || (_feBlend496 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix868 || (_feColorMatrix868 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite496 || (_feComposite496 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix869 || (_feColorMatrix869 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite497 || (_feComposite497 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix870 || (_feColorMatrix870 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood248 || (_feFlood248 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend497 || (_feBlend497 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend498 || (_feBlend498 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix871 || (_feColorMatrix871 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite498 || (_feComposite498 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix872 || (_feColorMatrix872 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix873 || (_feColorMatrix873 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7237",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite499 || (_feComposite499 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix874 || (_feColorMatrix874 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood249 || (_feFlood249 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend499 || (_feBlend499 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend500 || (_feBlend500 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix875 || (_feColorMatrix875 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite500 || (_feComposite500 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix876 || (_feColorMatrix876 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite501 || (_feComposite501 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix877 || (_feColorMatrix877 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood250 || (_feFlood250 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend501 || (_feBlend501 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend502 || (_feBlend502 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix878 || (_feColorMatrix878 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite502 || (_feComposite502 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix879 || (_feColorMatrix879 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix880 || (_feColorMatrix880 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7239",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite503 || (_feComposite503 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix881 || (_feColorMatrix881 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood251 || (_feFlood251 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend503 || (_feBlend503 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend504 || (_feBlend504 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix882 || (_feColorMatrix882 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite504 || (_feComposite504 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix883 || (_feColorMatrix883 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite505 || (_feComposite505 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix884 || (_feColorMatrix884 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood252 || (_feFlood252 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend505 || (_feBlend505 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend506 || (_feBlend506 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix885 || (_feColorMatrix885 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite506 || (_feComposite506 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix886 || (_feColorMatrix886 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix887 || (_feColorMatrix887 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7241",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite507 || (_feComposite507 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix888 || (_feColorMatrix888 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood253 || (_feFlood253 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend507 || (_feBlend507 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend508 || (_feBlend508 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix889 || (_feColorMatrix889 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite508 || (_feComposite508 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix890 || (_feColorMatrix890 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite509 || (_feComposite509 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix891 || (_feColorMatrix891 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood254 || (_feFlood254 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend509 || (_feBlend509 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend510 || (_feBlend510 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix892 || (_feColorMatrix892 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite510 || (_feComposite510 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix893 || (_feColorMatrix893 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix894 || (_feColorMatrix894 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7243",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite511 || (_feComposite511 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix895 || (_feColorMatrix895 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood255 || (_feFlood255 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend511 || (_feBlend511 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend512 || (_feBlend512 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix896 || (_feColorMatrix896 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite512 || (_feComposite512 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix897 || (_feColorMatrix897 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite513 || (_feComposite513 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix898 || (_feColorMatrix898 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood256 || (_feFlood256 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend513 || (_feBlend513 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend514 || (_feBlend514 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix899 || (_feColorMatrix899 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite514 || (_feComposite514 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix900 || (_feColorMatrix900 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix901 || (_feColorMatrix901 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7245",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite515 || (_feComposite515 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix902 || (_feColorMatrix902 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood257 || (_feFlood257 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend515 || (_feBlend515 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend516 || (_feBlend516 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix903 || (_feColorMatrix903 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite516 || (_feComposite516 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix904 || (_feColorMatrix904 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite517 || (_feComposite517 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix905 || (_feColorMatrix905 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood258 || (_feFlood258 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend517 || (_feBlend517 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend518 || (_feBlend518 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix906 || (_feColorMatrix906 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite518 || (_feComposite518 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix907 || (_feColorMatrix907 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix908 || (_feColorMatrix908 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7247",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite519 || (_feComposite519 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix909 || (_feColorMatrix909 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood259 || (_feFlood259 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend519 || (_feBlend519 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend520 || (_feBlend520 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix910 || (_feColorMatrix910 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite520 || (_feComposite520 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix911 || (_feColorMatrix911 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite521 || (_feComposite521 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix912 || (_feColorMatrix912 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood260 || (_feFlood260 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend521 || (_feBlend521 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend522 || (_feBlend522 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix913 || (_feColorMatrix913 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite522 || (_feComposite522 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix914 || (_feColorMatrix914 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix915 || (_feColorMatrix915 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7249",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite523 || (_feComposite523 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix916 || (_feColorMatrix916 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood261 || (_feFlood261 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend523 || (_feBlend523 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend524 || (_feBlend524 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix917 || (_feColorMatrix917 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite524 || (_feComposite524 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix918 || (_feColorMatrix918 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite525 || (_feComposite525 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix919 || (_feColorMatrix919 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood262 || (_feFlood262 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend525 || (_feBlend525 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend526 || (_feBlend526 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix920 || (_feColorMatrix920 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite526 || (_feComposite526 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix921 || (_feColorMatrix921 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix922 || (_feColorMatrix922 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7251",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite527 || (_feComposite527 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix923 || (_feColorMatrix923 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood263 || (_feFlood263 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend527 || (_feBlend527 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend528 || (_feBlend528 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix924 || (_feColorMatrix924 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite528 || (_feComposite528 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix925 || (_feColorMatrix925 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite529 || (_feComposite529 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix926 || (_feColorMatrix926 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood264 || (_feFlood264 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend529 || (_feBlend529 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend530 || (_feBlend530 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix927 || (_feColorMatrix927 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite530 || (_feComposite530 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix928 || (_feColorMatrix928 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix929 || (_feColorMatrix929 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7253",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite531 || (_feComposite531 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix930 || (_feColorMatrix930 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood265 || (_feFlood265 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend531 || (_feBlend531 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend532 || (_feBlend532 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix931 || (_feColorMatrix931 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite532 || (_feComposite532 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix932 || (_feColorMatrix932 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite533 || (_feComposite533 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix933 || (_feColorMatrix933 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood266 || (_feFlood266 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend533 || (_feBlend533 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend534 || (_feBlend534 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix934 || (_feColorMatrix934 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite534 || (_feComposite534 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix935 || (_feColorMatrix935 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix936 || (_feColorMatrix936 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7255",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite535 || (_feComposite535 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix937 || (_feColorMatrix937 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood267 || (_feFlood267 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend535 || (_feBlend535 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend536 || (_feBlend536 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix938 || (_feColorMatrix938 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite536 || (_feComposite536 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix939 || (_feColorMatrix939 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite537 || (_feComposite537 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix940 || (_feColorMatrix940 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood268 || (_feFlood268 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend537 || (_feBlend537 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend538 || (_feBlend538 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix941 || (_feColorMatrix941 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite538 || (_feComposite538 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix942 || (_feColorMatrix942 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix943 || (_feColorMatrix943 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7257",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite539 || (_feComposite539 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix944 || (_feColorMatrix944 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood269 || (_feFlood269 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend539 || (_feBlend539 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend540 || (_feBlend540 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix945 || (_feColorMatrix945 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite540 || (_feComposite540 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix946 || (_feColorMatrix946 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite541 || (_feComposite541 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix947 || (_feColorMatrix947 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood270 || (_feFlood270 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend541 || (_feBlend541 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend542 || (_feBlend542 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix948 || (_feColorMatrix948 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite542 || (_feComposite542 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix949 || (_feColorMatrix949 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix950 || (_feColorMatrix950 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7259",
    x: -0.016622,
    y: -0.027474,
    width: 1.0826,
    height: 1.1297,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite543 || (_feComposite543 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix951 || (_feColorMatrix951 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood271 || (_feFlood271 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend543 || (_feBlend543 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend544 || (_feBlend544 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix952 || (_feColorMatrix952 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite544 || (_feComposite544 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix953 || (_feColorMatrix953 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite545 || (_feComposite545 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix954 || (_feColorMatrix954 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood272 || (_feFlood272 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend545 || (_feBlend545 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend546 || (_feBlend546 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix955 || (_feColorMatrix955 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite546 || (_feComposite546 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix956 || (_feColorMatrix956 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix957 || (_feColorMatrix957 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7261",
    x: -0.0097375,
    y: -0.0079126,
    width: 1.0812,
    height: 1.0874,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite547 || (_feComposite547 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix958 || (_feColorMatrix958 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood273 || (_feFlood273 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend547 || (_feBlend547 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend548 || (_feBlend548 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix959 || (_feColorMatrix959 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite548 || (_feComposite548 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix960 || (_feColorMatrix960 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite549 || (_feComposite549 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix961 || (_feColorMatrix961 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood274 || (_feFlood274 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend549 || (_feBlend549 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend550 || (_feBlend550 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix962 || (_feColorMatrix962 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite550 || (_feComposite550 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix963 || (_feColorMatrix963 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix964 || (_feColorMatrix964 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7263",
    x: -0.0001864,
    y: -0.018135,
    width: 1.1279,
    height: 1.1372,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite551 || (_feComposite551 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix965 || (_feColorMatrix965 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood275 || (_feFlood275 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend551 || (_feBlend551 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend552 || (_feBlend552 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix966 || (_feColorMatrix966 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite552 || (_feComposite552 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix967 || (_feColorMatrix967 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite553 || (_feComposite553 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix968 || (_feColorMatrix968 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood276 || (_feFlood276 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend553 || (_feBlend553 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend554 || (_feBlend554 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix969 || (_feColorMatrix969 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite554 || (_feComposite554 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix970 || (_feColorMatrix970 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix971 || (_feColorMatrix971 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7265",
    x: -0.011678,
    y: -0.0087964,
    width: 1.03,
    height: 1.0111,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite555 || (_feComposite555 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix972 || (_feColorMatrix972 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood277 || (_feFlood277 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend555 || (_feBlend555 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend556 || (_feBlend556 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix973 || (_feColorMatrix973 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite556 || (_feComposite556 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix974 || (_feColorMatrix974 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite557 || (_feComposite557 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix975 || (_feColorMatrix975 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood278 || (_feFlood278 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend557 || (_feBlend557 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend558 || (_feBlend558 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix976 || (_feColorMatrix976 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite558 || (_feComposite558 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix977 || (_feColorMatrix977 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix978 || (_feColorMatrix978 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7267",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite559 || (_feComposite559 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix979 || (_feColorMatrix979 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood279 || (_feFlood279 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend559 || (_feBlend559 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend560 || (_feBlend560 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix980 || (_feColorMatrix980 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite560 || (_feComposite560 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix981 || (_feColorMatrix981 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite561 || (_feComposite561 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix982 || (_feColorMatrix982 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood280 || (_feFlood280 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend561 || (_feBlend561 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend562 || (_feBlend562 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix983 || (_feColorMatrix983 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite562 || (_feComposite562 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix984 || (_feColorMatrix984 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix985 || (_feColorMatrix985 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7269",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite563 || (_feComposite563 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix986 || (_feColorMatrix986 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood281 || (_feFlood281 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend563 || (_feBlend563 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend564 || (_feBlend564 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix987 || (_feColorMatrix987 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite564 || (_feComposite564 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix988 || (_feColorMatrix988 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite565 || (_feComposite565 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix989 || (_feColorMatrix989 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood282 || (_feFlood282 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend565 || (_feBlend565 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend566 || (_feBlend566 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix990 || (_feColorMatrix990 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite566 || (_feComposite566 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix991 || (_feColorMatrix991 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix992 || (_feColorMatrix992 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7271",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite567 || (_feComposite567 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix993 || (_feColorMatrix993 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood283 || (_feFlood283 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend567 || (_feBlend567 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend568 || (_feBlend568 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix994 || (_feColorMatrix994 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite568 || (_feComposite568 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix995 || (_feColorMatrix995 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite569 || (_feComposite569 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix996 || (_feColorMatrix996 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood284 || (_feFlood284 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend569 || (_feBlend569 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend570 || (_feBlend570 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix997 || (_feColorMatrix997 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite570 || (_feComposite570 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix998 || (_feColorMatrix998 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix999 || (_feColorMatrix999 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7273",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite571 || (_feComposite571 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix1000 || (_feColorMatrix1000 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood285 || (_feFlood285 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend571 || (_feBlend571 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend572 || (_feBlend572 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix1001 || (_feColorMatrix1001 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite572 || (_feComposite572 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix1002 || (_feColorMatrix1002 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite573 || (_feComposite573 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix1003 || (_feColorMatrix1003 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood286 || (_feFlood286 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend573 || (_feBlend573 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend574 || (_feBlend574 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix1004 || (_feColorMatrix1004 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite574 || (_feComposite574 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix1005 || (_feColorMatrix1005 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix1006 || (_feColorMatrix1006 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7275",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite575 || (_feComposite575 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix1007 || (_feColorMatrix1007 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood287 || (_feFlood287 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend575 || (_feBlend575 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend576 || (_feBlend576 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix1008 || (_feColorMatrix1008 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite576 || (_feComposite576 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix1009 || (_feColorMatrix1009 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite577 || (_feComposite577 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix1010 || (_feColorMatrix1010 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood288 || (_feFlood288 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend577 || (_feBlend577 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend578 || (_feBlend578 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix1011 || (_feColorMatrix1011 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite578 || (_feComposite578 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix1012 || (_feColorMatrix1012 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix1013 || (_feColorMatrix1013 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7277",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite579 || (_feComposite579 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix1014 || (_feColorMatrix1014 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood289 || (_feFlood289 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend579 || (_feBlend579 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend580 || (_feBlend580 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix1015 || (_feColorMatrix1015 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite580 || (_feComposite580 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix1016 || (_feColorMatrix1016 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite581 || (_feComposite581 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix1017 || (_feColorMatrix1017 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood290 || (_feFlood290 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend581 || (_feBlend581 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend582 || (_feBlend582 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix1018 || (_feColorMatrix1018 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite582 || (_feComposite582 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix1019 || (_feColorMatrix1019 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix1020 || (_feColorMatrix1020 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7279",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite583 || (_feComposite583 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix1021 || (_feColorMatrix1021 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood291 || (_feFlood291 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend583 || (_feBlend583 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend584 || (_feBlend584 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix1022 || (_feColorMatrix1022 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite584 || (_feComposite584 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix1023 || (_feColorMatrix1023 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite585 || (_feComposite585 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix1024 || (_feColorMatrix1024 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood292 || (_feFlood292 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend585 || (_feBlend585 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend586 || (_feBlend586 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix1025 || (_feColorMatrix1025 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite586 || (_feComposite586 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix1026 || (_feColorMatrix1026 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix1027 || (_feColorMatrix1027 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7281",
    x: -0.042782,
    y: -0.052253,
    width: 1.0727,
    height: 1.183,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite587 || (_feComposite587 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix1028 || (_feColorMatrix1028 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood293 || (_feFlood293 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend587 || (_feBlend587 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend588 || (_feBlend588 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix1029 || (_feColorMatrix1029 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite588 || (_feComposite588 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix1030 || (_feColorMatrix1030 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite589 || (_feComposite589 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix1031 || (_feColorMatrix1031 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood294 || (_feFlood294 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend589 || (_feBlend589 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend590 || (_feBlend590 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix1032 || (_feColorMatrix1032 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite590 || (_feComposite590 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix1033 || (_feColorMatrix1033 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix1034 || (_feColorMatrix1034 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7283",
    x: -0.056881,
    y: -0.0079552,
    width: 1.0665,
    height: 1.0989,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite591 || (_feComposite591 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix1035 || (_feColorMatrix1035 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood295 || (_feFlood295 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend591 || (_feBlend591 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend592 || (_feBlend592 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix1036 || (_feColorMatrix1036 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite592 || (_feComposite592 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix1037 || (_feColorMatrix1037 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite593 || (_feComposite593 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix1038 || (_feColorMatrix1038 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood296 || (_feFlood296 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend593 || (_feBlend593 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend594 || (_feBlend594 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix1039 || (_feColorMatrix1039 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite594 || (_feComposite594 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix1040 || (_feColorMatrix1040 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix1041 || (_feColorMatrix1041 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7285",
    x: -0.080181,
    y: -0.0037421,
    width: 1.103,
    height: 1.1349,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite595 || (_feComposite595 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix1042 || (_feColorMatrix1042 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood297 || (_feFlood297 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend595 || (_feBlend595 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend596 || (_feBlend596 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix1043 || (_feColorMatrix1043 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite596 || (_feComposite596 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix1044 || (_feColorMatrix1044 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite597 || (_feComposite597 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix1045 || (_feColorMatrix1045 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood298 || (_feFlood298 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend597 || (_feBlend597 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend598 || (_feBlend598 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix1046 || (_feColorMatrix1046 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite598 || (_feComposite598 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix1047 || (_feColorMatrix1047 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix1048 || (_feColorMatrix1048 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7287",
    x: -0.040278,
    y: -0.0055249,
    width: 1.0736,
    height: 1.0065,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite599 || (_feComposite599 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix1049 || (_feColorMatrix1049 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood299 || (_feFlood299 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend599 || (_feBlend599 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend600 || (_feBlend600 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix1050 || (_feColorMatrix1050 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite600 || (_feComposite600 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix1051 || (_feColorMatrix1051 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite601 || (_feComposite601 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix1052 || (_feColorMatrix1052 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood300 || (_feFlood300 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend601 || (_feBlend601 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend602 || (_feBlend602 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix1053 || (_feColorMatrix1053 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite602 || (_feComposite602 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix1054 || (_feColorMatrix1054 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix1055 || (_feColorMatrix1055 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7289",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite603 || (_feComposite603 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix1056 || (_feColorMatrix1056 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood301 || (_feFlood301 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend603 || (_feBlend603 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend604 || (_feBlend604 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix1057 || (_feColorMatrix1057 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite604 || (_feComposite604 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix1058 || (_feColorMatrix1058 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite605 || (_feComposite605 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix1059 || (_feColorMatrix1059 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood302 || (_feFlood302 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend605 || (_feBlend605 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend606 || (_feBlend606 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix1060 || (_feColorMatrix1060 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite606 || (_feComposite606 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix1061 || (_feColorMatrix1061 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix1062 || (_feColorMatrix1062 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7291",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite607 || (_feComposite607 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix1063 || (_feColorMatrix1063 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood303 || (_feFlood303 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend607 || (_feBlend607 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend608 || (_feBlend608 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix1064 || (_feColorMatrix1064 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite608 || (_feComposite608 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix1065 || (_feColorMatrix1065 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite609 || (_feComposite609 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix1066 || (_feColorMatrix1066 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood304 || (_feFlood304 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend609 || (_feBlend609 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend610 || (_feBlend610 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix1067 || (_feColorMatrix1067 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite610 || (_feComposite610 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix1068 || (_feColorMatrix1068 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix1069 || (_feColorMatrix1069 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7293",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite611 || (_feComposite611 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix1070 || (_feColorMatrix1070 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood305 || (_feFlood305 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend611 || (_feBlend611 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend612 || (_feBlend612 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix1071 || (_feColorMatrix1071 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite612 || (_feComposite612 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix1072 || (_feColorMatrix1072 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite613 || (_feComposite613 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix1073 || (_feColorMatrix1073 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood306 || (_feFlood306 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend613 || (_feBlend613 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend614 || (_feBlend614 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix1074 || (_feColorMatrix1074 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite614 || (_feComposite614 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix1075 || (_feColorMatrix1075 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix1076 || (_feColorMatrix1076 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7295",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite615 || (_feComposite615 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix1077 || (_feColorMatrix1077 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood307 || (_feFlood307 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend615 || (_feBlend615 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend616 || (_feBlend616 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix1078 || (_feColorMatrix1078 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite616 || (_feComposite616 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix1079 || (_feColorMatrix1079 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite617 || (_feComposite617 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix1080 || (_feColorMatrix1080 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood308 || (_feFlood308 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend617 || (_feBlend617 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend618 || (_feBlend618 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix1081 || (_feColorMatrix1081 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite618 || (_feComposite618 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix1082 || (_feColorMatrix1082 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix1083 || (_feColorMatrix1083 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7297",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite619 || (_feComposite619 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix1084 || (_feColorMatrix1084 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood309 || (_feFlood309 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend619 || (_feBlend619 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend620 || (_feBlend620 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix1085 || (_feColorMatrix1085 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite620 || (_feComposite620 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix1086 || (_feColorMatrix1086 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite621 || (_feComposite621 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix1087 || (_feColorMatrix1087 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood310 || (_feFlood310 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend621 || (_feBlend621 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend622 || (_feBlend622 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix1088 || (_feColorMatrix1088 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite622 || (_feComposite622 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix1089 || (_feColorMatrix1089 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix1090 || (_feColorMatrix1090 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7299",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite623 || (_feComposite623 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix1091 || (_feColorMatrix1091 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood311 || (_feFlood311 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend623 || (_feBlend623 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend624 || (_feBlend624 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix1092 || (_feColorMatrix1092 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite624 || (_feComposite624 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix1093 || (_feColorMatrix1093 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite625 || (_feComposite625 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix1094 || (_feColorMatrix1094 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood312 || (_feFlood312 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend625 || (_feBlend625 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend626 || (_feBlend626 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix1095 || (_feColorMatrix1095 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite626 || (_feComposite626 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix1096 || (_feColorMatrix1096 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix1097 || (_feColorMatrix1097 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7301",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite627 || (_feComposite627 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix1098 || (_feColorMatrix1098 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood313 || (_feFlood313 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend627 || (_feBlend627 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend628 || (_feBlend628 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix1099 || (_feColorMatrix1099 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite628 || (_feComposite628 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix1100 || (_feColorMatrix1100 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite629 || (_feComposite629 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix1101 || (_feColorMatrix1101 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood314 || (_feFlood314 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend629 || (_feBlend629 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend630 || (_feBlend630 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix1102 || (_feColorMatrix1102 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite630 || (_feComposite630 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix1103 || (_feColorMatrix1103 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix1104 || (_feColorMatrix1104 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7303",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite631 || (_feComposite631 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix1105 || (_feColorMatrix1105 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood315 || (_feFlood315 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend631 || (_feBlend631 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend632 || (_feBlend632 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix1106 || (_feColorMatrix1106 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite632 || (_feComposite632 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix1107 || (_feColorMatrix1107 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite633 || (_feComposite633 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix1108 || (_feColorMatrix1108 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood316 || (_feFlood316 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend633 || (_feBlend633 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend634 || (_feBlend634 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix1109 || (_feColorMatrix1109 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite634 || (_feComposite634 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix1110 || (_feColorMatrix1110 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix1111 || (_feColorMatrix1111 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7305",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite635 || (_feComposite635 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix1112 || (_feColorMatrix1112 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood317 || (_feFlood317 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend635 || (_feBlend635 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend636 || (_feBlend636 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix1113 || (_feColorMatrix1113 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite636 || (_feComposite636 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix1114 || (_feColorMatrix1114 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite637 || (_feComposite637 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix1115 || (_feColorMatrix1115 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood318 || (_feFlood318 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend637 || (_feBlend637 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend638 || (_feBlend638 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix1116 || (_feColorMatrix1116 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite638 || (_feComposite638 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix1117 || (_feColorMatrix1117 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix1118 || (_feColorMatrix1118 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7307",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite639 || (_feComposite639 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix1119 || (_feColorMatrix1119 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood319 || (_feFlood319 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend639 || (_feBlend639 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend640 || (_feBlend640 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix1120 || (_feColorMatrix1120 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite640 || (_feComposite640 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix1121 || (_feColorMatrix1121 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite641 || (_feComposite641 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix1122 || (_feColorMatrix1122 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood320 || (_feFlood320 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend641 || (_feBlend641 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend642 || (_feBlend642 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix1123 || (_feColorMatrix1123 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite642 || (_feComposite642 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix1124 || (_feColorMatrix1124 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix1125 || (_feColorMatrix1125 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7309",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite643 || (_feComposite643 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix1126 || (_feColorMatrix1126 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood321 || (_feFlood321 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend643 || (_feBlend643 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend644 || (_feBlend644 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix1127 || (_feColorMatrix1127 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite644 || (_feComposite644 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix1128 || (_feColorMatrix1128 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite645 || (_feComposite645 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix1129 || (_feColorMatrix1129 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood322 || (_feFlood322 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend645 || (_feBlend645 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend646 || (_feBlend646 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix1130 || (_feColorMatrix1130 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite646 || (_feComposite646 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix1131 || (_feColorMatrix1131 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix1132 || (_feColorMatrix1132 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7311",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite647 || (_feComposite647 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix1133 || (_feColorMatrix1133 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood323 || (_feFlood323 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend647 || (_feBlend647 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend648 || (_feBlend648 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix1134 || (_feColorMatrix1134 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite648 || (_feComposite648 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix1135 || (_feColorMatrix1135 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite649 || (_feComposite649 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix1136 || (_feColorMatrix1136 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood324 || (_feFlood324 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend649 || (_feBlend649 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend650 || (_feBlend650 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix1137 || (_feColorMatrix1137 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite650 || (_feComposite650 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix1138 || (_feColorMatrix1138 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix1139 || (_feColorMatrix1139 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7313",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite651 || (_feComposite651 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix1140 || (_feColorMatrix1140 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood325 || (_feFlood325 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend651 || (_feBlend651 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend652 || (_feBlend652 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix1141 || (_feColorMatrix1141 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite652 || (_feComposite652 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix1142 || (_feColorMatrix1142 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite653 || (_feComposite653 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix1143 || (_feColorMatrix1143 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood326 || (_feFlood326 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend653 || (_feBlend653 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend654 || (_feBlend654 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix1144 || (_feColorMatrix1144 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite654 || (_feComposite654 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix1145 || (_feColorMatrix1145 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix1146 || (_feColorMatrix1146 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7315",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite655 || (_feComposite655 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix1147 || (_feColorMatrix1147 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood327 || (_feFlood327 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend655 || (_feBlend655 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend656 || (_feBlend656 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix1148 || (_feColorMatrix1148 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite656 || (_feComposite656 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix1149 || (_feColorMatrix1149 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite657 || (_feComposite657 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix1150 || (_feColorMatrix1150 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood328 || (_feFlood328 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend657 || (_feBlend657 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend658 || (_feBlend658 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix1151 || (_feColorMatrix1151 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite658 || (_feComposite658 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix1152 || (_feColorMatrix1152 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix1153 || (_feColorMatrix1153 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7317",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite659 || (_feComposite659 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix1154 || (_feColorMatrix1154 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood329 || (_feFlood329 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend659 || (_feBlend659 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend660 || (_feBlend660 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix1155 || (_feColorMatrix1155 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite660 || (_feComposite660 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix1156 || (_feColorMatrix1156 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite661 || (_feComposite661 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix1157 || (_feColorMatrix1157 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood330 || (_feFlood330 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend661 || (_feBlend661 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend662 || (_feBlend662 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix1158 || (_feColorMatrix1158 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite662 || (_feComposite662 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix1159 || (_feColorMatrix1159 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix1160 || (_feColorMatrix1160 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7319",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite663 || (_feComposite663 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix1161 || (_feColorMatrix1161 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood331 || (_feFlood331 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend663 || (_feBlend663 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend664 || (_feBlend664 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix1162 || (_feColorMatrix1162 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite664 || (_feComposite664 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix1163 || (_feColorMatrix1163 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite665 || (_feComposite665 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix1164 || (_feColorMatrix1164 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood332 || (_feFlood332 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend665 || (_feBlend665 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend666 || (_feBlend666 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix1165 || (_feColorMatrix1165 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite666 || (_feComposite666 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix1166 || (_feColorMatrix1166 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix1167 || (_feColorMatrix1167 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7321",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite667 || (_feComposite667 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix1168 || (_feColorMatrix1168 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood333 || (_feFlood333 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend667 || (_feBlend667 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend668 || (_feBlend668 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix1169 || (_feColorMatrix1169 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite668 || (_feComposite668 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix1170 || (_feColorMatrix1170 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite669 || (_feComposite669 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix1171 || (_feColorMatrix1171 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood334 || (_feFlood334 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend669 || (_feBlend669 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend670 || (_feBlend670 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix1172 || (_feColorMatrix1172 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite670 || (_feComposite670 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix1173 || (_feColorMatrix1173 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix1174 || (_feColorMatrix1174 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7323",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite671 || (_feComposite671 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix1175 || (_feColorMatrix1175 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood335 || (_feFlood335 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend671 || (_feBlend671 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend672 || (_feBlend672 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix1176 || (_feColorMatrix1176 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite672 || (_feComposite672 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix1177 || (_feColorMatrix1177 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite673 || (_feComposite673 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix1178 || (_feColorMatrix1178 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood336 || (_feFlood336 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend673 || (_feBlend673 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend674 || (_feBlend674 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix1179 || (_feColorMatrix1179 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite674 || (_feComposite674 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix1180 || (_feColorMatrix1180 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix1181 || (_feColorMatrix1181 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7325",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite675 || (_feComposite675 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix1182 || (_feColorMatrix1182 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood337 || (_feFlood337 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend675 || (_feBlend675 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend676 || (_feBlend676 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix1183 || (_feColorMatrix1183 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite676 || (_feComposite676 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix1184 || (_feColorMatrix1184 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite677 || (_feComposite677 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix1185 || (_feColorMatrix1185 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood338 || (_feFlood338 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend677 || (_feBlend677 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend678 || (_feBlend678 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix1186 || (_feColorMatrix1186 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite678 || (_feComposite678 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix1187 || (_feColorMatrix1187 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix1188 || (_feColorMatrix1188 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7327",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite679 || (_feComposite679 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix1189 || (_feColorMatrix1189 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood339 || (_feFlood339 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend679 || (_feBlend679 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend680 || (_feBlend680 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix1190 || (_feColorMatrix1190 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite680 || (_feComposite680 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix1191 || (_feColorMatrix1191 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite681 || (_feComposite681 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix1192 || (_feColorMatrix1192 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood340 || (_feFlood340 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend681 || (_feBlend681 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend682 || (_feBlend682 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix1193 || (_feColorMatrix1193 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite682 || (_feComposite682 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix1194 || (_feColorMatrix1194 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix1195 || (_feColorMatrix1195 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7329",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite683 || (_feComposite683 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix1196 || (_feColorMatrix1196 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood341 || (_feFlood341 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend683 || (_feBlend683 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend684 || (_feBlend684 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix1197 || (_feColorMatrix1197 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite684 || (_feComposite684 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix1198 || (_feColorMatrix1198 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite685 || (_feComposite685 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix1199 || (_feColorMatrix1199 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood342 || (_feFlood342 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend685 || (_feBlend685 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend686 || (_feBlend686 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix1200 || (_feColorMatrix1200 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite686 || (_feComposite686 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix1201 || (_feColorMatrix1201 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix1202 || (_feColorMatrix1202 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7331",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite687 || (_feComposite687 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix1203 || (_feColorMatrix1203 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood343 || (_feFlood343 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend687 || (_feBlend687 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend688 || (_feBlend688 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix1204 || (_feColorMatrix1204 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite688 || (_feComposite688 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix1205 || (_feColorMatrix1205 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite689 || (_feComposite689 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix1206 || (_feColorMatrix1206 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood344 || (_feFlood344 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend689 || (_feBlend689 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend690 || (_feBlend690 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix1207 || (_feColorMatrix1207 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite690 || (_feComposite690 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix1208 || (_feColorMatrix1208 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix1209 || (_feColorMatrix1209 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7333",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite691 || (_feComposite691 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix1210 || (_feColorMatrix1210 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood345 || (_feFlood345 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend691 || (_feBlend691 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend692 || (_feBlend692 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix1211 || (_feColorMatrix1211 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite692 || (_feComposite692 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix1212 || (_feColorMatrix1212 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite693 || (_feComposite693 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix1213 || (_feColorMatrix1213 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood346 || (_feFlood346 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend693 || (_feBlend693 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend694 || (_feBlend694 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix1214 || (_feColorMatrix1214 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite694 || (_feComposite694 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix1215 || (_feColorMatrix1215 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix1216 || (_feColorMatrix1216 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7335",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite695 || (_feComposite695 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix1217 || (_feColorMatrix1217 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood347 || (_feFlood347 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(255,56,56)",
    result: "flood1"
  })), _feBlend695 || (_feBlend695 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend696 || (_feBlend696 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix1218 || (_feColorMatrix1218 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite696 || (_feComposite696 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix1219 || (_feColorMatrix1219 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite697 || (_feComposite697 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix1220 || (_feColorMatrix1220 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood348 || (_feFlood348 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(201,201,201)",
    result: "flood1"
  })), _feBlend697 || (_feBlend697 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend698 || (_feBlend698 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix1221 || (_feColorMatrix1221 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite698 || (_feComposite698 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix1222 || (_feColorMatrix1222 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feColorMatrix1223 || (_feColorMatrix1223 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    values: "1 0 0 -0.0662461 -0 0 1 0 -0.0662461 -0 0 0 1 -0.0662461 -0 0 0 0 1 0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationEon);
export default __webpack_public_path__ + "static/media/illustrationEON.2dedefe39f123dcad73baf8f13bc3947.svg";
export { ForwardRef as ReactComponent };